import React, { useState, useEffect } from "react";

// ── HELPERS ──────────────────────────────────────────────────────
function exKey(dayId, secTitle, idx) {
  return `${dayId}__${secTitle}__${idx}`;
}

function getDayItems(day) {
  const keys = [];
  day.sections.forEach(sec => {
    if (sec.items.length > 0) {
      sec.items.forEach((_, i) => keys.push(exKey(day.id, sec.title, i)));
    }
  });
  return keys;
}

function isDayDone(day, completed) {
  const keys = getDayItems(day);
  return keys.length > 0 && keys.every(k => completed[k]);
}

function isWeekDone(week, completed) {
  return week.days.every(d => isDayDone(d, completed));
}

function isPhaseDone(phase, completed) {
  return phase.weeks.every(w => isWeekDone(w, completed));
}

function dayProgress(day, completed) {
  const keys = getDayItems(day);
  if (keys.length === 0) return { done: 0, total: 0 };
  return { done: keys.filter(k => completed[k]).length, total: keys.length };
}

const PHASES = [
  {
    id:"f1", name:"FASE 1", label:"Adaptación", accent:"#FF9500",
    weeks:[
      {
        id:"w1", name:"Semana 1", label:"Adaptación",
        days:[
          {
            id:"w1d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla — 2×10 seg",
                "Skips de Potencia — 4×20 yardas (2 altura | 2 distancia)",
                "Saltos de Zancada — 4×20 yardas (2 altura | 2 distancia)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 3×10","1.B. Jalones de Banda — 3×15"]},
              {title:"Construcción", items:[
                "1. Press Neutro Mancuernas Inclinado — 3×12","2. Remo con Barra — 3×12",
                "3. Press Militar — 3×12","4.A. Extensión Tríceps Polea — 3×12","4.B. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Plancha — 2×60 seg"]}
            ]
          },
          {
            id:"w1d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración — CAD Lineal", items:[
                "Salidas 2 Puntos — 4×1 (sprint 10 yardas, desacelerar 10 yardas)",
                "Salidas 2 Puntos — 4×1 (5 sprint, 5 trote, 5 sprint)",
                "Para y Avanza 2 Puntos — 4×1 (parar cada 5 yardas en 20 yardas)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio (agarre bajo) — 3×10",
                "1.B. Caminata Monster — 3×10 yardas (adelante y atrás)"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna",
                "2. Curl Isquiotibiales — 3×12","3. Elevación de Talones — 3×12"
              ]},
              {title:"Core", items:["1. Plancha Lateral — 2×30 seg c/lado"]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 25 yardas)"]}
            ]
          },
          {
            id:"w1d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla Lateral — 2×10 yardas c/dirección",
                "Saltos Laterales en Una Pierna — 4×4 saltos ida y vuelta"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 3×10","1.B. Jalones de Cara — 3×12"]},
              {title:"Construcción", items:[
                "1. Press de Banca con Mancuernas — 3×12","2. Dominadas — 3×Máximo",
                "3. Elevaciones Laterales — 3×12","4.A. Curl con Barra — 3×12",
                "4.B. Extensión Tríceps Agarre Inverso — 3×12"
              ]},
              {title:"Core", items:["1. Cobra en Prono — 2×60 seg c/lado"]}
            ]
          },
          {
            id:"w1d4", name:"Día 4", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Velocidad Máxima — CAD Lateral", items:[
                "Tempo 50's — 8×1","Paso Rápido Carioca — 4×20 yardas c/dirección",
                "Carrera Cruzada — 4×20 yardas c/dirección",
                "Desplazamiento Lateral — 4×10 yardas c/dirección"
              ]},
              {title:"Fuerza", items:["1.A. Sentadilla Frontal — 3×10","1.B. Empuje de Cadera — 3×10"]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna","2. RDL — 3×12",
                "3. Elevación de Puntas con Peso — 3×12"
              ]},
              {title:"Core", items:[
                "1. Plancha — 1×60 seg","2. Plancha Lateral — 1×60 seg c/lado",
                "3. Cobra en Prono — 1×60 seg c/lado"
              ]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 50 yardas)"]}
            ]
          }
        ]
      },
      {
        id:"w2", name:"Semana 2", label:"Adaptación",
        days:[
          {
            id:"w2d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla — 2×10 seg",
                "Skips de Potencia — 4×20 yardas (2 altura | 2 distancia)",
                "Saltos de Zancada — 4×20 yardas (2 altura | 2 distancia)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 3×8","1.B. Jalones de Banda — 3×15"]},
              {title:"Construcción", items:[
                "1. Press Neutro Mancuernas Inclinado — 3×12","2. Remo con Barra — 3×12",
                "3. Press Militar — 3×12","4.A. Extensión Tríceps Polea — 3×12","4.B. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Plancha — 2×60 seg"]}
            ]
          },
          {
            id:"w2d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración — CAD Lineal", items:[
                "Salidas 2 Puntos — 4×1 (sprint 10 yardas, desacelerar 10 yardas)",
                "Salidas 2 Puntos — 4×1 (5 sprint, 5 trote, 5 sprint)",
                "Para y Avanza 2 Puntos — 4×1 (parar cada 5 yardas en 20 yardas)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio (agarre bajo) — 3×8",
                "1.B. Caminata Monster — 3×10 yardas (adelante y atrás)"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna",
                "2. Curl Isquiotibiales — 3×12","3. Elevación de Talones — 3×12"
              ]},
              {title:"Core", items:["1. Plancha Lateral — 2×30 seg c/lado"]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 25 yardas)"]}
            ]
          },
          {
            id:"w2d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla Lateral — 2×10 yardas c/dirección",
                "Saltos Laterales en Una Pierna — 4×4 saltos ida y vuelta"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 3×8","1.B. Jalones de Cara — 3×12"]},
              {title:"Construcción", items:[
                "1. Press de Banca con Mancuernas — 3×12","2. Dominadas — 3×Máximo",
                "3. Elevaciones Laterales — 3×12","4.A. Curl con Barra — 3×12",
                "4.B. Extensión Tríceps Agarre Inverso — 3×12"
              ]},
              {title:"Core", items:["1. Cobra en Prono — 2×60 seg c/lado"]}
            ]
          },
          {
            id:"w2d4", name:"Día 4", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Velocidad Máxima — CAD Lateral", items:[
                "Tempo 50's — 8×1","Paso Rápido Carioca — 4×20 yardas c/dirección",
                "Carrera Cruzada — 4×20 yardas c/dirección",
                "Desplazamiento Lateral — 4×10 yardas c/dirección"
              ]},
              {title:"Fuerza", items:["1.A. Sentadilla Frontal — 3×8","1.B. Empuje de Cadera — 3×10"]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna","2. RDL — 3×12",
                "3. Elevación de Puntas con Peso — 3×12"
              ]},
              {title:"Core", items:[
                "1. Plancha — 1×60 seg","2. Plancha Lateral — 1×60 seg c/lado",
                "3. Cobra en Prono — 1×60 seg c/lado"
              ]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 50 yardas)"]}
            ]
          }
        ]
      }
    ]
  },

  // ══════════════════════════════════════════
  // FASE 1.2 — ACUMULACIÓN
  // ══════════════════════════════════════════
  {
    id:"f12", name:"FASE 2", label:"Acumulación", accent:"#00C9FF",
    weeks:[
      {
        id:"w3", name:"Semana 3", label:"Acumulación",
        days:[
          {
            id:"w3d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Pogos Lineales/Laterales en Una Pierna — 1×10 yardas c/pierna",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja en Una Pierna (aterrizar en 2) — 8×1 c/pierna",
                "Saltos de Patinador — 4×4 c/dirección",
                "Escalones de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Excéntrico con Banda — 5×4 [5|1|X] [BANDAS NEGRAS]",
                "1.B. Jalón de Cara con Rot. Externa con Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×12",
                "1.B. Remo Mancuernas en Banco Inclinado — 3×12",
                "2.A. Elevación Frontal con Disco — 3×12",
                "2.B. Jalones de Cara en Polea — 3×12",
                "3. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"w3d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg",
                "Salidas de Pared — 4×5 seg",
                "Sprint Lateral de Pared — 4×4 c/lado",
                "Salidas 2 Puntos — 6×10 yardas",
                "Serie de Desaceleración — 2×20 yardas c/u (Multi-Step, 2-Step, 1-Step)",
                "Ejercicio Corte en Y | Ejercicio Corte con Salto — 2×1 c/dirección",
                "Carrera en Cuarto de Arco — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Excéntrica con Banda — 5×4 [5|1|X] [BANDAS NEGRAS]",
                "1.B. Sentadillas con Círculo de Cadera — 5×8 [BANDA CÍRCULO]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×12 c/pierna",
                "2. RDL en Una Pierna — 3×12 c/pierna",
                "3. Curl Nórdico Isquiotibiales (Tempo) — 3×12",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico Estabilidad Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"w3d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos de Línea | Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla | Saltos de Zancada Alternos — 2×10 seg c/u",
                "Saltos de Patinador — 4×4 c/lado",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/lado",
                "Salto a Caja — 8×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×4",
                "1.B. Blackburns en Prono — 5×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×12",
                "1.B. Press de Banca con Mancuernas — 3×12",
                "2.A. Elevación Deltoides Posterior — 3×12",
                "2.B. Elevaciones Laterales — 3×12",
                "3. Rompecráneos — 3×12"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"w3d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras en Tempo — 4×30 yardas",
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×4",
                "1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×12 c/pierna",
                "2. Buenos Días — 3×12",
                "3. Empuje de Cadera en Una Pierna — 3×12 c/pierna"
              ]},
              {title:"Core", items:["1. Pájaro-Perro en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w4", name:"Semana 4", label:"Acumulación",
        days:[
          {
            id:"w4d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Pogos Lineales/Laterales en Una Pierna — 1×10 yardas c/pierna",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja en Una Pierna (aterrizar en 2) — 8×1 c/pierna",
                "Saltos de Patinador — 4×4 c/dirección",
                "Escalones de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Excéntrico con Banda — 5×3 [4|1|X] [BANDAS NEGRAS]",
                "1.B. Jalón de Cara con Rot. Externa con Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×10",
                "1.B. Remo Mancuernas en Banco Inclinado — 3×10",
                "2.A. Elevación Frontal con Disco — 3×10",
                "2.B. Jalones de Cara en Polea — 3×10",
                "3. Curl Martillo — 3×10"
              ]},
              {title:"Core", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"w4d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg",
                "Salidas de Pared — 4×5 seg","Sprint Lateral de Pared — 4×4 c/lado",
                "Salidas 2 Puntos — 6×10 yardas",
                "Serie de Desaceleración — 2×20 yardas c/u (Multi-Step, 2-Step, 1-Step)",
                "Ejercicio Corte en Y | Corte con Salto — 2×1 c/dirección",
                "Carrera en Cuarto de Arco — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Excéntrica con Banda — 5×3 [4|1|X] [BANDAS NEGRAS]",
                "1.B. Sentadillas con Círculo de Cadera — 5×8 [BANDA CÍRCULO]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×10 c/pierna",
                "2. RDL en Una Pierna — 3×10 c/pierna",
                "3. Curl Nórdico Isquiotibiales (Tempo) — 3×10",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico Estabilidad Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"w4d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos de Línea | Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla | Saltos de Zancada Alternos — 2×10 seg c/u",
                "Saltos de Patinador — 4×4 c/lado",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/lado","Salto a Caja — 8×1"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 5×3","1.B. Blackburns en Prono — 5×10"]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×10","1.B. Press de Banca con Mancuernas — 3×10",
                "2.A. Elevación Deltoides Posterior — 3×10","2.B. Elevaciones Laterales — 3×10",
                "3. Rompecráneos — 3×10"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"w4d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras en Tempo — 4×30 yardas",
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×3",
                "1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×10 c/pierna","2. Buenos Días — 3×10",
                "3. Empuje de Cadera en Una Pierna — 3×10 c/pierna"
              ]},
              {title:"Core", items:["1. Pájaro-Perro en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w5", name:"Semana 5", label:"Acumulación",
        days:[
          {
            id:"w5d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Pogos Lineales/Laterales en Una Pierna — 1×10 yardas c/pierna",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja en Una Pierna (aterrizar en 2) — 8×1 c/pierna",
                "Saltos de Patinador — 4×4 c/dirección","Escalones de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Excéntrico con Banda — 5×2 [3|1|X] [BANDAS NEGRAS]",
                "1.B. Jalón de Cara con Rot. Externa con Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×8",
                "1.B. Remo Mancuernas en Banco Inclinado — 3×8",
                "2.A. Elevación Frontal con Disco — 3×8","2.B. Jalones de Cara en Polea — 3×8",
                "3. Curl Martillo — 3×8"
              ]},
              {title:"Core", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"w5d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg","Salidas de Pared — 4×5 seg",
                "Sprint Lateral de Pared — 4×4 c/lado","Salidas 2 Puntos — 6×10 yardas",
                "Serie de Desaceleración — 2×20 yardas c/u (Multi-Step, 2-Step, 1-Step)",
                "Ejercicio Corte en Y | Corte con Salto — 2×1 c/dirección",
                "Carrera en Cuarto de Arco — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Excéntrica con Banda — 5×2 [3|1|X] [BANDAS NEGRAS]",
                "1.B. Sentadillas con Círculo de Cadera — 5×8 [BANDA CÍRCULO]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×8 c/pierna",
                "2. RDL en Una Pierna — 3×8 c/pierna",
                "3. Curl Nórdico Isquiotibiales (Tempo) — 3×8",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico Estabilidad Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"w5d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo — 2×10 seg","Saltos de Línea | Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla | Saltos de Zancada Alternos — 2×10 seg c/u",
                "Saltos de Patinador — 4×4 c/lado",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/lado","Salto a Caja — 8×1"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 5×2","1.B. Blackburns en Prono — 5×10"]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×8","1.B. Press de Banca con Mancuernas — 3×8",
                "2.A. Elevación Deltoides Posterior — 3×8","2.B. Elevaciones Laterales — 3×8",
                "3. Rompecráneos — 3×8"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"w5d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras en Tempo — 4×30 yardas",
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×2",
                "1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×8 c/pierna","2. Buenos Días — 3×8",
                "3. Empuje de Cadera en Una Pierna — 3×8 c/pierna"
              ]},
              {title:"Core", items:["1. Pájaro-Perro en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w6", name:"Semana 6", label:"Descarga",
        days:[
          {
            id:"w6d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Pogos Lineales/Laterales en Una Pierna — 1×10 yardas c/pierna",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna — 2×4 c/pierna",
                "Salto a Caja en Una Pierna — 8×1 c/pierna","Saltos de Patinador — 4×4 c/dirección",
                "Escalones de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×5 @50%",
                "1.B. Jalón de Cara con Rot. Externa con Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×8",
                "1.B. Remo Mancuernas en Banco Inclinado — 3×8",
                "2.A. Elevación Frontal con Disco — 3×8","2.B. Jalones de Cara en Polea — 3×8",
                "3. Curl Martillo — 3×8"
              ]},
              {title:"Core", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"w6d2", name:"Día 2", label:"Aceleración · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg","Salidas de Pared — 4×5 seg",
                "Sprint Lateral de Pared — 4×4 c/lado","Salidas 2 Puntos — 6×10 yardas",
                "Serie de Desaceleración — 2×20 yardas c/u","Ejercicio Corte en Y | Corte con Salto — 2×1 c/dirección",
                "Carrera en Cuarto de Arco — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera — 5×5 @50%",
                "1.B. Sentadillas con Círculo de Cadera — 5×8 [BANDA CÍRCULO]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×8 c/pierna",
                "2. RDL en Una Pierna — 3×8 c/pierna","3. Curl Nórdico Isquiotibiales (Tempo) — 3×8",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico Estabilidad Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"w6d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo — 2×10 seg","Saltos de Línea | Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla | Saltos de Zancada Alternos — 2×10 seg c/u",
                "Saltos de Patinador — 4×4 c/lado",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/lado","Salto a Caja — 8×1"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 5×5 @50%","1.B. Blackburns en Prono — 5×10"]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×8","1.B. Press de Banca con Mancuernas — 3×8",
                "2.A. Elevación Deltoides Posterior — 3×8","2.B. Elevaciones Laterales — 3×8",
                "3. Rompecráneos — 3×8"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"w6d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras en Tempo — 4×30 yardas",
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×5 @50%",
                "1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×8 c/pierna","2. Buenos Días — 3×8",
                "3. Empuje de Cadera en Una Pierna — 3×8 c/pierna"
              ]},
              {title:"Core", items:["1. Pájaro-Perro en Plancha — 3×20"]}
            ]
          }
        ]
      }
    ]
  },

  // ══════════════════════════════════════════
  // FASE 2 — TRANSMUTACIÓN
  // ══════════════════════════════════════════
  {
    id:"f2", name:"FASE 3", label:"Transmutación", accent:"#00C9FF",
    weeks:[
      {
        id:"w7", name:"Semana 7", label:"Transmutación",
        days:[
          {
            id:"w7d1", name:"Día 1", label:"Pliometría · CAD · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos de Línea | Saltos de Línea Laterales — 2×10 seg c/u",
                "Saltos de Línea en Una Pierna | Saltos Laterales en Una Pierna — 2×5 seg c/u",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Amplio a 90° en Una Pierna (pierna exterior) — 4×1 c/pierna",
                "Salto a Caja en Una Pierna (aterrizar en 2) — 4×1 c/pierna",
                "Salto a Caja en Semi-Arrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico con Banda — 5×4 [1|5|X] [BANDAS NEGRAS]",
                "1.B. Jalones de Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×12",
                "1.B. Remo con Mancuernas Inclinado — 3×12",
                "2.A. Press Militar en Semi-Arrodillado — 3×12 c/brazo",
                "2.B. Espantapájaros con Banda — 3×12 [BANDA ROJA]",
                "3. Curl con Barra — 3×12"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"w7d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg",
                "Salidas desde el Suelo | Salidas Laterales desde el Suelo — 2×10 yardas c/u",
                "Salidas en Semi-Arrodillado | Salidas Laterales Semi-Arrodillado — 2×10 yardas c/u",
                "Ejercicio Corte en Y con Reacción — 4×1",
                "Ejercicio Corte con Salto y Reacción — 4×1",
                "Carrera en Medio Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica con Banda — 5×4 [1|5|X] [BANDAS NEGRAS]",
                "1.B. Puente Glúteo en Una Pierna (pierna opuesta doblada) — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×12 c/pierna",
                "2. Balanceo de Kettlebell — 3×12",
                "3. Curl Isquiotibiales en Una Pierna con Banda — 3×12 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"w7d3", name:"Día 3", label:"Pliometría · Potencia · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo con Peso — 2×10 seg (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos de Zancada Alternos — 2×10 seg (5 lbs o menos)",
                "Salto a Caja Sentado | Salto a Caja con Aproximación — 8×1 c/u",
                "Saltos Laterales a Caja — 4×1 c/lado",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/lado",
                "Saltos de Patinador con Reacción — 4×4 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press en Suelo — 5×4","1.B. ITY's en Inclinado — 5×3 c/dirección"
              ]},
              {title:"Construcción", items:[
                "1.A. Jalón al Pecho Agarre Cerrado — 3×12","1.B. Press Z con Mancuernas — 3×12",
                "2. Vaciar los Cubos — 3×12","3. Extensión Tríceps en Polea — 3×12"
              ]},
              {title:"Core", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"w7d4", name:"Día 4", label:"Velocidad Máxima · CAD Lateral · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Skips de Potencia — 4×10 yardas (2 altura | 2 distancia)",
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×20 yardas",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección",
                "Pro Shuttle | Ejercicio en L — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×4",
                "1.B. Descensos Isométricos — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×12 c/pierna",
                "2. Buenos Días con Banda — 3×12 [BANDA VERDE]",
                "3. Empuje de Cadera con Barra — 3×12"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w8", name:"Semana 8", label:"Transmutación",
        days:[
          {
            id:"w8d1", name:"Día 1", label:"Pliometría · CAD · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos de Línea | Saltos de Línea Laterales — 2×10 seg c/u",
                "Saltos de Línea en Una Pierna | Saltos Laterales en Una Pierna — 2×5 seg c/u",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Amplio a 90° en Una Pierna — 4×1 c/pierna",
                "Salto a Caja en Una Pierna (aterrizar en 2) — 4×1 c/pierna",
                "Salto a Caja en Semi-Arrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico con Banda — 5×3 [X|4|X] [BANDAS NEGRAS]",
                "1.B. Jalones de Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×10","1.B. Remo con Mancuernas Inclinado — 3×10",
                "2.A. Press Militar en Semi-Arrodillado — 3×10 c/brazo",
                "2.B. Espantapájaros con Banda — 3×10 [BANDA ROJA]","3. Curl con Barra — 3×10"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"w8d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg",
                "Salidas desde el Suelo | Salidas Laterales desde el Suelo — 2×10 yardas c/u",
                "Salidas en Semi-Arrodillado | Salidas Laterales Semi-Arrodillado — 2×10 yardas c/u",
                "Ejercicio Corte en Y con Reacción — 4×1","Ejercicio Corte con Salto y Reacción — 4×1",
                "Carrera en Medio Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica con Banda — 5×3 [X|4|X] [BANDAS NEGRAS]",
                "1.B. Puente Glúteo en Una Pierna (pierna opuesta doblada) — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×10 c/pierna",
                "2. Balanceo de Kettlebell — 3×10",
                "3. Curl Isquiotibiales en Una Pierna con Banda — 3×10 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"w8d3", name:"Día 3", label:"Pliometría · Potencia · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo con Peso — 2×10 seg (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos de Zancada Alternos — 2×10 seg (5 lbs o menos)",
                "Salto a Caja Sentado | Salto a Caja con Aproximación — 8×1 c/u",
                "Saltos Laterales a Caja — 4×1 c/lado",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/lado",
                "Saltos de Patinador con Reacción — 4×4 c/lado"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 5×3","1.B. ITY's en Inclinado — 5×3 c/dirección"]},
              {title:"Construcción", items:[
                "1.A. Jalón al Pecho Agarre Cerrado — 3×10","1.B. Press Z con Mancuernas — 3×10",
                "2. Vaciar los Cubos — 3×10","3. Extensión Tríceps en Polea — 3×10"
              ]},
              {title:"Core", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"w8d4", name:"Día 4", label:"Velocidad Máxima · CAD Lateral · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Skips de Potencia — 4×10 yardas (2 altura | 2 distancia)",
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×20 yardas",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección",
                "Pro Shuttle | Ejercicio en L — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×3","1.B. Descensos Isométricos — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna",
                "2. Buenos Días con Banda — 3×10 [BANDA VERDE]","3. Empuje de Cadera con Barra — 3×10"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w9", name:"Semana 9", label:"Transmutación",
        days:[
          {
            id:"w9d1", name:"Día 1", label:"Pliometría · CAD · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos de Línea | Saltos de Línea Laterales — 2×10 seg c/u",
                "Saltos de Línea en Una Pierna | Saltos Laterales en Una Pierna — 2×5 seg c/u",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Amplio a 90° en Una Pierna — 4×1 c/pierna",
                "Salto a Caja en Una Pierna — 4×1 c/pierna","Salto a Caja en Semi-Arrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico con Banda — 5×2 [X|3|X] [BANDAS NEGRAS]",
                "1.B. Jalones de Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×8","1.B. Remo con Mancuernas Inclinado — 3×8",
                "2.A. Press Militar en Semi-Arrodillado — 3×8 c/brazo",
                "2.B. Espantapájaros con Banda — 3×8 [BANDA ROJA]","3. Curl con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"w9d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg",
                "Salidas desde el Suelo | Salidas Laterales desde el Suelo — 2×10 yardas c/u",
                "Salidas en Semi-Arrodillado | Salidas Laterales Semi-Arrodillado — 2×10 yardas c/u",
                "Ejercicio Corte en Y con Reacción — 4×1","Ejercicio Corte con Salto y Reacción — 4×1",
                "Carrera en Medio Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica con Banda — 5×2 [X|3|X] [BANDAS NEGRAS]",
                "1.B. Puente Glúteo en Una Pierna — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×8 c/pierna",
                "2. Balanceo de Kettlebell — 3×8",
                "3. Curl Isquiotibiales en Una Pierna con Banda — 3×8 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"w9d3", name:"Día 3", label:"Pliometría · Potencia · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo con Peso — 2×10 seg (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos de Zancada Alternos — 2×10 seg (5 lbs o menos)",
                "Salto a Caja Sentado | Salto a Caja con Aproximación — 8×1 c/u",
                "Saltos Laterales a Caja — 4×1 c/lado","Saltos de Patinador Ascendentes — 2×10 yardas c/lado",
                "Saltos de Patinador con Reacción — 4×4 c/lado"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 5×2","1.B. ITY's en Inclinado — 5×3 c/dirección"]},
              {title:"Construcción", items:[
                "1.A. Jalón al Pecho Agarre Cerrado — 3×8","1.B. Press Z con Mancuernas — 3×8",
                "2. Vaciar los Cubos — 3×8","3. Extensión Tríceps en Polea — 3×8"
              ]},
              {title:"Core", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"w9d4", name:"Día 4", label:"Velocidad Máxima · CAD Lateral · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Skips de Potencia — 4×10 yardas","Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas","Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×20 yardas",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección",
                "Pro Shuttle | Ejercicio en L — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×2","1.B. Descensos Isométricos — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×8 c/pierna",
                "2. Buenos Días con Banda — 3×8 [BANDA VERDE]","3. Empuje de Cadera con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w10", name:"Semana 10", label:"Descarga",
        days:[
          {
            id:"w10d1", name:"Día 1", label:"Pliometría · CAD · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos de Línea | Saltos de Línea Laterales — 2×10 seg c/u",
                "Saltos de Línea en Una Pierna | Saltos Laterales en Una Pierna — 2×5 seg c/u",
                "Salto Amplio / Salto Amplio Lateral en Una Pierna — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Amplio a 90° en Una Pierna — 4×1 c/pierna",
                "Salto a Caja en Una Pierna — 4×1 c/pierna","Salto a Caja en Semi-Arrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×5 @50%","1.B. Jalones de Banda — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×8","1.B. Remo con Mancuernas Inclinado — 3×8",
                "2.A. Press Militar en Semi-Arrodillado — 3×8 c/brazo",
                "2.B. Espantapájaros con Banda — 3×8 [BANDA ROJA]","3. Curl con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"w10d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración — CAD Lineal", items:[
                "Bombeo de Brazos en Semi-Arrodillado — 2×5 seg",
                "Salidas desde el Suelo | Salidas Laterales desde el Suelo — 2×10 yardas c/u",
                "Salidas en Semi-Arrodillado | Salidas Laterales Semi-Arrodillado — 2×10 yardas c/u",
                "Ejercicio Corte en Y con Reacción — 4×1","Ejercicio Corte con Salto y Reacción — 4×1",
                "Carrera en Medio Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera — 5×5 @50%","1.B. Puente Glúteo en Una Pierna — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×8 c/pierna",
                "2. Balanceo de Kettlebell — 3×8",
                "3. Curl Isquiotibiales en Una Pierna con Banda — 3×8 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"w10d3", name:"Día 3", label:"Pliometría · Potencia · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo con Peso — 2×10 seg (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos de Zancada Alternos — 2×10 seg",
                "Salto a Caja Sentado | Salto a Caja con Aproximación — 8×1 c/u",
                "Saltos Laterales a Caja — 4×1 c/lado","Saltos de Patinador Ascendentes — 2×10 yardas c/lado",
                "Saltos de Patinador con Reacción — 4×4 c/lado"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 5×5 @50%","1.B. ITY's en Inclinado — 5×3 c/dirección"]},
              {title:"Construcción", items:[
                "1.A. Jalón al Pecho Agarre Cerrado — 3×8","1.B. Press Z con Mancuernas — 3×8",
                "2. Vaciar los Cubos — 3×8","3. Extensión Tríceps en Polea — 3×8"
              ]},
              {title:"Core", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"w10d4", name:"Día 4", label:"Velocidad Máxima · CAD Lateral · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — CAD Lateral", items:[
                "Skips de Potencia — 4×10 yardas","Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas","Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×20 yardas",
                "Lanzadera Lateral Corta | Lanzadera Corta — 2×1 c/dirección",
                "Pro Shuttle | Ejercicio en L — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×5 @50%","1.B. Descensos Isométricos — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×8 c/pierna",
                "2. Buenos Días con Banda — 3×8 [BANDA VERDE]","3. Empuje de Cadera con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      }
    ]
  },

  // ══════════════════════════════════════════
  // FASE 3 — REALIZACIÓN
  // ══════════════════════════════════════════
  {
    id:"f3", name:"FASE 4", label:"Realización", accent:"#7B61FF",
    weeks:[
      {
        id:"w11", name:"Semana 11", label:"Realización",
        days:[
          {
            id:"w11d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza Concéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "Salidas Caídas — 4×10 yardas",
                "2.A. Carrera Pistón Resistida con Banda — 4×5 yardas",
                "2.B. Salida de 2 Puntos — 4×10 yardas",
                "Caídas de Balón — 10×1 (aumentar distancia progresivamente)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto en Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Press de Banca Concéntrico con Banda — 6×3 [1|1|X] [BANDAS NEGRAS]",
                "1.B. Lanzamiento Balón Medicinal Escalonado — 6×2"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Suelo con Mancuernas — 3×8",
                "1.B. Jalón Lateral con Banda — 3×8 c/brazo [BANDA VERDE]",
                "2. Elevación Frontal/Lateral con Mancuerna en Una Pierna — 3×8 c/dirección",
                "3. Curl con Mancuernas — 3×8 c/brazo"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"w11d2", name:"Día 2", label:"Agilidad Lateral · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"CAD Lateral", items:[
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Paso Rápido Carioca | Carrera Cruzada — 2×10 yardas c/dirección",
                "Ejercicio Espejo — 4×5 seg",
                "Desplazamiento Lateral con Reacción de Balón (de frente) — 4×1",
                "Desplazamiento Lateral con Sprint de Reacción — 4×1"
              ]},
              {title:"Pliometría", items:["1. Saltos en V — 4×1"]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Concéntrica con Banda — 6×3 [1|1|X] [BANDAS NEGRAS]",
                "1.B. Salto a Caja con Aproximación — 6×2"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 3×8 c/pierna",
                "2. Balanceo de Kettlebell con Banda — 3×8 [BANDA NEGRA]",
                "3. Curl Nórdico Isquiotibiales — 3×5 (sin manos)"
              ]},
              {title:"Core", items:["1. Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"w11d3", name:"Día 3", label:"Agilidad Lineal · Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad Lineal", items:[
                "Para y Avanza 2 Puntos (a señal) — 4×1",
                "Pro Shuttle | Ejercicio en L — 2×1 c/dirección",
                "Desplazamiento Lateral con Caídas de Balón — 8×1 (aumentar distancia)",
                "Retroceso con Caídas de Balón — 8×1 (aumentar distancia)",
                "Ejercicio en Figura 8 — 2×1 c/dirección"
              ]},
              {title:"Pliometría", items:["1. Saltos Laterales Alternos — 4×20 yardas"]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 6×3",
                "1.B. Pase de Pecho con Balón Medicinal Rebote — 6×5 seg"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo a Un Brazo — 3×8 c/brazo","1.B. Press Landmine — 3×8 c/lado",
                "2. Dominadas Supinas — 3×Máximo",
                "3. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Posición Dividida — 3×8 c/lado"]}
            ]
          },
          {
            id:"w11d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Rodilla Alta en Una Pierna | Pedaleo en Una Pierna — 2×10 yardas c/u",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×30 yardas c/u"
              ]},
              {title:"Pliometría", items:["1. Saltos en Una Pierna — 2×20 yardas c/pierna"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Peso Muerto Barra Trapecio — 6×3","1.B. Salto a Caja — 6×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 3×8 c/lado","2. Zancada Lateral Goblet — 3×8 c/lado",
                "3. Marcha con Trineo — 3×20 yardas"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w12", name:"Semana 12", label:"Realización",
        days:[
          {
            id:"w12d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza Concéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "Salidas Caídas — 4×10 yardas","2.A. Carrera Pistón Resistida con Banda — 4×5 yardas",
                "2.B. Salida de 2 Puntos — 4×10 yardas",
                "Caídas de Balón — 10×1 (aumentar distancia progresivamente)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto en Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Press de Banca Concéntrico con Banda — 8×2 [X|1|X] [BANDAS NEGRAS]",
                "1.B. Lanzamiento Balón Medicinal Escalonado — 8×2"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Suelo con Mancuernas — 4×6",
                "1.B. Jalón Lateral con Banda — 4×6 c/brazo [BANDA VERDE]",
                "2. Elevación Frontal/Lateral con Mancuerna en Una Pierna — 4×6 c/dirección",
                "3. Curl con Mancuernas — 4×6 c/brazo"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"w12d2", name:"Día 2", label:"Agilidad Lateral · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"CAD Lateral", items:[
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Paso Rápido Carioca | Carrera Cruzada — 2×10 yardas c/dirección",
                "Ejercicio Espejo — 4×5 seg","Desplazamiento Lateral con Reacción de Balón — 4×1",
                "Desplazamiento Lateral con Sprint de Reacción — 4×1"
              ]},
              {title:"Pliometría", items:["1. Saltos en V — 4×1"]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Concéntrica con Banda — 8×2 [X|1|X] [BANDAS NEGRAS]",
                "1.B. Salto a Caja con Aproximación — 8×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×6 c/pierna",
                "2. Balanceo de Kettlebell con Banda — 4×6 [BANDA NEGRA]",
                "3. Curl Nórdico Isquiotibiales — 4×5 (sin manos)"
              ]},
              {title:"Core", items:["1. Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"w12d3", name:"Día 3", label:"Agilidad Lineal · Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad Lineal", items:[
                "Para y Avanza 2 Puntos (a señal) — 4×1","Pro Shuttle | Ejercicio en L — 2×1 c/dirección",
                "Desplazamiento Lateral con Caídas de Balón — 8×1",
                "Retroceso con Caídas de Balón — 8×1","Ejercicio en Figura 8 — 2×1 c/dirección"
              ]},
              {title:"Pliometría", items:["1. Saltos Laterales Alternos — 4×20 yardas"]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 8×2",
                "1.B. Pase de Pecho con Balón Medicinal Rebote — 8×5 seg"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo a Un Brazo — 4×6 c/brazo","1.B. Press Landmine — 4×6 c/lado",
                "2. Dominadas Supinas — 3×Máximo","3. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Posición Dividida — 3×8 c/lado"]}
            ]
          },
          {
            id:"w12d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Rodilla Alta en Una Pierna | Pedaleo en Una Pierna — 2×10 yardas c/u",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×30 yardas c/u"
              ]},
              {title:"Pliometría", items:["1. Saltos en Una Pierna — 2×20 yardas c/pierna"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Peso Muerto Barra Trapecio — 8×2","1.B. Salto a Caja — 8×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 4×6 c/lado","2. Zancada Lateral Goblet — 4×6 c/lado",
                "3. Marcha con Trineo — 4×20 yardas"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w13", name:"Semana 13", label:"Realización",
        days:[
          {
            id:"w13d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza Concéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "Salidas Caídas — 4×10 yardas","2.A. Carrera Pistón Resistida con Banda — 4×5 yardas",
                "2.B. Salida de 2 Puntos — 4×10 yardas",
                "Caídas de Balón — 10×1 (aumentar distancia progresivamente)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto en Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Press de Banca Concéntrico con Banda — 10×1 [X|X|X] [BANDAS NEGRAS]",
                "1.B. Lanzamiento Balón Medicinal Escalonado — 10×1"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Suelo con Mancuernas — 4×4",
                "1.B. Jalón Lateral con Banda — 4×4 c/brazo [BANDA VERDE]",
                "2. Elevación Frontal/Lateral con Mancuerna en Una Pierna — 4×4 c/dirección",
                "3. Curl con Mancuernas — 3×8 c/brazo"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"w13d2", name:"Día 2", label:"Agilidad Lateral · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"CAD Lateral", items:[
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Paso Rápido Carioca | Carrera Cruzada — 2×10 yardas c/dirección",
                "Ejercicio Espejo — 4×5 seg",
                "Desplazamiento Lateral con Reacción de Balón (de frente | hacia pared) — 4×1",
                "Desplazamiento Lateral con Sprint de Reacción — 4×1"
              ]},
              {title:"Pliometría", items:["1. Saltos en V — 4×1"]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Concéntrica con Banda — 10×1 [X|X|X] [BANDAS NEGRAS]",
                "1.B. Salto a Caja con Aproximación — 10×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×4 c/pierna",
                "2. Balanceo de Kettlebell con Banda — 4×4 [BANDA NEGRA]",
                "3. Curl Nórdico Isquiotibiales — 4×5 (sin manos)"
              ]},
              {title:"Core", items:["1. Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"w13d3", name:"Día 3", label:"Agilidad Lineal · Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad Lineal", items:[
                "Para y Avanza 2 Puntos (a señal) — 4×1","Pro Shuttle | Ejercicio en L — 2×1 c/dirección",
                "Desplazamiento Lateral con Caídas de Balón — 8×1",
                "Retroceso con Caídas de Balón — 8×1","Ejercicio en Figura 8 — 2×1 c/dirección"
              ]},
              {title:"Pliometría", items:["1. Saltos Laterales Alternos — 4×20 yardas"]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 10×1",
                "1.B. Pase de Pecho con Balón Medicinal Rebote — 10×3 seg"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo a Un Brazo — 4×4 c/brazo","1.B. Press Landmine — 4×4 c/lado",
                "2. Dominadas Supinas — 3×Máximo","3. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Posición Dividida — 3×8 c/lado"]}
            ]
          },
          {
            id:"w13d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Rodilla Alta en Una Pierna | Pedaleo en Una Pierna — 2×10 yardas c/u",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×30 yardas c/u"
              ]},
              {title:"Pliometría", items:["1. Saltos en Una Pierna — 2×20 yardas c/pierna"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Peso Muerto Barra Trapecio — 10×1","1.B. Salto a Caja — 10×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 4×4 c/lado","2. Zancada Lateral Goblet — 4×4 c/lado",
                "3. Marcha con Trineo — 4×20 yardas"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"w14", name:"Semana 14", label:"Descarga",
        days:[
          {
            id:"w14d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "Salidas Caídas — 4×10 yardas","2.A. Carrera Pistón Resistida con Banda — 4×5 yardas",
                "2.B. Salida de 2 Puntos — 4×10 yardas",
                "Caídas de Balón — 10×1 (aumentar distancia progresivamente)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto en Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1. Press de Banca Concéntrico con Banda — 5×5 @50% [BANDAS NEGRAS]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Suelo con Mancuernas — 4×4",
                "1.B. Jalón Lateral con Banda — 4×4 c/brazo [BANDA VERDE]",
                "2. Elevación Frontal/Lateral con Mancuerna en Una Pierna — 4×4 c/dirección",
                "3. Curl con Mancuernas — 3×8 c/brazo"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"w14d2", name:"Día 2", label:"Agilidad Lateral · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"CAD Lateral", items:[
                "Desplazamiento Lateral de Potencia | Desplazamiento Lateral — 2×20 yardas c/u",
                "Paso Rápido Carioca | Carrera Cruzada — 2×10 yardas c/dirección",
                "Ejercicio Espejo — 4×5 seg","Desplazamiento Lateral con Reacción de Balón — 4×1",
                "Desplazamiento Lateral con Sprint de Reacción — 4×1"
              ]},
              {title:"Pliometría", items:["1. Saltos en V — 4×1"]},
              {title:"Fuerza", items:["1. Sentadilla Trasera Concéntrica con Banda — 5×5 @50% [BANDAS NEGRAS]"]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×4 c/pierna",
                "2. Balanceo de Kettlebell con Banda — 4×4 [BANDA NEGRA]",
                "3. Curl Nórdico Isquiotibiales — 4×5 (sin manos)"
              ]},
              {title:"Core", items:["1. Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"w14d3", name:"Día 3", label:"Agilidad Lineal · Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad Lineal", items:[
                "Para y Avanza 2 Puntos (a señal) — 4×1","Pro Shuttle | Ejercicio en L — 2×1 c/dirección",
                "Desplazamiento Lateral con Caídas de Balón — 8×1",
                "Retroceso con Caídas de Balón — 8×1","Ejercicio en Figura 8 — 2×1 c/dirección"
              ]},
              {title:"Pliometría", items:["1. Saltos Laterales Alternos — 4×20 yardas"]},
              {title:"Fuerza", items:["1. Press de Banca — 5×5 @50%"]},
              {title:"Construcción", items:[
                "1.A. Remo a Un Brazo — 4×4 c/brazo","1.B. Press Landmine — 4×4 c/lado",
                "2. Dominadas Supinas — 3×Máximo","3. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Posición Dividida — 3×8 c/lado"]}
            ]
          },
          {
            id:"w14d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "Carrera con Rodillas Altas | Carrera Talón a Glúteo — 2×10 yardas c/u",
                "Skips A | Skips B — 2×20 yardas",
                "Rodilla Alta en Una Pierna | Pedaleo en Una Pierna — 2×10 yardas c/u",
                "Saltos con Piernas Rectas | Saltos Alternos — 2×20 yardas c/u",
                "Carreras de Paso por Encima | Aceleraciones Progresivas — 4×30 yardas c/u"
              ]},
              {title:"Pliometría", items:["1. Saltos en Una Pierna — 2×20 yardas c/pierna"]},
              {title:"Fuerza — Contraste", items:["1. Peso Muerto Barra Trapecio — 5×5 @50%"]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 4×4 c/lado","2. Zancada Lateral Goblet — 4×4 c/lado",
                "3. Marcha con Trineo — 4×20 yardas"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      }
    ]
  }
];

// ── ATHLETIC SPEED SYSTEM DATA ───────────────────────────────────
const ASS_PHASES = [
  {
    id:"ss-p1", name:"FASE 1", label:"Adaptación", accent:"#FF9500",
    weeks:[
      {
        id:"ss-w1", name:"Semana 1", label:"Acumulación",
        days:[
          {
            id:"ss-w1d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 sec","Saltos con Sentadilla — 2×10 sec",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 3×10","1.B. Jalones de Banda — 3×15"]},
              {title:"Construcción", items:[
                "1. Press Neutro con Mancuernas Inclinado — 3×12","2. Remo con Barra — 3×12",
                "3. Press Militar — 3×12","4.A. Extensión Tríceps Polea — 3×12","4.B. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Plancha — 2×60 sec"]},
              {title:"Acondicionamiento", items:["1. Saltar Cuerda — 500 Saltos"]}
            ]
          },
          {
            id:"ss-w1d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración", items:[
                "1. Salidas 2 Puntos — 10×1 (10 yardas sprint, 10 yardas desacelerar)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio (agarre bajo) — 3×10",
                "1.B. Caminata Monster — 3×10 yds (adelante y atrás)"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna","2. Curl Isquiotibiales — 3×12","3. Elevación de Talones — 3×12"
              ]},
              {title:"Core", items:["1. Plancha Lateral — 2×30 sec c/lado"]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 25 yardas)"]}
            ]
          },
          {
            id:"ss-w1d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 sec","Saltos con Sentadilla — 2×10 sec",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 3×10","1.B. Jalones de Cara — 3×12"]},
              {title:"Construcción", items:[
                "1. Press de Banca con Mancuernas — 3×12","2. Dominadas — 3×Max","3. Elevaciones Laterales — 3×12",
                "4.A. Curl con Barra — 3×12","4.B. Extensión Tríceps Agarre Inverso — 3×12"
              ]},
              {title:"Core", items:["1. Cobra en Prono — 2×60 sec c/lado"]},
              {title:"Acondicionamiento", items:["1. Saltar Cuerda — 750 Saltos"]}
            ]
          },
          {
            id:"ss-w1d4", name:"Día 4", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Velocidad Máxima", items:["1. Tempo 50's — 10×1"]},
              {title:"Fuerza", items:["1.A. Sentadilla Frontal — 3×10","1.B. Empuje de Cadera — 3×10"]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna","2. RDL — 3×12","3. Elevación de Puntas con Peso — 3×12"
              ]},
              {title:"Core", items:[
                "1. Plancha — 1×60","2. Plancha Lateral — 1×60 sec c/lado","3. Cobra en Prono — 1×60 sec c/lado"
              ]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 50 yardas)"]}
            ]
          }
        ]
      },
      {
        id:"ss-w2", name:"Semana 2", label:"Acumulación",
        days:[
          {
            id:"ss-w2d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 sec","Saltos con Sentadilla — 2×10 sec",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 3×8","1.B. Jalones de Banda — 3×15"]},
              {title:"Construcción", items:[
                "1. Press Neutro con Mancuernas Inclinado — 3×12","2. Remo con Barra — 3×12",
                "3. Press Militar — 3×12","4.A. Extensión Tríceps Polea — 3×12","4.B. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Plancha — 2×60 sec"]},
              {title:"Acondicionamiento", items:["1. Saltar Cuerda — 1.000 Saltos"]}
            ]
          },
          {
            id:"ss-w2d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración", items:[
                "1. Salidas 2 Puntos — 10×1 (10 yardas sprint, 10 yardas desacelerar)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio (agarre bajo) — 3×8",
                "1.B. Caminata Monster — 3×10 yds (adelante y atrás)"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna","2. Curl Isquiotibiales — 3×12","3. Elevación de Talones — 3×12"
              ]},
              {title:"Core", items:["1. Plancha Lateral — 2×30 sec c/lado"]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 25 yardas)"]}
            ]
          },
          {
            id:"ss-w2d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 sec","Saltos con Sentadilla — 2×10 sec",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 3×8","1.B. Jalones de Cara — 3×12"]},
              {title:"Construcción", items:[
                "1. Press de Banca con Mancuernas — 3×12","2. Dominadas — 3×Max","3. Elevaciones Laterales — 3×12",
                "4.A. Curl con Barra — 3×12","4.B. Extensión Tríceps Agarre Inverso — 3×12"
              ]},
              {title:"Core", items:["1. Cobra en Prono — 2×60 sec c/lado"]},
              {title:"Acondicionamiento", items:["1. Saltar Cuerda — 1.000 Saltos"]}
            ]
          },
          {
            id:"ss-w2d4", name:"Día 4", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Velocidad Máxima", items:["1. Tempo 50's — 10×1"]},
              {title:"Fuerza", items:["1.A. Sentadilla Frontal — 3×8","1.B. Empuje de Cadera — 3×10"]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna","2. RDL — 3×12","3. Elevación de Puntas con Peso — 3×12"
              ]},
              {title:"Core", items:[
                "1. Plancha — 1×60","2. Plancha Lateral — 1×60 sec c/lado","3. Cobra en Prono — 1×60 sec c/lado"
              ]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 50 yardas)"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"ss-p2", name:"FASE 2", label:"Acumulación", accent:"#E8003D",
    weeks:[
      {
        id:"ss-w3", name:"Semana 3", label:"Acumulación",
        days:[
          {
            id:"ss-w3d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 sec",
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 8×1 c/pierna",
                "Escalones de Velocista — 2×8 c/pierna",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Banda Excéntrica — 5×4 [5|1|X] [BLACK BANDS]",
                "1.B. Jalón de Cara con Banda y Rotación Externa — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×12","1.B. Remo con Mancuernas Apoyado en Banco Inclinado — 3×12",
                "2.A. Elevación Frontal con Disco — 3×12","2.B. Jalones de Cara en Polea — 3×12","3. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Dead Bugs Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"ss-w3d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salto Amplio Escalonado — 10×1",
                "3. Salidas de Pared — 4×5 sec","4. Salidas 2 Puntos — 10×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera con Banda Excéntrica — 5×4 [5|1|X] [BLACK BANDS]",
                "1.B. Sentadillas con Hip Circle — 5×8 [HIP CIRCLE BAND]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×12 c/pierna","2. RDL Una Pierna — 3×12 c/pierna",
                "3. Curl Isquiotibiales Nórdico (Tempo) — 3×12","4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico de Estabilidad de Core con Banda — 1×20 yds c/u direction [GREEN BAND]"]}
            ]
          },
          {
            id:"ss-w3d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos Bilaterales", items:[
                "Saltos Pogo — 2×10 sec",
                "Saltos con Sentadilla | Saltos con Zancada Alternos — 2×10 sec c/u",
                "Salto a Caja — 8×1","Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 5×4","1.B. Blackburns en Prono — 5×10"]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×12","1.B. Press de Banca con Mancuernas — 3×12",
                "2.A. Elevación Deltoides Posterior — 3×12","2.B. Elevación Lateral — 3×12","3. Skull Crushers — 3×12"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yds c/lado"]}
            ]
          },
          {
            id:"ss-w3d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "3. Skips A | Skips B — 2×20 yds","4. Shuffle Pierna Recta — 2×10 yds",
                "5. Saltos Pierna Recta — 2×20 yds","6. Carreras Tempo — 4×30 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×4","1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×12 c/pierna",
                "2. Buenos Días — 3×12","3. Empuje de Cadera Una Pierna — 3×12 c/pierna"
              ]},
              {title:"Core", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w4", name:"Semana 4", label:"Acumulación",
        days:[
          {
            id:"ss-w4d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 sec",
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 8×1 c/pierna",
                "Escalones de Velocista — 2×8 c/pierna",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Banda Excéntrica — 5×3 [4|1|X] [BLACK BANDS]",
                "1.B. Jalón de Cara con Banda y Rotación Externa — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×10","1.B. Remo con Mancuernas Apoyado en Banco Inclinado — 3×10",
                "2.A. Elevación Frontal con Disco — 3×10","2.B. Jalones de Cara en Polea — 3×10","3. Curl Martillo — 3×10"
              ]},
              {title:"Core", items:["1. Dead Bugs Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"ss-w4d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salto Amplio Escalonado — 10×1",
                "3. Salidas de Pared — 6×3 sec","4. Salidas 2 Puntos — 10×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera con Banda Excéntrica — 5×3 [4|1|X] [BLACK BANDS]",
                "1.B. Sentadillas con Hip Circle — 5×8 [HIP CIRCLE BAND]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×10 c/pierna","2. RDL Una Pierna — 3×10 c/pierna",
                "3. Curl Isquiotibiales Nórdico (Tempo) — 3×10","4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico de Estabilidad de Core con Banda — 1×20 yds c/u direction [GREEN BAND]"]}
            ]
          },
          {
            id:"ss-w4d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos Bilaterales", items:[
                "Saltos Pogo — 2×10 sec",
                "Saltos con Sentadilla | Saltos con Zancada Alternos — 2×10 sec c/u",
                "Salto a Caja — 8×1","Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 5×3","1.B. Blackburns en Prono — 5×10"]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×10","1.B. Press de Banca con Mancuernas — 3×10",
                "2.A. Elevación Deltoides Posterior — 3×10","2.B. Elevación Lateral — 3×10","3. Skull Crushers — 3×10"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yds c/lado"]}
            ]
          },
          {
            id:"ss-w4d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "3. Skips A | Skips B — 2×20 yds","4. Shuffle Pierna Recta — 2×10 yds",
                "5. Saltos Pierna Recta — 2×20 yds","6. Carreras Tempo — 4×30 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×3","1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×10 c/pierna",
                "2. Buenos Días — 3×10","3. Empuje de Cadera Una Pierna — 3×10 c/pierna"
              ]},
              {title:"Core", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w5", name:"Semana 5", label:"Acumulación",
        days:[
          {
            id:"ss-w5d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 sec",
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 8×1 c/pierna",
                "Escalones de Velocista — 2×8 c/pierna",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Banda Excéntrica — 5×2 [3|1|X] [BLACK BANDS]",
                "1.B. Jalón de Cara con Banda y Rotación Externa — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×8","1.B. Remo con Mancuernas Apoyado en Banco Inclinado — 3×8",
                "2.A. Elevación Frontal con Disco — 3×8","2.B. Jalones de Cara en Polea — 3×8","3. Curl Martillo — 3×8"
              ]},
              {title:"Core", items:["1. Dead Bugs Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"ss-w5d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salto Amplio Escalonado — 10×1",
                "3. Salidas de Pared — 6×3 sec","4. Salidas 2 Puntos — 10×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera con Banda Excéntrica — 5×2 [3|1|X] [BLACK BANDS]",
                "1.B. Sentadillas con Hip Circle — 5×8 [HIP CIRCLE BAND]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×8 c/pierna","2. RDL Una Pierna — 3×8 c/pierna",
                "3. Curl Isquiotibiales Nórdico (Tempo) — 3×8","4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico de Estabilidad de Core con Banda — 1×20 yds c/u direction [GREEN BAND]"]}
            ]
          },
          {
            id:"ss-w5d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos Bilaterales", items:[
                "Saltos Pogo — 2×10 sec",
                "Saltos con Sentadilla | Saltos con Zancada Alternos — 2×10 sec c/u",
                "Salto a Caja — 8×1","Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 5×2","1.B. Blackburns en Prono — 5×10"]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×8","1.B. Press de Banca con Mancuernas — 3×8",
                "2.A. Elevación Deltoides Posterior — 3×8","2.B. Elevación Lateral — 3×8","3. Skull Crushers — 3×8"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yds c/lado"]}
            ]
          },
          {
            id:"ss-w5d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 4×10 yds c/u",
                "3. Skips A | Skips B — 4×20 yds","4. Shuffle Pierna Recta — 4×10 yds",
                "5. Saltos Pierna Recta — 4×20 yds","6. Carreras Tempo — 4×30 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×2","1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×8 c/pierna",
                "2. Buenos Días — 3×8","3. Empuje de Cadera Una Pierna — 3×8 c/pierna"
              ]},
              {title:"Core", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w6", name:"Semana 6", label:"Descarga",
        days:[
          {
            id:"ss-w6d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Saltos Pogo — 2×10 sec",
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 8×1 c/pierna",
                "Escalones de Velocista — 2×8 c/pierna",
                "Skips de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Banda Excéntrica — 5×5 @50% [2|1|X] [BLACK BANDS]",
                "1.B. Jalón de Cara con Banda y Rotación Externa — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Mancuernas Inclinado — 3×8","1.B. Remo con Mancuernas Apoyado en Banco Inclinado — 3×8",
                "2.A. Elevación Frontal con Disco — 3×8","2.B. Jalones de Cara en Polea — 3×8","3. Curl Martillo — 3×8"
              ]},
              {title:"Core", items:["1. Dead Bugs Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"ss-w6d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salto Amplio Escalonado — 10×1",
                "3. Salidas de Pared — 6×3 sec","4. Salidas 2 Puntos — 10×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera con Banda Excéntrica — 5×5 @50% [2|1|X] [BLACK BANDS]",
                "1.B. Sentadillas con Hip Circle — 5×8 [HIP CIRCLE BAND]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Mancuernas — 3×8 c/pierna","2. RDL Una Pierna — 3×8 c/pierna",
                "3. Curl Isquiotibiales Nórdico (Tempo) — 3×8","4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Circuito Dinámico de Estabilidad de Core con Banda — 1×20 yds c/u direction [GREEN BAND]"]}
            ]
          },
          {
            id:"ss-w6d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos Bilaterales", items:[
                "Saltos Pogo — 2×10 sec",
                "Saltos con Sentadilla | Saltos con Zancada Alternos — 2×10 sec c/u",
                "Salto a Caja — 8×1","Saltos de Potencia — 4×20 yds (2 height | 2 distance)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 5×5 @50%","1.B. Blackburns en Prono — 5×10"]},
              {title:"Construcción", items:[
                "1.A. Dominadas Agarre Neutro — 3×8","1.B. Press de Banca con Mancuernas — 3×8",
                "2.A. Elevación Deltoides Posterior — 3×8","2.B. Elevación Lateral — 3×8","3. Skull Crushers — 3×8"
              ]},
              {title:"Core", items:["1. Cargada Maletín — 4×20 yds c/lado"]}
            ]
          },
          {
            id:"ss-w6d4", name:"Día 4", label:"Velocidad Máxima · Fuerza Absoluta · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×20 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 4×10 yds c/u",
                "3. Skips A | Skips B — 4×20 yds","4. Shuffle Pierna Recta — 4×10 yds",
                "5. Saltos Pierna Recta — 4×20 yds","6. Carreras Tempo — 4×30 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×5 @50%","1.B. Escalones con Desaceleración — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadilla Búlgara — 3×8 c/pierna",
                "2. Buenos Días — 3×8","3. Empuje de Cadera Una Pierna — 3×8 c/pierna"
              ]},
              {title:"Core", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"ss-p3", name:"FASE 3", label:"Transmutación", accent:"#00C9FF",
    weeks:[
      {
        id:"ss-w7", name:"Semana 7", label:"Transmutación",
        days:[
          {
            id:"ss-w7d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 4×1 c/pierna",
                "Salto a Caja con Aproximación Una Pierna — 4×1 c/pierna",
                "Salto a Caja Semiarrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico con Banda — 5×4 [1|5|X] [BLACK BANDS]",
                "1.B. Jalones de Banda — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×12","1.B. Remo Inclinado con Mancuernas — 3×12",
                "2.A. Press Aéreo Semiarrodillado — 3×12 c/u arm",
                "2.B. Espantapájaros con Banda — 3×12 [RED BAND]","3. Curl con Barra — 3×12"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"ss-w7d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salidas desde el Suelo — 4×10 yds",
                "3. Salidas Semiarrodillado — 2×10 yds c/u","4. Salidas en Caída — 4×10 yds",
                "5. Salidas 2 Puntos — 8×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica con Banda — 5×4 [1|5|X] [BLACK BANDS]",
                "1.B. Puente Glúteo Una Pierna (pierna contraria recogida) — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×12 c/pierna","2. Swing con Kettlebell — 3×12",
                "3. Curl Isquiotibiales Una Pierna con Banda — 3×12 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w7d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo con Peso — 2×10 sec (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos con Zancada Alternos — 2×10 sec (5 lbs o menos)",
                "Salto a Caja Sentado — 8×1","Salto a Caja con Aproximación — 4×1 c/u","Doble Salto Amplio — 4×1"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 5×4","1.B. Incline ITY's — 5×3 c/u way"]},
              {title:"Construcción", items:[
                "1.A. Jalones Agarre Cerrado — 3×12","1.B. Press Z con Mancuernas — 3×12",
                "2. Vaciar los Cubos — 3×12","3. Extensión de Tríceps en Polea — 3×12"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w7d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×10 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "3. Skips A | Skips B — 2×20 yds",
                "4. Rodilla Alta Una Pierna — 4×10 yds c/u",
                "5. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "6. Carreras con Paso Elevado — 4×10 yds","7. Progresivos — 4×40 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×4","1.B. Bajadas Isométricas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×12 c/pierna",
                "2. Buenos Días con Banda — 3×12 [GREEN BAND]","3. Empuje de Cadera con Barra — 3×12"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w8", name:"Semana 8", label:"Transmutación",
        days:[
          {
            id:"ss-w8d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 4×1 c/pierna",
                "Salto a Caja con Aproximación Una Pierna — 4×1 c/pierna",
                "Salto a Caja Semiarrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico con Banda — 5×3 [1|4|X] [BLACK BANDS]",
                "1.B. Jalones de Banda — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×10","1.B. Remo Inclinado con Mancuernas — 3×10",
                "2.A. Press Aéreo Semiarrodillado — 3×10 c/u arm",
                "2.B. Espantapájaros con Banda — 3×10 [RED BAND]","3. Curl con Barra — 3×10"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"ss-w8d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salidas desde el Suelo — 4×10 yds",
                "3. Salidas Semiarrodillado — 2×10 yds c/u","4. Salidas en Caída — 4×10 yds",
                "5. Salidas de Salto Atrás — 4×10 yds","6. Salidas 2 Puntos — 8×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica con Banda — 5×3 [1|4|X] [BLACK BANDS]",
                "1.B. Puente Glúteo Una Pierna (pierna contraria recogida) — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×10 c/pierna","2. Swing con Kettlebell — 3×10",
                "3. Curl Isquiotibiales Una Pierna con Banda — 3×10 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w8d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo con Peso — 2×10 sec (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos con Zancada Alternos — 2×10 sec (5 lbs o menos)",
                "Salto a Caja Sentado — 8×1","Salto a Caja con Aproximación — 4×1 c/u","Doble Salto Amplio — 4×1"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 5×3","1.B. Incline ITY's — 5×3 c/u way"]},
              {title:"Construcción", items:[
                "1.A. Jalones Agarre Cerrado — 3×10","1.B. Press Z con Mancuernas — 3×10",
                "2. Vaciar los Cubos — 3×10","3. Extensión de Tríceps en Polea — 3×10"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w8d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×10 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "3. Skips A | Skips B — 2×20 yds",
                "4. Rodilla Alta Una Pierna — 4×10 yds c/u",
                "5. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "6. Carreras con Paso Elevado — 4×10 yds","7. Progresivos — 4×40 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×3","1.B. Bajadas Isométricas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna",
                "2. Buenos Días con Banda — 3×10 [GREEN BAND]","3. Empuje de Cadera con Barra — 3×10"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w9", name:"Semana 9", label:"Transmutación",
        days:[
          {
            id:"ss-w9d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 4×1 c/pierna",
                "Salto a Caja con Aproximación Una Pierna — 4×1 c/pierna",
                "Salto a Caja Semiarrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico con Banda — 5×2 [1|3|X] [BLACK BANDS]",
                "1.B. Jalones de Banda — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×8","1.B. Remo Inclinado con Mancuernas — 3×8",
                "2.A. Press Aéreo Semiarrodillado — 3×8 c/u arm",
                "2.B. Espantapájaros con Banda — 3×8 [RED BAND]","3. Curl con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"ss-w9d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salidas desde el Suelo — 4×10 yds",
                "3. Salidas Semiarrodillado — 2×10 yds c/u","4. Salidas en Caída — 4×10 yds",
                "5. Salidas de Salto Atrás — 4×10 yds","6. Salidas 2 Puntos — 8×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica con Banda — 5×2 [1|3|X] [BLACK BANDS]",
                "1.B. Puente Glúteo Una Pierna (pierna contraria recogida) — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×8 c/pierna","2. Swing con Kettlebell — 3×8",
                "3. Curl Isquiotibiales Una Pierna con Banda — 3×8 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w9d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo con Peso — 2×10 sec (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos con Zancada Alternos — 2×10 sec (5 lbs o menos)",
                "Salto a Caja Sentado — 8×1","Salto a Caja con Aproximación — 4×1 c/u","Doble Salto Amplio — 4×1"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 5×2","1.B. Incline ITY's — 5×3 c/u way"]},
              {title:"Construcción", items:[
                "1.A. Jalones Agarre Cerrado — 3×8","1.B. Press Z con Mancuernas — 3×8",
                "2. Vaciar los Cubos — 3×8","3. Extensión de Tríceps en Polea — 3×8"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w9d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×10 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "3. Skips A | Skips B — 2×20 yds",
                "4. Rodilla Alta Una Pierna — 4×10 yds c/u",
                "5. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "6. Carreras con Paso Elevado — 4×10 yds","7. Progresivos — 4×40 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×2","1.B. Bajadas Isométricas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×8 c/pierna",
                "2. Buenos Días con Banda — 3×8 [GREEN BAND]","3. Empuje de Cadera con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w10", name:"Semana 10", label:"Descarga",
        days:[
          {
            id:"ss-w10d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral", items:[
                "Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "Salto Amplio Una Pierna (aterrizar en 2) — 2×4 c/pierna",
                "Salto a Caja Una Pierna (aterrizar en 2) — 2×1 c/pierna",
                "Salto a Caja con Aproximación Una Pierna — 2×1 c/pierna",
                "Salto a Caja Semiarrodillado — 2×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico con Banda — 5×5 @50% [1|2|X] [BLACK BANDS]",
                "1.B. Jalones de Banda — 5×10 [RED BAND]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con Mancuernas — 3×8","1.B. Remo Inclinado con Mancuernas — 3×8",
                "2.A. Press Aéreo Semiarrodillado — 3×8 c/u arm",
                "2.B. Espantapájaros con Banda — 3×8 [RED BAND]","3. Curl con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"ss-w10d2", name:"Día 2", label:"Aceleración · Fuerza Trifásica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Bombeo de Brazos Semiarrodillado — 2×5 sec","2. Salidas desde el Suelo — 2×10 yds",
                "3. Salidas Semiarrodillado — 2×10 yds c/u","4. Salidas en Caída — 2×10 yds",
                "5. Salidas de Salto Atrás — 2×10 yds","6. Salidas 2 Puntos — 2×10 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica con Banda — 5×5 @50% [1|2|X] [BLACK BANDS]",
                "1.B. Puente Glúteo Una Pierna (pierna contraria recogida) — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa Elevada con Mancuernas — 3×8 c/pierna","2. Swing con Kettlebell — 3×8",
                "3. Curl Isquiotibiales Una Pierna con Banda — 3×8 c/pierna",
                "4. Flexión Plantar y Dorsal — 2×20 c/u"
              ]},
              {title:"Core", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w10d3", name:"Día 3", label:"Pliometría · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Bilateral", items:[
                "Saltos Pogo con Peso — 2×10 sec (5 lbs o menos)",
                "Saltos con Sentadilla con Peso | Saltos con Zancada Alternos — 2×10 sec (5 lbs o menos)",
                "Salto a Caja Sentado — 4×1","Salto a Caja con Aproximación — 2×1 c/u","Doble Salto Amplio — 2×1"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 5×5 @50%","1.B. Incline ITY's — 5×3 c/u way"]},
              {title:"Construcción", items:[
                "1.A. Jalones Agarre Cerrado — 3×8","1.B. Press Z con Mancuernas — 3×8",
                "2. Vaciar los Cubos — 3×8","3. Extensión de Tríceps en Polea — 3×8"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w10d4", name:"Día 4", label:"Velocidad Máxima · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima", items:[
                "1. Skips de Potencia — 4×10 yds (2 height | 2 distance)",
                "2. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "3. Skips A | Skips B — 2×20 yds",
                "4. Rodilla Alta Una Pierna — 2×10 yds c/u",
                "5. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "6. Carreras con Paso Elevado — 2×10 yds","7. Progresivos — 2×40 yds"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×5 @50%","1.B. Bajadas Isométricas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×8 c/pierna",
                "2. Buenos Días con Banda — 3×8 [GREEN BAND]","3. Empuje de Cadera con Barra — 3×8"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"ss-p4", name:"FASE 4", label:"Realización", accent:"#7B61FF",
    weeks:[
      {
        id:"ss-w11", name:"Semana 11", label:"Realización",
        days:[
          {
            id:"ss-w11d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2.A. Carrera Pistón con Resistencia de Banda — 4×5 yds",
                "2.B. Salida 2 Puntos — 4×10 yds",
                "3. Caídas de Balón — 10×1 (construir hacia la mayor distancia)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Press de Banca Concéntrico con Banda — 6×3 [1|1|X] [BLACK BANDS]",
                "1.B. Lanzamiento Amplio de Balón Medicinal Escalonado — 6×2"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con Mancuernas — 3×8",
                "1.B. Jalones de Espalda con Banda — 3×8 c/u arm [GREEN BAND]",
                "2. Elevación Frontal/Lateral Una Pierna con Mancuernas — 3×8 c/u way",
                "3. Curl con Mancuernas — 3×8 c/u arm"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"ss-w11d2", name:"Día 2", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Frontal", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Skips A (2 Normal | 2 con Potencia) — 4×20 yds",
                "3. Skips B (2 Normal | 2 con Potencia) — 4×20 yds",
                "4. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "5. Cambios de Cadera en Caja Baja — 4×5 c/pierna","6. Progresivos — 4×20 yds"
              ]},
              {title:"Pliometría", items:["1. Escalones de Velocista — 2×6 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Sentadilla Trasera Concéntrica con Banda — 6×3 [1|1|X] [BLACK BANDS]",
                "1.B. Salto a Caja con Aproximación — 6×2"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 3×8 c/pierna",
                "2. Swing con Kettlebell y Banda — 3×8 [BLACK BAND]",
                "3. Curl Isquiotibiales Nórdico — 3×5 (Objetivo: completar la repetición completa sin manos)"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w11d3", name:"Día 3", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2. Salidas con Liberación de Compañero — 8×1",
                "3.A. Marcha con Trineo Pesado — 8×10 yds",
                "3.B. Salida 2 Puntos o en Cuclillas — 8×10 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Alternos — 4×20 yds"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Press de Banca — 5×3","1.B. Pase de Pecho con Balón Medicinal Rebote — 5×5 sec"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo Un Brazo — 3×8 c/u arm","1.B. Press Landmine — 3×8 c/lado",
                "2. Dominadas Agarre Supino — 3×Max Reps","3. Pistones con Banda — 3×8 c/u arm [PURPLE BAND]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Stance Dividido — 3×8 c/lado"]}
            ]
          },
          {
            id:"ss-w11d4", name:"Día 4", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Posterior", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Carrera Rodillas Altas/Patada de Glúteo — 2×20 yds",
                "3. Rodilla Alta Una Pierna — 4×10 yds c/u",
                "4. Ciclismo Una Pierna — 4×20 yds c/u",
                "5. Carrera con Pierna Muerta — 4×10 yds c/u","6. Progresivos — 4×40 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Una Pierna — 2×20 yds c/u"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×3","1.B. Salto a Caja — 5×1"
              ]},
              {title:"Construcción", items:[
                "1. Marchas con Trineo Pesado — 3×20 yds","2. Empuje de Cadera Una Pierna — 3×8 c/lado"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w12", name:"Semana 12", label:"Realización",
        days:[
          {
            id:"ss-w12d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2.A. Carrera Pistón con Resistencia de Banda — 4×5 yds",
                "2.B. Salida 2 Puntos — 4×10 yds",
                "3. Caídas de Balón — 10×1 (construir hacia la mayor distancia)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Press de Banca Concéntrico con Banda — 8×2 [X|1|X] [BLACK BANDS]",
                "1.B. Lanzamiento Amplio de Balón Medicinal Escalonado — 8×1"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con Mancuernas — 4×6",
                "1.B. Jalones de Espalda con Banda — 4×6 c/u arm [GREEN BAND]",
                "2. Elevación Frontal/Lateral Una Pierna con Mancuernas — 4×6 c/u way",
                "3. Curl con Mancuernas — 4×6 c/u arm"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"ss-w12d2", name:"Día 2", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Frontal", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Skips A (2 Normal | 2 con Potencia) — 4×20 yds",
                "3. Skips B (2 Normal | 2 con Potencia) — 4×20 yds",
                "4. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "5. Cambios de Cadera en Caja Baja — 4×5 c/pierna","6. Progresivos — 4×20 yds"
              ]},
              {title:"Pliometría", items:["1. Escalones de Velocista — 2×6 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Sentadilla Trasera Concéntrica con Banda — 8×2 [X|1|X] [BLACK BANDS]",
                "1.B. Salto a Caja con Aproximación — 8×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×6 c/pierna",
                "2. Swing con Kettlebell y Banda — 4×6 [BLACK BAND]",
                "3. Curl Isquiotibiales Nórdico — 3×5 (Objetivo: completar la repetición completa sin manos)"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w12d3", name:"Día 3", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2. Salidas con Liberación de Compañero — 8×1",
                "3.A. Marcha con Trineo Pesado — 8×10 yds",
                "3.B. Salida 2 Puntos o en Cuclillas — 8×10 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Alternos — 4×20 yds"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Press de Banca — 5×2","1.B. Pase de Pecho con Balón Medicinal Rebote — 5×5 sec"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo Un Brazo — 4×6 c/u arm","1.B. Press Landmine — 4×6 c/lado",
                "2. Dominadas Agarre Supino — 2×Max Reps","3. Pistones con Banda — 4×6 c/u arm [PURPLE BAND]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Stance Dividido — 3×8 c/lado"]}
            ]
          },
          {
            id:"ss-w12d4", name:"Día 4", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Posterior", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Carrera Rodillas Altas/Patada de Glúteo — 2×20 yds",
                "3. Rodilla Alta Una Pierna — 4×10 yds c/u",
                "4. Ciclismo Una Pierna — 4×20 yds c/u",
                "5. Carrera con Pierna Muerta — 4×10 yds c/u","6. Progresivos — 4×40 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Una Pierna — 2×20 yds c/u"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×2","1.B. Salto a Caja — 5×1"
              ]},
              {title:"Construcción", items:[
                "1. Marchas con Trineo Pesado — 4×20 yds","2. Empuje de Cadera Una Pierna — 4×8 c/lado"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w13", name:"Semana 13", label:"Realización",
        days:[
          {
            id:"ss-w13d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2.A. Carrera Pistón con Resistencia de Banda — 4×5 yds",
                "2.B. Salida 2 Puntos — 4×10 yds",
                "3. Caídas de Balón — 10×1 (construir hacia la mayor distancia)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Press de Banca Concéntrico con Banda — 10×1 [X|X|X] [BLACK BANDS]",
                "1.B. Lanzamiento Amplio de Balón Medicinal Escalonado — 10×1"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con Mancuernas — 4×6",
                "1.B. Jalones de Espalda con Banda — 4×6 c/u arm [GREEN BAND]",
                "2. Elevación Frontal/Lateral Una Pierna con Mancuernas — 4×6 c/u way",
                "3. Curl con Mancuernas — 4×6 c/u arm"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"ss-w13d2", name:"Día 2", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Frontal", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Skips A (2 Normal | 2 con Potencia) — 4×20 yds",
                "3. Skips B (2 Normal | 2 con Potencia) — 4×20 yds",
                "4. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "5. Cambios de Cadera en Caja Baja — 4×5 c/pierna","6. Progresivos — 4×20 yds"
              ]},
              {title:"Pliometría", items:["1. Escalones de Velocista — 2×6 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Sentadilla Trasera Concéntrica con Banda — 10×1 [X|X|X] [BLACK BANDS]",
                "1.B. Salto a Caja con Aproximación — 10×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×6 c/pierna",
                "2. Swing con Kettlebell y Banda — 4×6 [BLACK BAND]",
                "3. Curl Isquiotibiales Nórdico — 3×5 (Objetivo: completar la repetición completa sin manos)"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w13d3", name:"Día 3", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2. Salidas con Liberación de Compañero — 8×1",
                "3.A. Marcha con Trineo Pesado — 8×10 yds",
                "3.B. Salida 2 Puntos o en Cuclillas — 8×10 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Alternos — 4×20 yds"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Press de Banca — 5×1","1.B. Pase de Pecho con Balón Medicinal Rebote — 5×5 sec"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo Un Brazo — 4×6 c/u arm","1.B. Press Landmine — 4×6 c/lado",
                "2. Dominadas Agarre Supino — 2×Max Reps","3. Pistones con Banda — 4×6 c/u arm [PURPLE BAND]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Stance Dividido — 3×8 c/lado"]}
            ]
          },
          {
            id:"ss-w13d4", name:"Día 4", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Posterior", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Carrera Rodillas Altas/Patada de Glúteo — 2×20 yds",
                "3. Rodilla Alta Una Pierna — 4×10 yds c/u",
                "4. Ciclismo Una Pierna — 4×20 yds c/u",
                "5. Carrera con Pierna Muerta — 4×10 yds c/u","6. Progresivos — 4×40 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Una Pierna — 2×20 yds c/u"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×1","1.B. Salto a Caja — 5×1"
              ]},
              {title:"Construcción", items:[
                "1. Marchas con Trineo Pesado — 4×20 yds","2. Empuje de Cadera Una Pierna — 4×8 c/lado"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"ss-w14", name:"Semana 14", label:"Descarga",
        days:[
          {
            id:"ss-w14d1", name:"Día 1", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2.A. Carrera Pistón con Resistencia de Banda — 4×5 yds",
                "2.B. Salida 2 Puntos — 4×10 yds",
                "3. Caídas de Balón — 10×1 (construir hacia la mayor distancia)"
              ]},
              {title:"Pliometría", items:["1. Triple Salto Una Pierna — 4×1 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Press de Banca Concéntrico con Banda — 5×5 @50% [X|X|X] [BLACK BANDS]",
                "1.B. Lanzamiento Amplio de Balón Medicinal Escalonado — 5×1"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con Mancuernas — 4×6",
                "1.B. Jalones de Espalda con Banda — 4×6 c/u arm [GREEN BAND]",
                "2. Elevación Frontal/Lateral Una Pierna con Mancuernas — 4×6 c/u way",
                "3. Curl con Mancuernas — 4×6 c/u arm"
              ]},
              {title:"Core", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"ss-w14d2", name:"Día 2", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Frontal", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Skips A (2 Normal | 2 con Potencia) — 4×20 yds",
                "3. Skips B (2 Normal | 2 con Potencia) — 4×20 yds",
                "4. Saltos Pierna Recta | Saltos Alternos — 2×20 yds c/u",
                "5. Cambios de Cadera en Caja Baja — 4×5 c/pierna","6. Progresivos — 4×20 yds"
              ]},
              {title:"Pliometría", items:["1. Escalones de Velocista — 2×6 c/pierna"]},
              {title:"Fuerza — Contraste Concéntrico", items:[
                "1.A. Sentadilla Trasera Concéntrica con Banda — 5×5 @50% [X|X|X] [BLACK BANDS]",
                "1.B. Salto a Caja con Aproximación — 5×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×6 c/pierna",
                "2. Swing con Kettlebell y Banda — 4×6 [BLACK BAND]",
                "3. Curl Isquiotibiales Nórdico — 3×5 (Objetivo: completar la repetición completa sin manos)"
              ]},
              {title:"Core", items:["1. Elevación de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"ss-w14d3", name:"Día 3", label:"Aceleración · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Aceleración", items:[
                "1. Pogos Lineales | Pogos Lineales Una Pierna — 1×10 yds c/pierna",
                "2. Salidas con Liberación de Compañero — 8×1",
                "3.A. Marcha con Trineo Pesado — 8×10 yds",
                "3.B. Salida 2 Puntos o en Cuclillas — 8×10 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Alternos — 4×20 yds"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Press de Banca — 5×5 @50%","1.B. Pase de Pecho con Balón Medicinal Rebote — 5×5 sec"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo Un Brazo — 4×6 c/u arm","1.B. Press Landmine — 4×6 c/lado",
                "2. Dominadas Agarre Supino — 2×Max Reps","3. Pistones con Banda — 4×6 c/u arm [PURPLE BAND]"
              ]},
              {title:"Core", items:["1. Press Pallof con Rotación en Stance Dividido — 3×8 c/lado"]}
            ]
          },
          {
            id:"ss-w14d4", name:"Día 4", label:"Velocidad Máxima · Pliometría · Fuerza",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad Máxima — Mecánica Posterior", items:[
                "1. Carrera Rodillas Altas | Patada de Glúteo — 2×10 yds c/u",
                "2. Carrera Rodillas Altas/Patada de Glúteo — 2×20 yds",
                "3. Rodilla Alta Una Pierna — 4×10 yds c/u",
                "4. Ciclismo Una Pierna — 4×20 yds c/u",
                "5. Carrera con Pierna Muerta — 4×10 yds c/u","6. Progresivos — 4×40 yds"
              ]},
              {title:"Pliometría", items:["1. Saltos Una Pierna — 2×20 yds c/u"]},
              {title:"Fuerza — Contraste", items:[
                "1.A. Peso Muerto Barra Trapecio — 5×5 @50%","1.B. Salto a Caja — 5×1"
              ]},
              {title:"Construcción", items:[
                "1. Marchas con Trineo Pesado — 4×20 yds","2. Empuje de Cadera Una Pierna — 4×8 c/lado"
              ]},
              {title:"Core", items:["1. Hiperextensiones con Peso — 3×20"]}
            ]
          }
        ]
      }
    ]
  }
];

// ── EVA — ELITE VERTICAL ACADEMY ────────────────────────────────
const EVA_PHASES = [
  {
    id:"eva-f1", name:"FASE 1", label:"Adaptación", accent:"#FF9500",
    weeks:[
      {
        id:"eva-f1w1", name:"Semana 1", label:"Adaptación",
        days:[
          {
            id:"eva-f1w1d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla — 2×10 seg",
                "Skips de Potencia — 4×20 yardas (2 altura | 2 distancia)",
                "Saltos de Zancada — 4×20 yardas (2 altura | 2 distancia)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 3×10","1.B. Jalones de Banda — 3×15"]},
              {title:"Construcción", items:[
                "1. Press Neutro Mancuernas Inclinado — 3×12","2. Remo con Barra — 3×12",
                "3. Press Militar — 3×12","4.A. Extensión Tríceps Polea — 3×12","4.B. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Plancha — 2×60 seg"]}
            ]
          },
          {
            id:"eva-f1w1d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración — CAD Lineal", items:[
                "Salidas 2 Puntos — 4×1 (sprint 10 yardas, desacelerar 10 yardas)",
                "Salidas 2 Puntos — 4×1 (5 sprint, 5 trote, 5 sprint)",
                "Para y Avanza 2 Puntos — 4×1 (parar cada 5 yardas en 20 yardas)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio (agarre bajo) — 3×10",
                "1.B. Caminata Monster — 3×10 yardas (adelante y atrás)"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna",
                "2. Curl Isquiotibiales — 3×12","3. Elevación de Talones — 3×12"
              ]},
              {title:"Core", items:["1. Plancha Lateral — 2×30 seg c/lado"]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 25 yardas)"]}
            ]
          },
          {
            id:"eva-f1w1d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla Lateral — 2×10 yardas c/dirección",
                "Saltos Laterales en Una Pierna — 4×4 saltos ida y vuelta"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 3×10","1.B. Jalones de Cara — 3×12"]},
              {title:"Construcción", items:[
                "1. Press de Banca con Mancuernas — 3×12","2. Dominadas — 3×Máximo",
                "3. Elevaciones Laterales — 3×12","4.A. Curl con Barra — 3×12",
                "4.B. Extensión Tríceps Agarre Inverso — 3×12"
              ]},
              {title:"Core", items:["1. Cobra en Prono — 2×60 seg c/lado"]}
            ]
          },
          {
            id:"eva-f1w1d4", name:"Día 4", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Velocidad Máxima — CAD Lateral", items:[
                "Tempo 50's — 8×1","Paso Rápido Carioca — 4×20 yardas c/dirección",
                "Carrera Cruzada — 4×20 yardas c/dirección",
                "Desplazamiento Lateral — 4×10 yardas c/dirección"
              ]},
              {title:"Fuerza", items:["1.A. Sentadilla Frontal — 3×10","1.B. Empuje de Cadera — 3×10"]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna","2. RDL — 3×12",
                "3. Elevación de Puntas con Peso — 3×12"
              ]},
              {title:"Core", items:[
                "1. Plancha — 1×60 seg","2. Plancha Lateral — 1×60 seg c/lado",
                "3. Cobra en Prono — 1×60 seg c/lado"
              ]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 50 yardas)"]}
            ]
          }
        ]
      },
      {
        id:"eva-f1w2", name:"Semana 2", label:"Adaptación",
        days:[
          {
            id:"eva-f1w2d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla — 2×10 seg",
                "Skips de Potencia — 4×20 yardas (2 altura | 2 distancia)",
                "Saltos de Zancada — 4×20 yardas (2 altura | 2 distancia)"
              ]},
              {title:"Fuerza", items:["1.A. Press de Banca — 3×8","1.B. Jalones de Banda — 3×15"]},
              {title:"Construcción", items:[
                "1. Press Neutro Mancuernas Inclinado — 3×12","2. Remo con Barra — 3×12",
                "3. Press Militar — 3×12","4.A. Extensión Tríceps Polea — 3×12","4.B. Curl Martillo — 3×12"
              ]},
              {title:"Core", items:["1. Plancha — 2×60 seg"]}
            ]
          },
          {
            id:"eva-f1w2d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración — CAD Lineal", items:[
                "Salidas 2 Puntos — 4×1 (sprint 10 yardas, desacelerar 10 yardas)",
                "Salidas 2 Puntos — 4×1 (5 sprint, 5 trote, 5 sprint)",
                "Para y Avanza 2 Puntos — 4×1 (parar cada 5 yardas en 20 yardas)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Barra Trapecio (agarre bajo) — 3×8",
                "1.B. Caminata Monster — 3×10 yardas (adelante y atrás)"
              ]},
              {title:"Construcción", items:[
                "1. Escalones con Mancuernas — 3×10 c/pierna",
                "2. Curl Isquiotibiales — 3×12","3. Elevación de Talones — 3×12"
              ]},
              {title:"Core", items:["1. Plancha Lateral — 2×30 seg c/lado"]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 25 yardas)"]}
            ]
          },
          {
            id:"eva-f1w2d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Fundamentos", items:[
                "Saltos Pogo — 2×10 seg","Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos de Línea — 2×10 seg","Saltos de Línea Laterales — 2×10 seg",
                "Saltos con Sentadilla Lateral — 2×10 yardas c/dirección",
                "Saltos Laterales en Una Pierna — 4×4 saltos ida y vuelta"
              ]},
              {title:"Fuerza", items:["1.A. Press en Suelo — 3×8","1.B. Jalones de Cara — 3×12"]},
              {title:"Construcción", items:[
                "1. Press de Banca con Mancuernas — 3×12","2. Dominadas — 3×Máximo",
                "3. Elevaciones Laterales — 3×12","4.A. Curl con Barra — 3×12",
                "4.B. Extensión Tríceps Agarre Inverso — 3×12"
              ]},
              {title:"Core", items:["1. Cobra en Prono — 2×60 seg c/lado"]}
            ]
          },
          {
            id:"eva-f1w2d4", name:"Día 4", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Velocidad Máxima — CAD Lateral", items:[
                "Tempo 50's — 8×1","Paso Rápido Carioca — 4×20 yardas c/dirección",
                "Carrera Cruzada — 4×20 yardas c/dirección",
                "Desplazamiento Lateral — 4×10 yardas c/dirección"
              ]},
              {title:"Fuerza", items:["1.A. Sentadilla Frontal — 3×8","1.B. Empuje de Cadera — 3×10"]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna","2. RDL — 3×12",
                "3. Elevación de Puntas con Peso — 3×12"
              ]},
              {title:"Core", items:[
                "1. Plancha — 1×60 seg","2. Plancha Lateral — 1×60 seg c/lado",
                "3. Cobra en Prono — 1×60 seg c/lado"
              ]},
              {title:"Acondicionamiento", items:["1. Lanzadera 300 Yardas — 1×1 (giro en 50 yardas)"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"eva-f2", name:"FASE 2", label:"Acumulación", accent:"#E8003D",
    weeks:[
      {
        id:"eva-f2w1", name:"Semana 3", label:"Activación",
        days:[
          {
            id:"eva-f2w1d1", name:"Día 1", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Dividida Iso-Extrema — 1×2min c/lado",
                "Sentadilla Dividida Oscilatoria — 4×10seg c/lado",
                "Pogos Estacionarios — 2×10",
                "Pogos Alternos Estacionarios — 2×10 c/pierna",
                "Pogos Estacionarios Una Pierna — 1×10 c/pierna",
                "Saltos de Zancada Alternos — 4×10"
              ]},
              {title:"Fuerza", items:[
                "1A. Press de Banca Iso con Banda — 4×4 @77% [1|5|X]",
                "1B. Deslizamientos de Pared — 4×5"
              ]},
              {title:"Construcción", items:[
                "Dominadas — 3×8",
                "Press Landmine en Semi-Arrodillado — 3×8 c/lado",
                "Extensión de Tríceps en Polea — 3×8"
              ]},
              {title:"Core", items:["Revolver el Caldero con Balón Suizo — 3×8 c/dirección"]}
            ]
          },
          {
            id:"eva-f2w1d2", name:"Día 2", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Iso-Extrema — 1×2min",
                "Saltos Sentadilla Baja Oscilatorios — 4×10seg",
                "Saltos Pogo Lineales — 2×10yds",
                "Pogos Lineales Alternos — 2×10yds",
                "Pogos Lineales Una Pierna — 2×10yds",
                "Saltos con Sentadilla — 4×10"
              ]},
              {title:"Fuerza", items:[
                "1A. Sentadilla Trasera Iso con Banda — 4×4 @77% [1|5|X]",
                "1B. Caminata Monster — 4×10yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Mancuernas (talón elevado) — 3×8 c/pierna",
                "RDL con Mancuernas — 3×8",
                "Curl Nórdico Isquiotibiales Iso-Extremo — 3×5 (5seg on | 5 off)"
              ]},
              {title:"Core", items:["Cargada Maletín — 3×20yds"]}
            ]
          },
          {
            id:"eva-f2w1d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Búlgara Iso-Extrema — 1×2min c/lado",
                "Sentadilla Búlgara Oscilatoria — 4×10seg",
                "Pogos Lineales — 2×10yds",
                "Skips de Potencia — 4×20yds (vertical)",
                "Salto a Caja Una Pierna Nivel Bajo — 6×1 c/lado (aterrizar en 2)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press en Suelo — 4×4",
                "1B. Jalones de Cara con Banda — 4×5",
                "2. Isométricos Superadores Press de Banca — 3×5seg"
              ]},
              {title:"Construcción", items:[
                "Remo a Un Brazo — 3×8 c/brazo",
                "Elevación Deltoides Posterior Inclinado — 3×8",
                "Curl Martillo con Mancuernas — 3×8"
              ]},
              {title:"Core", items:["Press Pallof — 3×8 c/lado"]}
            ]
          },
          {
            id:"eva-f2w1d4", name:"Día 4", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Sumo Iso-Extrema — 1×2min",
                "Saltos Sentadilla Baja Oscilatorios — 4×10seg",
                "Pogos Estacionarios — 2×10seg",
                "Saltos de Potencia — 4×20yds (vertical)",
                "Saltos a Caja Nivel Bajo — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio (Agarre Bajo) — 4×4",
                "1B. Descensos Isométricos — 4×5 c/lado",
                "2. Isométricos Superadores Trap Bar Sentadilla Dividida — 3×5seg c/lado (heel raised)"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara (talón elevado) — 3×8",
                "Zancada Lateral Goblet — 3×8 c/lado",
                "Empuje de Cadera Una Pierna Iso-Extremo — 1×90seg"
              ]},
              {title:"Core", items:["Cobra en Prono — 1×90seg"]}
            ]
          }
        ]
      },
      {
        id:"eva-f2w2", name:"Semana 4", label:"Activación",
        days:[
          {
            id:"eva-f2w2d1", name:"Día 1", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Dividida Iso-Extrema — 1×3min c/lado",
                "Sentadilla Dividida Oscilatoria — 4×10seg c/lado",
                "Pogos Estacionarios — 2×10",
                "Pogos Alternos Estacionarios — 2×10 c/pierna",
                "Pogos Estacionarios Una Pierna — 1×10 c/pierna",
                "Saltos de Zancada Alternos — 4×10"
              ]},
              {title:"Fuerza", items:[
                "1A. Press de Banca Iso con Banda — 5×3 @80% [X|4|X]",
                "1B. Deslizamientos de Pared — 5×5"
              ]},
              {title:"Construcción", items:[
                "Dominadas — 4×6",
                "Press Landmine en Semi-Arrodillado — 4×6 c/lado",
                "Extensión de Tríceps en Polea — 4×6"
              ]},
              {title:"Core", items:["Revolver el Caldero con Balón Suizo — 3×8 c/dirección"]}
            ]
          },
          {
            id:"eva-f2w2d2", name:"Día 2", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Iso-Extrema — 1×3min",
                "Saltos Sentadilla Baja Oscilatorios — 4×10seg",
                "Saltos Pogo Lineales — 2×10yds",
                "Pogos Lineales Alternos — 2×10yds",
                "Pogos Lineales Una Pierna — 2×10yds",
                "Saltos con Sentadilla — 4×10"
              ]},
              {title:"Fuerza", items:[
                "1A. Sentadilla Trasera Iso con Banda — 5×3 @80% [X|4|X]",
                "1B. Caminata Monster — 5×10yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Mancuernas (talón elevado) — 4×6 c/pierna",
                "RDL con Mancuernas — 4×6",
                "Curl Nórdico Isquiotibiales Iso-Extremo — 3×4 (10seg on | 10 off)"
              ]},
              {title:"Core", items:["Cargada Maletín — 3×20yds"]}
            ]
          },
          {
            id:"eva-f2w2d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Búlgara Iso-Extrema — 1×3min c/lado",
                "Sentadilla Búlgara Oscilatoria — 4×10seg",
                "Pogos Lineales — 2×10yds",
                "Skips de Potencia — 4×20yds (vertical)",
                "Salto a Caja Una Pierna Nivel Bajo — 6×1 c/lado (aterrizar en 2)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press en Suelo — 5×3",
                "1B. Jalones de Cara con Banda — 5×5",
                "2. Isométricos Superadores Press de Banca — 3×2 (5seg on | 5 off)"
              ]},
              {title:"Construcción", items:[
                "Remo a Un Brazo — 4×6 c/brazo",
                "Elevación Deltoides Posterior Inclinado — 4×6",
                "Curl Martillo con Mancuernas — 4×6"
              ]},
              {title:"Core", items:["Press Pallof — 3×8 c/lado"]}
            ]
          },
          {
            id:"eva-f2w2d4", name:"Día 4", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Sumo Iso-Extrema — 1×3min",
                "Saltos Sentadilla Baja Oscilatorios — 4×10seg",
                "Pogos Estacionarios — 2×10seg",
                "Saltos de Potencia — 4×20yds (vertical)",
                "Saltos a Caja Nivel Bajo — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio (Agarre Bajo) — 5×3",
                "1B. Descensos Isométricos — 5×5 c/lado",
                "2. Isométricos Superadores Trap Bar Sentadilla Dividida — 3×2 (5seg on | 5 off | heel raised)"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara (talón elevado) — 4×6",
                "Zancada Lateral Goblet — 4×6 c/lado",
                "Empuje de Cadera Una Pierna Iso-Extremo — 1×2min"
              ]},
              {title:"Core", items:["Cobra en Prono — 1×90seg"]}
            ]
          }
        ]
      },
      {
        id:"eva-f2w3", name:"Semana 5", label:"Activación",
        days:[
          {
            id:"eva-f2w3d1", name:"Día 1", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Dividida Iso con Mancuernas — 2×Max Time c/lado",
                "DB Sentadilla Dividida Oscilatoria — 4×10seg",
                "Pogos Estacionarios — 4×10",
                "Pogos Alternos Estacionarios — 4×10 c/pierna",
                "Pogos Estacionarios Una Pierna — 2×10 c/pierna",
                "Saltos de Zancada Alternos — 4×10"
              ]},
              {title:"Fuerza", items:[
                "1A. Press de Banca Iso con Banda — 5×3 @82% [X|4|X]",
                "1B. Deslizamientos de Pared — 5×5"
              ]},
              {title:"Construcción", items:[
                "Dominadas — 4×6",
                "Press Landmine en Semi-Arrodillado — 4×6 c/lado",
                "Extensión de Tríceps en Polea — 4×6"
              ]},
              {title:"Core", items:["Revolver el Caldero con Balón Suizo — 3×8 c/dirección"]}
            ]
          },
          {
            id:"eva-f2w3d2", name:"Día 2", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Iso con Barra — 2×Max Time",
                "Sentadilla Baja Oscilatoria con Barra — 4×10seg",
                "Saltos Pogo Lineales — 4×10yds",
                "Pogos Lineales Alternos — 4×10yds",
                "Pogos Lineales Una Pierna — 2×10yds c/lado",
                "Saltos con Sentadilla — 4×10"
              ]},
              {title:"Fuerza", items:[
                "1A. Sentadilla Trasera Iso con Banda — 5×3 @82% [X|4|X]",
                "1B. Caminata Monster — 5×10yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Mancuernas (talón elevado) — 4×6 c/pierna",
                "RDL con Mancuernas — 4×6",
                "Curl Nórdico Isquiotibiales Iso-Extremo — 3×5 (10seg on | 10 off)"
              ]},
              {title:"Core", items:["Cargada Maletín — 3×20yds"]}
            ]
          },
          {
            id:"eva-f2w3d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Búlgara Iso con Mancuernas — 2×Max Time c/lado",
                "Sentadilla Búlgara Oscilatoria con Mancuernas — 4×10seg",
                "Pogos Lineales — 4×10yds",
                "Skips de Potencia — 4×20yds (vertical)",
                "Salto a Caja Una Pierna — 4×1 c/lado (aterrizar en 2)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press en Suelo — 5×3",
                "1B. Jalones de Cara con Banda — 5×5",
                "2. Isométricos Superadores Press de Banca — 3×10seg"
              ]},
              {title:"Construcción", items:[
                "Remo a Un Brazo — 4×6 c/brazo",
                "Elevación Deltoides Posterior Inclinado — 4×6",
                "Curl Martillo con Mancuernas — 4×6"
              ]},
              {title:"Core", items:["Press Pallof — 3×8 c/lado"]}
            ]
          },
          {
            id:"eva-f2w3d4", name:"Día 4", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Sentadilla Sumo Iso con Barra — 2×Max Time",
                "Sentadilla Sumo Oscilatoria con Barra — 4×10seg",
                "Pogos Estacionarios — 4×10seg",
                "Saltos de Potencia — 4×20yds (vertical)",
                "Saltos a Caja — 8×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio (Agarre Bajo) — 5×3",
                "1B. Descensos Isométricos — 5×5 c/lado",
                "2. Isométricos Superadores Trap Bar Sentadilla Dividida — 3×10seg c/lado (heel raised)"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara (talón elevado) — 4×6",
                "Zancada Lateral Goblet — 4×6 c/lado",
                "Empuje de Cadera Una Pierna Iso-Extremo — 1×2min"
              ]},
              {title:"Core", items:["Cobra en Prono — 1×90seg"]}
            ]
          }
        ]
      },
      {
        id:"eva-f2deload", name:"Semana 6", label:"Descarga",
        days:[
          {
            id:"eva-f2dld1", name:"Día 1", label:"Potencia · Fuerza · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Pogos Estacionarios — 4×10seg",
                "Saltos de Zancada Alternos — 4×10seg"
              ]},
              {title:"Fuerza", items:[
                "Press de Banca — 5×5 @50% [1|1|1]",
                "Deslizamientos de Pared — 5×5"
              ]},
              {title:"Construcción", items:[
                "Dominadas — 5×5",
                "Press Landmine en Semi-Arrodillado — 5×5 c/lado",
                "Extensión de Tríceps en Polea — 3×8"
              ]},
              {title:"Core", items:["Revolver el Caldero con Balón Suizo — 3×8 c/dirección"]}
            ]
          },
          {
            id:"eva-f2dld2", name:"Día 2", label:"Potencia · Fuerza · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Saltos Pogo Lineales — 4×10yds",
                "Saltos con Sentadilla — 4×10"
              ]},
              {title:"Fuerza", items:[
                "Sentadilla Trasera — 5×5 @50% [1|1|1]",
                "Caminata Monster — 5×10yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Mancuernas (talón elevado) — 5×5 c/pierna",
                "RDL con Mancuernas — 5×5",
                "Curl Nórdico Isquiotibiales — 5×5"
              ]},
              {title:"Core", items:["Cargada Maletín — 3×20yds"]}
            ]
          },
          {
            id:"eva-f2dld3", name:"Día 3", label:"Potencia · Fuerza · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Pogos Lineales — 4×10yds",
                "Skips de Potencia — 4×20yds"
              ]},
              {title:"Fuerza", items:[
                "Press en Suelo — 5×5 @50% [1|1|1]",
                "Jalones de Cara con Banda — 5×5"
              ]},
              {title:"Construcción", items:[
                "Remo a Un Brazo — 5×5 c/brazo",
                "Elevación Deltoides Posterior Inclinado — 5×5",
                "Curl Martillo con Mancuernas — 5×5"
              ]},
              {title:"Core", items:["Press Pallof — 3×8 c/lado"]}
            ]
          },
          {
            id:"eva-f2dld4", name:"Día 4", label:"Potencia · Fuerza · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:[
                "Pogos Estacionarios — 4×10seg",
                "Saltos a Caja — 10×1"
              ]},
              {title:"Fuerza", items:[
                "Peso Muerto Barra Trapecio — 5×5 @50% [1|1|1]",
                "Descensos Isométricos — 5×2 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara (talón elevado) — 5×5",
                "Zancada Lateral Goblet — 5×5 c/lado",
                "Empuje de Cadera Una Pierna — 5×5 c/lado"
              ]},
              {title:"Core", items:["Cobra en Prono — 1×90seg"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"eva-f3", name:"FASE 3", label:"Transmutación", accent:"#00C9FF",
    weeks:[
      {
        id:"eva-f3w1", name:"Semana 7", label:"Absorción",
        days:[
          {
            id:"eva-f3w1d1", name:"Día 1", label:"Unilateral · Fuerza Excéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "DB Saltos Pogo Alternos Estacionarios — 2×10seg (Light)",
                "DB Saltos de Zancada Alternos — 2×10 (Light)",
                "Caídas Una Pierna — 4×1 c/pierna",
                "Escalones de Velocista con Desaceleración — 4×4 c/lado",
                "Zancadas Rusas — 4×4 c/lado",
                "Zancadas Rusas de Velocidad — 4×4 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1A. Eccentric Band Press de Banca — 5×4 @75% [6|X|X]",
                "1B. Blackburns en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Jalones Agarre Neutro — 3×8",
                "Press Landmine — 3×8 c/lado",
                "Extensión Tríceps Rodante con Mancuernas — 3×8"
              ]},
              {title:"Core", items:["Rueda Abdominal — 3×12"]}
            ]
          },
          {
            id:"eva-f3w1d2", name:"Día 2", label:"Bilateral · Fuerza Excéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "DB Pogos Estacionarios — 2×10seg (Light)",
                "DB Saltos con Sentadilla — 2×10 (Light)",
                "Caídas — 8×1",
                "Caídas en Profundidad — 8×1",
                "Saltos Sentadilla Baja a Vertical — 8×1 (2 bajos + 1 vertical)"
              ]},
              {title:"Fuerza", items:[
                "1A. Eccentric Band Sentadilla Trasera — 5×4 @75% [6|X|X]",
                "1B. Puente Glúteo con Banda y Abducción — 5×5"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa Elevada con Mancuernas — 3×8 c/pierna [2|X|X]",
                "RDL con Barra — 3×8 [2|X|X]",
                "Curl Nórdico Isquiotibiales — 6×2 (Max Excéntrico)"
              ]},
              {title:"Core", items:["Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3w1d3", name:"Día 3", label:"Unilateral · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "DB Pogos Lineales — 2×10yds c/lado (Light)",
                "Skips de Potencia — 4×20yds",
                "Eccentric Salto a Caja Una Piernas — 4×1 c/lado [3|X|X]",
                "Escalones de Velocista Alternos — 4×4 c/lado",
                "Saltos de Sentadilla Búlgara — 4×4 c/lado",
                "Salto Tuck con Aproximación a Aterrizaje Zancada — 4×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1A. Press de Banca Larsen — 5×4",
                "1B. Jalón de Cara con Rotación Externa con Banda — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo en Banco Inclinado — 3×8",
                "Arrancada con Banda — 3×8",
                "Curl Martillo Inclinado con Mancuernas — 3×8"
              ]},
              {title:"Core", items:["Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3w1d4", name:"Día 4", label:"Bilateral · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "DB Pogos Estacionarios — 2×10 (Light)",
                "Saltos de Potencia — 4×20yds",
                "Eccentric Saltos a Caja — 8×1 [3|X|X]",
                "Caídas en Profundidad — 8×1",
                "Salto Tuck con Aproximación a Aterrizaje Sentadilla Baja — 8×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio — 5×4",
                "1B. Escalones con Desaceleración — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara — 3×8 [3|X|X]",
                "Zancada Lateral Goblet — 3×8 c/lado",
                "Empuje de Cadera Una Pierna con Peso — 3×8 c/lado"
              ]},
              {title:"Core", items:["Hiperextensiones — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"eva-f3w2", name:"Semana 8", label:"Absorción",
        days:[
          {
            id:"eva-f3w2d1", name:"Día 1", label:"Unilateral · Fuerza Excéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "DB Saltos Pogo Alternos Estacionarios — 2×10seg (+2-5 lbs)",
                "DB Saltos de Zancada Alternos — 2×10 (+2-5 lbs)",
                "Caídas Una Pierna — 4×1 c/pierna",
                "Escalones de Velocista con Desaceleración — 4×4 c/lado",
                "Zancadas Rusas — 6×4 c/lado",
                "Zancadas Rusas de Velocidad — 6×4 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1A. Eccentric Band Press de Banca — 5×3 @80% [6|X|X]",
                "1B. Blackburns en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Jalones Agarre Neutro — 4×6",
                "Press Landmine — 4×6 c/lado",
                "Extensión Tríceps Rodante con Mancuernas — 4×6"
              ]},
              {title:"Core", items:["Rueda Abdominal — 3×12"]}
            ]
          },
          {
            id:"eva-f3w2d2", name:"Día 2", label:"Bilateral · Fuerza Excéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "DB Pogos Estacionarios — 2×10seg (+2-5 lbs)",
                "DB Saltos con Sentadilla — 2×10 (+2-5 lbs)",
                "Caídas — 8×1",
                "Caídas en Profundidad — 10×1 (+4 pulgadas)",
                "Saltos Sentadilla Baja a Vertical — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Eccentric Band Sentadilla Trasera — 5×3 @80% [6|X|X]",
                "1B. Puente Glúteo con Banda y Abducción — 5×5"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa Elevada con Mancuernas — 4×6 c/pierna [3|X|X]",
                "RDL con Barra — 4×6 [3|X|X]",
                "Curl Nórdico Isquiotibiales — 4×4 (Max Excéntrico)"
              ]},
              {title:"Core", items:["Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3w2d3", name:"Día 3", label:"Unilateral · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "DB Pogos Lineales — 2×10yds c/lado (+2-5 lbs)",
                "Skips de Potencia — 4×20yds",
                "Eccentric Salto a Caja Una Piernas — 4×1 c/lado [3|X|X]",
                "Escalones de Velocista Alternos — 4×4 c/lado",
                "Saltos de Sentadilla Búlgara — 4×4 c/lado",
                "Salto Tuck con Aproximación a Aterrizaje Zancada — 6×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1A. Press de Banca Larsen — 5×3",
                "1B. Jalón de Cara con Rotación Externa con Banda — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo en Banco Inclinado — 4×6",
                "Arrancada con Banda — 4×6",
                "Curl Martillo Inclinado con Mancuernas — 4×6"
              ]},
              {title:"Core", items:["Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3w2d4", name:"Día 4", label:"Bilateral · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "DB Pogos Estacionarios — 2×10 (+2-5 lbs)",
                "Saltos de Potencia — 4×20yds",
                "Eccentric Saltos a Caja — 8×1 [3|X|X]",
                "Caídas en Profundidad — 10×1 (+4 pulgadas)",
                "Salto Tuck con Aproximación a Aterrizaje Sentadilla Baja — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio — 5×3",
                "1B. Escalones con Desaceleración — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara — 4×6 [3|X|X]",
                "Zancada Lateral Goblet — 4×6 c/lado",
                "Empuje de Cadera Una Pierna con Peso — 4×6 c/lado"
              ]},
              {title:"Core", items:["Hiperextensiones — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"eva-f3w3", name:"Semana 9", label:"Absorción",
        days:[
          {
            id:"eva-f3w3d1", name:"Día 1", label:"Unilateral · Fuerza Excéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "DB Saltos Pogo Alternos Estacionarios — 2×10seg (+2-5 lbs)",
                "DB Saltos de Zancada Alternos — 2×10 (+2-5 lbs)",
                "Caídas Una Pierna — 4×1 c/pierna",
                "Escalones de Velocista con Desaceleración — 4×4 c/lado",
                "Zancadas Rusas — 8×2 c/lado",
                "Zancadas Rusas de Velocidad — 8×2 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1A. Eccentric Band Press de Banca — 5×2 @85% [6|X|X]",
                "1B. Blackburns en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Jalones Agarre Neutro — 5×5",
                "Press Landmine — 5×5 c/lado",
                "Extensión Tríceps Rodante con Mancuernas — 5×5"
              ]},
              {title:"Core", items:["Rueda Abdominal — 3×12"]}
            ]
          },
          {
            id:"eva-f3w3d2", name:"Día 2", label:"Bilateral · Fuerza Excéntrica",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "DB Pogos Estacionarios — 2×10seg (+2-5 lbs)",
                "DB Saltos con Sentadilla — 2×10 (+2-5 lbs)",
                "Caídas — 8×1",
                "Caídas en Profundidad — 12×1 (+4 pulgadas)",
                "Saltos Sentadilla Baja a Vertical — 12×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Eccentric Band Sentadilla Trasera — 5×2 @85% [6|X|X]",
                "1B. Puente Glúteo con Banda y Abducción — 5×5"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa Elevada con Mancuernas — 5×5 c/pierna [4|X|X]",
                "RDL con Barra — 5×5 [4|X|X]",
                "Curl Nórdico Isquiotibiales — 5×5 (Max Excéntrico)"
              ]},
              {title:"Core", items:["Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3w3d3", name:"Día 3", label:"Unilateral · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "DB Pogos Lineales — 2×10yds c/lado (+2-5 lbs)",
                "Skips de Potencia — 4×20yds",
                "Eccentric Salto a Caja Una Piernas — 4×1 c/lado [3|X|X]",
                "Escalones de Velocista Alternos — 8×2 c/lado",
                "Saltos de Sentadilla Búlgara — 8×2 c/lado",
                "Salto Tuck con Aproximación a Aterrizaje Zancada — 8×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1A. Press de Banca Larsen — 5×2",
                "1B. Jalón de Cara con Rotación Externa con Banda — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo en Banco Inclinado — 5×5",
                "Arrancada con Banda — 5×5",
                "Curl Martillo Inclinado con Mancuernas — 5×5"
              ]},
              {title:"Core", items:["Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3w3d4", name:"Día 4", label:"Bilateral · Fuerza Absoluta",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "DB Pogos Estacionarios — 2×10 (+2-5 lbs)",
                "Saltos de Potencia — 4×20yds",
                "Eccentric Saltos a Caja — 8×1 [3|X|X]",
                "Caídas en Profundidad — 12×1 (+4 pulgadas)",
                "Salto Tuck con Aproximación a Aterrizaje Sentadilla Baja — 12×1"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio — 5×2",
                "1B. Escalones con Desaceleración — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara — 5×5 [3|X|X]",
                "Zancada Lateral Goblet — 5×5 c/lado",
                "Empuje de Cadera Una Pierna con Peso — 5×5 c/lado"
              ]},
              {title:"Core", items:["Hiperextensiones — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"eva-f3deload", name:"Semana 10", label:"Descarga",
        days:[
          {
            id:"eva-f3dld1", name:"Día 1", label:"Unilateral · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Saltos Pogo Alternos Estacionarios — 2×10seg",
                "Saltos de Zancada Alternos — 2×10",
                "Caídas Una Pierna — 4×1 c/pierna",
                "Escalones de Velocista con Desaceleración — 4×4 c/lado",
                "Salto a Caja Una Piernas — 4×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "Press de Banca — 5×5 @50%",
                "Blackburns en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Jalones Agarre Neutro — 3×8",
                "Press Landmine — 3×8 c/lado",
                "Extensión Tríceps Rodante con Mancuernas — 3×8"
              ]},
              {title:"Core", items:["Rueda Abdominal — 3×12"]}
            ]
          },
          {
            id:"eva-f3dld2", name:"Día 2", label:"Bilateral · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Estacionarios — 2×10seg",
                "Saltos con Sentadilla — 2×10",
                "Caídas — 4×1",
                "Saltos a Caja — 12×1"
              ]},
              {title:"Fuerza", items:[
                "Sentadilla Trasera — 5×5 @50%",
                "Puente Glúteo con Banda y Abducción — 5×5"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa Elevada con Mancuernas — 3×8 c/pierna",
                "RDL con Barra — 3×8",
                "Curl Nórdico Isquiotibiales — 3×8"
              ]},
              {title:"Core", items:["Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3dld3", name:"Día 3", label:"Unilateral · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Pogos Lineales — 2×10yds c/lado",
                "Skips de Potencia — 4×20yds",
                "Escalones de Velocista Alternos — 4×4 c/lado",
                "Saltos de Sentadilla Búlgara — 4×4 c/lado"
              ]},
              {title:"Fuerza", items:[
                "Press de Banca Larsen — 5×5 @50%",
                "Jalón de Cara con Rotación Externa con Banda — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo en Banco Inclinado — 3×8",
                "Arrancada con Banda — 3×8",
                "Curl Martillo Inclinado con Mancuernas — 3×8"
              ]},
              {title:"Core", items:["Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"eva-f3dld4", name:"Día 4", label:"Bilateral · Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Estacionarios — 2×10seg",
                "Saltos de Potencia — 4×20yds",
                "Saltos a Caja — 12×1"
              ]},
              {title:"Fuerza", items:[
                "Peso Muerto Barra Trapecio — 5×5 @50%",
                "Escalones con Desaceleración — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara — 3×8 c/pierna",
                "Zancada Lateral Goblet — 3×8 c/lado",
                "Empuje de Cadera Una Pierna con Peso — 3×8 c/lado"
              ]},
              {title:"Core", items:["Hiperextensiones — 3×20"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"eva-f4", name:"FASE 4", label:"Realización", accent:"#7B61FF",
    weeks:[
      {
        id:"eva-f4w1", name:"Semana 11", label:"Propulsión",
        days:[
          {
            id:"eva-f4w1d1", name:"Día 1", label:"Unilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Saltos Pogo Alternos Estacionarios Asistidos con Banda — 4×10",
                "Saltos de Zancada Alternos Asistidos con Banda — 4×10",
                "Lanzamientos en Escalón de Velocista — 8×1 c/lado",
                "Lanzamiento de Balón en Escalón de Velocista — 8×1 c/lado",
                "Lanzamiento Vertical de Balón Medicinal en Posición Escalonada — 8×1 c/lado (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press con Pasador y Banda — 5×4 @60% (Aceleración)",
                "1B. Press Inclinado con Disco — 5×8"
              ]},
              {title:"Construcción", items:[
                "Dominadas con Cuerda o Toalla — 3×8",
                "Press Z con Mancuernas — 3×8",
                "Rompecráneos con Barra EZ — 3×8"
              ]},
              {title:"Core", items:["Elevaciones de Piernas Colgado — 3×20"]}
            ]
          },
          {
            id:"eva-f4w1d2", name:"Día 2", label:"Bilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Pulsantes Estacionarios Asistidos con Banda — 4×10",
                "Saltos con Sentadilla Asistidos con Banda — 4×10",
                "Saltos a Caja Sentado — 8×1",
                "Lanzamiento Vertical de Balón Medicinal Sentado — 8×1",
                "Lanzamiento de Balón Medicinal Hacia Atrás — 8×1 (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Sentadilla en Caja con Banda — 5×4 @60% (Aceleración)",
                "1B. Caminatas de Retroceso Bajo — 5×20yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Barra — 3×8 c/pierna",
                "Jalones desde Rack con Barra — 3×8",
                "Curl Nórdico Isquiotibiales — 3×8"
              ]},
              {title:"Core", items:["Zancadas Maletín — 3×8 pasos c/lado"]}
            ]
          },
          {
            id:"eva-f4w1d3", name:"Día 3", label:"Unilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Pogos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos a Caja en Semi-Arrodillado — 8×1 c/lado",
                "Lanzamiento Vertical en Semi-Arrodillado — 8×1 c/lado",
                "Underhand Lanzamiento Vertical de Balón Medicinal — 8×1 (20-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press en Suelo — 5×4 (Aceleración)",
                "1B. Nadadores en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo Alterno en Banco Inclinado — 3×8 c/brazo",
                "Elevación Deltoides Posterior Inclinado with External Rotation — 3×8",
                "Curl con Barra EZ — 3×8"
              ]},
              {title:"Core", items:["Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"eva-f4w1d4", name:"Día 4", label:"Bilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Estacionarios Asistidos con Banda — 4×10",
                "Saltos Asistidos con Banda — 4×10",
                "Non-CM Saltos a Caja — 8×1",
                "Lanzamiento Vertical Sin Contramovimiento — 8×1",
                "Lanzamiento Vertical de Balón Medicinal — 8×1 (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio — 5×4 (Aceleración)",
                "1B. Extensiones de Rodilla con Banda — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara to Foam — 3×8 c/pierna",
                "Balanceo de Kettlebell — 3×8",
                "Empuje de Cadera con Peso — 3×8"
              ]},
              {title:"Core", items:["Weighted Hiperextensiones — 3×8"]}
            ]
          }
        ]
      },
      {
        id:"eva-f4w2", name:"Semana 12", label:"Propulsión",
        days:[
          {
            id:"eva-f4w2d1", name:"Día 1", label:"Unilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Saltos Pogo Alternos Estacionarios Asistidos con Banda — 4×10",
                "Saltos de Zancada Alternos Asistidos con Banda — 4×10",
                "Lanzamientos en Escalón de Velocista — 8×1 c/lado",
                "Lanzamiento de Balón en Escalón de Velocista — 8×1 c/lado",
                "Lanzamiento Vertical de Balón Medicinal en Posición Escalonada — 8×1 c/lado (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press con Pasador y Banda — 5×3 @70% (Aceleración)",
                "1B. Press Inclinado con Disco — 5×8"
              ]},
              {title:"Construcción", items:[
                "Dominadas con Cuerda o Toalla — 4×6",
                "Press Z con Mancuernas — 4×6",
                "Rompecráneos con Barra EZ — 4×6"
              ]},
              {title:"Core", items:["Elevaciones de Piernas Colgado — 3×20"]}
            ]
          },
          {
            id:"eva-f4w2d2", name:"Día 2", label:"Bilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Pulsantes Estacionarios Asistidos con Banda — 4×10",
                "Saltos con Sentadilla Asistidos con Banda — 4×10",
                "Saltos a Caja Sentado — 8×1",
                "Lanzamiento Vertical de Balón Medicinal Sentado — 8×1",
                "Lanzamiento de Balón Medicinal Hacia Atrás — 8×1 (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Sentadilla en Caja con Banda — 5×3 @70% (Aceleración)",
                "1B. Caminatas de Retroceso Bajo — 5×20yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Barra — 4×6 c/pierna",
                "Jalones desde Rack con Barra — 4×6",
                "Curl Nórdico Isquiotibiales — 4×6"
              ]},
              {title:"Core", items:["Zancadas Maletín — 3×8 pasos c/lado"]}
            ]
          },
          {
            id:"eva-f4w2d3", name:"Día 3", label:"Unilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Pogos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos a Caja en Semi-Arrodillado — 8×1 c/lado",
                "Lanzamiento Vertical en Semi-Arrodillado — 8×1 c/lado",
                "Underhand Lanzamiento Vertical de Balón Medicinal — 8×1 (20-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press en Suelo — 5×3 (Aceleración)",
                "1B. Nadadores en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo Alterno en Banco Inclinado — 4×6 c/brazo",
                "Elevación Deltoides Posterior Inclinado with External Rotation — 4×6",
                "Curl con Barra EZ — 4×6"
              ]},
              {title:"Core", items:["Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"eva-f4w2d4", name:"Día 4", label:"Bilateral · Fuerza Aceleración",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Estacionarios Asistidos con Banda — 4×10",
                "Saltos Asistidos con Banda — 4×10",
                "Non-CM Saltos a Caja — 8×1",
                "Lanzamiento Vertical Sin Contramovimiento — 8×1",
                "Lanzamiento Vertical de Balón Medicinal — 8×1 (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio — 5×3 (Aceleración)",
                "1B. Extensiones de Rodilla con Banda — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara to Foam — 4×6 c/pierna",
                "Balanceo de Kettlebell — 4×6",
                "Empuje de Cadera con Peso — 4×6"
              ]},
              {title:"Core", items:["Weighted Hiperextensiones — 3×8"]}
            ]
          }
        ]
      },
      {
        id:"eva-f4w3", name:"Semana 13", label:"Propulsión",
        days:[
          {
            id:"eva-f4w3d1", name:"Día 1", label:"Unilateral · Fuerza Máxima",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Saltos Pogo Alternos Estacionarios Asistidos con Banda — 4×10",
                "Saltos de Zancada Alternos Asistidos con Banda — 4×10",
                "Lanzamientos en Escalón de Velocista — 8×1 c/lado",
                "Lanzamiento de Balón en Escalón de Velocista — 8×1 c/lado",
                "Lanzamiento Vertical de Balón Medicinal en Posición Escalonada — 8×1 c/lado (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press con Pasador y Banda — 5×2 @80% (Aceleración)",
                "1B. Press Inclinado con Disco — 5×8"
              ]},
              {title:"Construcción", items:[
                "Dominadas con Cuerda o Toalla — 5×5",
                "Press Z con Mancuernas — 5×5",
                "Rompecráneos con Barra EZ — 5×5"
              ]},
              {title:"Core", items:["Elevaciones de Piernas Colgado — 3×20"]}
            ]
          },
          {
            id:"eva-f4w3d2", name:"Día 2", label:"Bilateral · Fuerza Máxima",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Pulsantes Estacionarios Asistidos con Banda — 4×10",
                "Saltos con Sentadilla Asistidos con Banda — 4×10",
                "Saltos a Caja Sentado — 8×1",
                "Lanzamiento Vertical de Balón Medicinal Sentado — 8×1",
                "Lanzamiento de Balón Medicinal Hacia Atrás — 8×1 (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Sentadilla en Caja con Banda — 5×2 @80% (Aceleración)",
                "1B. Caminatas de Retroceso Bajo — 5×20yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Barra — 5×5 c/pierna",
                "Jalones desde Rack con Barra — 5×5",
                "Curl Nórdico Isquiotibiales — 5×5"
              ]},
              {title:"Core", items:["Zancadas Maletín — 3×8 pasos c/lado"]}
            ]
          },
          {
            id:"eva-f4w3d3", name:"Día 3", label:"Unilateral · Fuerza Máxima",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Pogos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos a Caja en Semi-Arrodillado — 8×1 c/lado",
                "Lanzamiento Vertical en Semi-Arrodillado — 8×1 c/lado",
                "Underhand Lanzamiento Vertical de Balón Medicinal — 8×1 (20-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Press en Suelo — 5×2 (Aceleración)",
                "1B. Nadadores en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo Alterno en Banco Inclinado — 5×5 c/brazo",
                "Elevación Deltoides Posterior Inclinado with External Rotation — 5×5",
                "Curl con Barra EZ — 5×5"
              ]},
              {title:"Core", items:["Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"eva-f4w3d4", name:"Día 4", label:"Bilateral · Fuerza Máxima",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Estacionarios Asistidos con Banda — 4×10",
                "Saltos Asistidos con Banda — 4×10",
                "Non-CM Saltos a Caja — 8×1",
                "Lanzamiento Vertical Sin Contramovimiento — 8×1",
                "Lanzamiento Vertical de Balón Medicinal — 8×1 (30-40lbs)"
              ]},
              {title:"Fuerza", items:[
                "1A. Peso Muerto Barra Trapecio — 5×2 (Aceleración)",
                "1B. Extensiones de Rodilla con Banda — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara to Foam — 5×5 c/pierna",
                "Balanceo de Kettlebell — 5×5",
                "Empuje de Cadera con Peso — 5×5"
              ]},
              {title:"Core", items:["Weighted Hiperextensiones — 3×8"]}
            ]
          }
        ]
      },
      {
        id:"eva-f4deload", name:"Semana 14", label:"Descarga",
        days:[
          {
            id:"eva-f4dld1", name:"Día 1", label:"Unilateral · Descarga Final",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Saltos Pogo Alternos Estacionarios Asistidos con Banda — 4×10",
                "Saltos de Zancada Alternos Asistidos con Banda — 4×10",
                "Lanzamientos en Escalón de Velocista — 4×1 c/lado",
                "Lanzamiento de Balón en Escalón de Velocista — 4×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "Press con Pasador y Banda — 5×5 @50%",
                "Press Inclinado con Disco — 5×5"
              ]},
              {title:"Construcción", items:[
                "Dominadas con Cuerda o Toalla — 5×5",
                "Press Z con Mancuernas — 5×5",
                "Rompecráneos con Barra EZ — 5×5"
              ]},
              {title:"Core", items:["Elevaciones de Piernas Colgado — 3×20"]}
            ]
          },
          {
            id:"eva-f4dld2", name:"Día 2", label:"Bilateral · Descarga Final",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Pulsantes Estacionarios Asistidos con Banda — 4×10",
                "Saltos con Sentadilla Asistidos con Banda — 4×10",
                "Saltos a Caja Sentado — 4×1",
                "Lanzamiento de Balón Medicinal Hacia Atrás — 4×1"
              ]},
              {title:"Fuerza", items:[
                "Sentadilla en Caja con Banda — 5×5 @50%",
                "Caminatas de Retroceso Bajo — 5×20yds"
              ]},
              {title:"Construcción", items:[
                "Zancada Inversa con Barra — 5×5 c/pierna",
                "Jalones desde Rack con Barra — 5×5",
                "Curl Nórdico Isquiotibiales — 5×5"
              ]},
              {title:"Core", items:["Zancadas Maletín — 3×8 pasos c/lado"]}
            ]
          },
          {
            id:"eva-f4dld3", name:"Día 3", label:"Unilateral · Descarga Final",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Unilateral", items:[
                "Pogos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos Una Pierna Asistidos con Banda — 2×10 c/lado",
                "Saltos a Caja en Semi-Arrodillado — 4×1 c/lado",
                "Lanzamiento Vertical en Semi-Arrodillado — 4×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "Press en Suelo — 5×5 @50%",
                "Nadadores en Prono — 5×8"
              ]},
              {title:"Construcción", items:[
                "Remo Alterno en Banco Inclinado — 5×5 c/brazo",
                "Elevación Deltoides Posterior Inclinado with External Rotation — 5×5",
                "Curl con Barra EZ — 5×5"
              ]},
              {title:"Core", items:["Corte de Leña en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"eva-f4dld4", name:"Día 4", label:"Bilateral · Descarga Final",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia — Bilateral", items:[
                "Pogos Estacionarios Asistidos con Banda — 4×10",
                "Saltos Asistidos con Banda — 4×10",
                "Non-CM Saltos a Caja — 4×1",
                "Lanzamiento Vertical de Balón Medicinal — 4×1"
              ]},
              {title:"Fuerza", items:[
                "Peso Muerto Barra Trapecio — 5×5 @50%",
                "Extensiones de Rodilla con Banda — 5×5 c/lado"
              ]},
              {title:"Construcción", items:[
                "Sentadilla Búlgara to Foam — 5×5 c/pierna",
                "Balanceo de Kettlebell — 5×5",
                "Empuje de Cadera con Peso — 5×5"
              ]},
              {title:"Core", items:["Weighted Hiperextensiones — 3×8"]}
            ]
          }
        ]
      }
    ]
  }
];

// ── FOOTBALL PERFORMANCE SYSTEM DATA ─────────────────────────────
const FPS_PHASES = [
  // ══════════════════════════════════════════
  // FPS FASE 1 — PREPARACIÓN GENERAL
  // ══════════════════════════════════════════
  {
    id:"fps-p1", name:"FASE 1", label:"Activación", accent:"#FF9500",
    weeks:[
      {
        id:"fps-w1", name:"Semana 1", label:"Activación",
        days:[
          {
            id:"fps-w1d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos en Línea — 2×10 seg",
                "Lateral Saltos en Línea — 2×10 seg",
                "Saltos desde Sentadilla — 2×10 seg",
                "Skips de Potencia — 4×20 yardas (2 altura | 2 distancia)",
                "Zancadas de Potencia — 4×20 yardas (2 altura | 2 distancia)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 3×10",
                "1.B. Apertura con Banda — 3×15 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1. Press Neutro Inclinado con MC — 3×12",
                "2. Remo con Barra — 3×12",
                "3. Press Vertical — 3×12",
                "4.A. Extensión de Tríceps en Polea — 3×12",
                "4.B. Curl Martillo — 3×12"
              ]},
              {title:"Tronco", items:["1. Plancha — 2×60 seg"]}
            ]
          },
          {
            id:"fps-w1d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Carrera Rodillas Altas | Talones a Glúteos — 2×10 yardas c/u",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 4×20 yardas",
                "Salidas de 2 Puntos — 4×10 yardas",
                "Progresiones de Velocidad — 4×20 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar (agarre bajo) — 3×10",
                "1.B. Caminata Monstruo — 3×10 yardas (adelante y atrás) [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1. Subidas al Cajón con MC — 3×10 c/pierna",
                "2. Curl Femoral — 3×12",
                "3. Elevación de Gemelos — 3×12"
              ]},
              {title:"Tronco", items:["1. Plancha Lateral — 2×30 seg c/lado"]}
            ]
          },
          {
            id:"fps-w1d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos en Línea — 2×10 seg",
                "Lateral Saltos en Línea — 2×10 seg",
                "Saltos en Zancada Alternos — 2×10 seg",
                "Saltos de Patinador Ascendentes — 4×10 yardas c/lado"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press en Suelo — 3×10",
                "1.B. Jalones de Cara — 3×12"
              ]},
              {title:"Construcción", items:[
                "1. Press de Banca con MC — 3×12",
                "2. Dominadas — 3×Máx",
                "3. Elevaciones Laterales — 3×12",
                "4.A. Curl con Barra — 3×12",
                "4.B. Extensión de Tríceps Agarre Invertido — 3×12"
              ]},
              {title:"Tronco", items:["1. Cobra en Prono — 2×60 seg c/lado"]}
            ]
          },
          {
            id:"fps-w1d4", name:"Día 4", label:"COD Lateral · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — CDD Lateral", items:[
                "Carioca Paso Rápido — 4×10 yardas c/dirección",
                "Carrera Cruzada — 4×10 yardas c/dirección",
                "Paso Lateral — 4×10 yardas c/dirección",
                "Paso Lateral de Potencia — 4×10 yardas c/dirección",
                "Pro Shuttle — 4×1 c/dirección",
                "L Drill — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Frontal — 3×10",
                "1.B. Puente de Glúteo con Abducción — 3×10"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna",
                "2. RDL — 3×12",
                "3. Caminata de Talones — 3×20 yardas"
              ]},
              {title:"Tronco", items:["1. Circuito Estático de Estabilidad de Tronco con Banda — 2×30 seg c/dirección [BANDA VERDE]"]}
            ]
          }
        ]
      },
      {
        id:"fps-w2", name:"Semana 2", label:"Activación",
        days:[
          {
            id:"fps-w2d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos en Línea — 2×10 seg",
                "Lateral Saltos en Línea — 2×10 seg",
                "Saltos desde Sentadilla — 2×10 seg",
                "Skips de Potencia — 4×20 yardas (2 altura | 2 distancia)",
                "Zancadas de Potencia — 4×20 yardas (2 altura | 2 distancia)"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 3×8",
                "1.B. Apertura con Banda — 3×15 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1. Press Neutro Inclinado con MC — 3×12",
                "2. Remo con Barra — 3×12",
                "3. Press Vertical — 3×12",
                "4.A. Extensión de Tríceps en Polea — 3×12",
                "4.B. Curl Martillo — 3×12"
              ]},
              {title:"Tronco", items:["1. Plancha — 2×60 seg"]}
            ]
          },
          {
            id:"fps-w2d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Carrera Rodillas Altas | Talones a Glúteos — 2×10 yardas c/u",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 4×20 yardas",
                "Salidas de 2 Puntos — 4×10 yardas",
                "Progresiones de Velocidad — 4×20 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar (agarre bajo) — 3×8",
                "1.B. Caminata Monstruo — 3×10 yardas (adelante y atrás) [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1. Subidas al Cajón con MC — 3×10 c/pierna",
                "2. Curl Femoral — 3×12",
                "3. Elevación de Gemelos — 3×12"
              ]},
              {title:"Tronco", items:["1. Plancha Lateral — 2×30 seg c/lado"]}
            ]
          },
          {
            id:"fps-w2d3", name:"Día 3", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos Pogo Laterales — 2×10 yardas c/dirección",
                "Saltos en Línea — 2×10 seg",
                "Lateral Saltos en Línea — 2×10 seg",
                "Saltos en Zancada Alternos — 2×10 seg",
                "Saltos de Patinador Ascendentes — 4×10 yardas c/lado"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press en Suelo — 3×8",
                "1.B. Jalones de Cara — 3×12"
              ]},
              {title:"Construcción", items:[
                "1. Press de Banca con MC — 3×12",
                "2. Dominadas — 3×Máx",
                "3. Elevaciones Laterales — 3×12",
                "4.A. Curl con Barra — 3×12",
                "4.B. Extensión de Tríceps Agarre Invertido — 3×12"
              ]},
              {title:"Tronco", items:["1. Cobra en Prono — 2×60 seg c/lado"]}
            ]
          },
          {
            id:"fps-w2d4", name:"Día 4", label:"COD Lateral · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — CDD Lateral", items:[
                "Carioca Paso Rápido — 4×10 yardas c/dirección",
                "Carrera Cruzada — 4×10 yardas c/dirección",
                "Paso Lateral — 4×10 yardas c/dirección",
                "Paso Lateral de Potencia — 4×10 yardas c/dirección",
                "Pro Shuttle — 4×1 c/dirección",
                "L Drill — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Frontal — 3×8",
                "1.B. Puente de Glúteo con Abducción — 3×10"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Caminando — 3×10 c/pierna",
                "2. RDL — 3×12",
                "3. Caminata de Talones — 3×20 yardas"
              ]},
              {title:"Tronco", items:["1. Circuito Estático de Estabilidad de Tronco con Banda — 2×30 seg c/dirección [BANDA VERDE]"]}
            ]
          }
        ]
      }
    ]
  },
  // ══════════════════════════════════════════
  // FPS FASE 2 — ACUMULACIÓN
  // ══════════════════════════════════════════
  {
    id:"fps-p2", name:"FASE 2", label:"Acumulación", accent:"#E8003D",
    weeks:[
      {
        id:"fps-w3", name:"Semana 3", label:"Acumulación",
        days:[
          {
            id:"fps-w3d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Saltos Pogo Lineales Unilaterales — 1×10 yardas c/pierna",
                "Saltos Pogo Laterales Unilaterales — 1×10 yardas c/pierna (ida y vuelta)",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador — 4×4 c/dirección",
                "Subidas de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Excéntrico — 5×4 [5|1|X]",
                "1.B. Wall Slides — 5×5"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con MC — 3×12",
                "1.B. Remo a Un Brazo — 3×12 c/brazo",
                "2.A. Z Press — 3×12",
                "2.B. Dominadas Agarre Neutro — 3×12",
                "3.A. Extensión de Tríceps con Banda — 3×12 [BANDA VERDE]",
                "3.B. Curl con Barra — 3×12"
              ]},
              {title:"Tronco", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w3d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "B Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas de 4 Direcciones — 2×10 yardas c/dirección",
                "Carreras Tempo — 4×30 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Excéntrica — 5×4 [5|1|X]",
                "1.B. Sentadillas con Hip Circle — 5×8 [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con MC — 3×12 c/pierna",
                "2. RDL Unilateral — 3×12 c/pierna",
                "3. Curl Femoral Nórdico (Tempo) — 3×12"
              ]},
              {title:"Tronco", items:["1. Circuito Dinámico de Estabilidad de Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"fps-w3d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos desde Sentadilla | Saltos en Zancada Alternos — 2×10 seg c/u",
                "Salto al Cajón — 10×1",
                "Lanzamiento de Balón Medicinal de Longitud — 10×1",
                "Lanzamiento de Balón Medicinal Atrás — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×4",
                "1.B. Jalón de Cara con Rotación Externa — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con MC — 3×12",
                "1.B. Remo Inclinado — 3×12",
                "2.A. Press Landmine Semiarrodillado — 3×12 c/brazo",
                "2.B. Jalones al Pecho — 3×12",
                "3.A. Skull Crushers con MC — 3×12",
                "3.B. Curl Martillo — 3×12"
              ]},
              {title:"Tronco", items:["1. Cargada de Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"fps-w3d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×10 yardas c/u",
                "Paso Lateral a Sprint — 2×10 yardas c/dirección",
                "Serie de Desaceleración — 2×20 yardas c/u",
                "Ejercicio de Corte en Y — 4×1 c/dirección",
                "Carrera en Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×4",
                "1.B. Subidas al Cajón Desaceleradas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadillas Búlgaras — 3×12 c/pierna",
                "2. Buenos Días — 3×12",
                "3. Empuje de Cadera Unilateral — 3×12 c/pierna"
              ]},
              {title:"Tronco", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w4", name:"Semana 4", label:"Acumulación",
        days:[
          {
            id:"fps-w4d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Saltos Pogo Lineales Unilaterales — 1×10 yardas c/pierna",
                "Saltos Pogo Laterales Unilaterales — 1×10 yardas c/pierna (ida y vuelta)",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador — 4×4 c/dirección",
                "Subidas de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Excéntrico — 5×3 [4|1|X]",
                "1.B. Wall Slides — 5×5"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con MC — 3×10",
                "1.B. Remo a Un Brazo — 3×10 c/brazo",
                "2.A. Z Press — 3×10",
                "2.B. Dominadas Agarre Neutro — 3×10",
                "3.A. Extensión de Tríceps con Banda — 3×10 [BANDA VERDE]",
                "3.B. Curl con Barra — 3×10"
              ]},
              {title:"Tronco", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w4d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "B Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas de 4 Direcciones — 2×10 yardas c/dirección",
                "Carreras Tempo — 4×40 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Excéntrica — 5×3 [4|1|X]",
                "1.B. Sentadillas con Hip Circle — 5×8 [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con MC — 3×10 c/pierna",
                "2. RDL Unilateral — 3×10 c/pierna",
                "3. Curl Femoral Nórdico (Tempo) — 3×10"
              ]},
              {title:"Tronco", items:["1. Circuito Dinámico de Estabilidad de Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"fps-w4d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos desde Sentadilla | Saltos en Zancada Alternos — 2×10 seg c/u",
                "Salto al Cajón — 10×1",
                "Lanzamiento de Balón Medicinal de Longitud — 10×1",
                "Lanzamiento de Balón Medicinal Atrás — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×3",
                "1.B. Jalón de Cara con Rotación Externa — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con MC — 3×10",
                "1.B. Remo Inclinado — 3×10",
                "2.A. Press Landmine Semiarrodillado — 3×10 c/brazo",
                "2.B. Jalones al Pecho — 3×10",
                "3.A. Skull Crushers con MC — 3×10",
                "3.B. Curl Martillo — 3×10"
              ]},
              {title:"Tronco", items:["1. Cargada de Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"fps-w4d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×10 yardas c/u",
                "Paso Lateral a Sprint — 2×10 yardas c/dirección",
                "Serie de Desaceleración — 2×20 yardas c/u",
                "Ejercicio de Corte en Y — 4×1 c/dirección",
                "Carrera en Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×3",
                "1.B. Subidas al Cajón Desaceleradas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadillas Búlgaras — 3×10 c/pierna",
                "2. Buenos Días — 3×10",
                "3. Empuje de Cadera Unilateral — 3×10 c/pierna"
              ]},
              {title:"Tronco", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w5", name:"Semana 5", label:"Acumulación",
        days:[
          {
            id:"fps-w5d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Saltos Pogo Lineales Unilaterales — 1×10 yardas c/pierna",
                "Saltos Pogo Laterales Unilaterales — 1×10 yardas c/pierna (ida y vuelta)",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador — 4×4 c/dirección",
                "Subidas de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Excéntrico — 5×2 [3|1|X]",
                "1.B. Wall Slides — 5×5"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con MC — 3×8",
                "1.B. Remo a Un Brazo — 3×8 c/brazo",
                "2.A. Z Press — 3×8",
                "2.B. Dominadas Agarre Neutro — 3×8",
                "3.A. Extensión de Tríceps con Banda — 3×8 [BANDA VERDE]",
                "3.B. Curl con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w5d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "B Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas de 4 Direcciones — 2×10 yardas c/dirección",
                "Carreras Tempo — 4×40 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Excéntrica — 5×2 [3|1|X]",
                "1.B. Sentadillas con Hip Circle — 5×8 [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con MC — 3×8 c/pierna",
                "2. RDL Unilateral — 3×8 c/pierna",
                "3. Curl Femoral Nórdico (Tempo) — 3×8"
              ]},
              {title:"Tronco", items:["1. Circuito Dinámico de Estabilidad de Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"fps-w5d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos desde Sentadilla | Saltos en Zancada Alternos — 2×10 seg c/u",
                "Salto al Cajón — 10×1",
                "Lanzamiento de Balón Medicinal de Longitud — 10×1",
                "Lanzamiento de Balón Medicinal Atrás — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×2",
                "1.B. Jalón de Cara con Rotación Externa — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con MC — 3×8",
                "1.B. Remo Inclinado — 3×8",
                "2.A. Press Landmine Semiarrodillado — 3×8 c/brazo",
                "2.B. Jalones al Pecho — 3×8",
                "3.A. Skull Crushers con MC — 3×8",
                "3.B. Curl Martillo — 3×8"
              ]},
              {title:"Tronco", items:["1. Cargada de Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"fps-w5d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×10 yardas c/u",
                "Paso Lateral a Sprint — 2×10 yardas c/dirección",
                "Serie de Desaceleración — 2×20 yardas c/u",
                "Ejercicio de Corte en Y — 4×1 c/dirección",
                "Carrera en Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×2",
                "1.B. Subidas al Cajón Desaceleradas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadillas Búlgaras — 3×8 c/pierna",
                "2. Buenos Días — 3×8",
                "3. Empuje de Cadera Unilateral — 3×8 c/pierna"
              ]},
              {title:"Tronco", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w6", name:"Semana 6", label:"Descarga",
        days:[
          {
            id:"fps-w6d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Saltos Pogo — 2×10 seg | Saltos Pogo Lineales — 2×10 yardas",
                "Saltos Pogo Lineales Unilaterales — 1×10 yardas c/pierna",
                "Saltos Pogo Laterales Unilaterales — 1×10 yardas c/pierna (ida y vuelta)",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador — 4×4 c/dirección",
                "Subidas de Velocista — 4×8 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×5 @50%",
                "1.B. Wall Slides — 5×5"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro con MC — 3×8",
                "1.B. Remo a Un Brazo — 3×8 c/brazo",
                "2.A. Z Press — 3×8",
                "2.B. Dominadas Agarre Neutro — 3×8",
                "3.A. Extensión de Tríceps con Banda — 3×8 [BANDA VERDE]",
                "3.B. Curl con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Insectos Muertos Sentado — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w6d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "B Skips (1 Regular | 1 Potencia) — 2×20 yardas",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas de 4 Direcciones — 2×10 yardas c/dirección",
                "Carreras Tempo — 4×40 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera — 5×5 @50%",
                "1.B. Sentadillas con Hip Circle — 5×8 [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con MC — 3×8 c/pierna",
                "2. RDL Unilateral — 3×8 c/pierna",
                "3. Curl Femoral Nórdico (Tempo) — 3×8"
              ]},
              {title:"Tronco", items:["1. Circuito Dinámico de Estabilidad de Tronco con Banda — 1×20 yardas c/dirección [BANDA VERDE]"]}
            ]
          },
          {
            id:"fps-w6d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo — 2×10 seg",
                "Saltos desde Sentadilla | Saltos en Zancada Alternos — 2×10 seg c/u",
                "Salto al Cajón — 10×1",
                "Lanzamiento de Balón Medicinal de Longitud — 10×1",
                "Lanzamiento de Balón Medicinal Atrás — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×5 @50%",
                "1.B. Jalón de Cara con Rotación Externa — 5×10 [BANDA ROJA]"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Suelo con MC — 3×8",
                "1.B. Remo Inclinado — 3×8",
                "2.A. Press Landmine Semiarrodillado — 3×8 c/brazo",
                "2.B. Jalones al Pecho — 3×8",
                "3.A. Skull Crushers con MC — 3×8",
                "3.B. Curl Martillo — 3×8"
              ]},
              {title:"Tronco", items:["1. Cargada de Maletín — 4×20 yardas c/lado"]}
            ]
          },
          {
            id:"fps-w6d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×10 yardas c/u",
                "Paso Lateral a Sprint — 2×10 yardas c/dirección",
                "Serie de Desaceleración — 2×20 yardas c/u",
                "Ejercicio de Corte en Y — 4×1 c/dirección",
                "Carrera en Arco — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×5 @50%",
                "1.B. Subidas al Cajón Desaceleradas — 5×5 c/pierna"
              ]},
              {title:"Construcción", items:[
                "1. Sentadillas Búlgaras — 3×8 c/pierna",
                "2. Buenos Días — 3×8",
                "3. Empuje de Cadera Unilateral — 3×8 c/pierna"
              ]},
              {title:"Tronco", items:["1. Bird Dogs en Plancha — 3×20"]}
            ]
          }
        ]
      }
    ]
  },
  // ══════════════════════════════════════════
  // FPS FASE 3 — TRANSMUTACIÓN
  // ══════════════════════════════════════════
  {
    id:"fps-p3", name:"FASE 3", label:"Transmutación", accent:"#00C9FF",
    weeks:[
      {
        id:"fps-w7", name:"Semana 7", label:"Transmutación",
        days:[
          {
            id:"fps-w7d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Long. Unilateral a 90° (pierna externa) — 4×1 c/pierna",
                "Salto al Cajón Unilateral (caída bilateral) — 4×1 c/pierna",
                "Salto al Cajón Semiarrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico — 5×4 [1|5|X]",
                "1.B. Blackburns en Prono — 5×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Alternado con MC — 3×12 c/brazo",
                "1.B. Remo Bajo Unilateral con Banda — 3×12 c/brazo [BANDA VERDE]",
                "2.A. Press Vertical Semiarrodillado — 3×12 c/brazo",
                "2.B. Dominadas con Cuerda — 3×12",
                "3.A. Flexiones Agarre Cerrado con Banda — 3×12",
                "3.B. Curl Barra EZ (Agarre Amplio) — 3×12"
              ]},
              {title:"Tronco", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"fps-w7d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas en Caída — 8×10 yardas",
                "Ball Drops — 10×1 (progresar a máx. distancia)",
                "Progresiones de Velocidad — 4×20 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica — 5×4 [1|5|X]",
                "1.B. Almejas Lateral — 5×8 c/lado"
              ]},
              {title:"Construcción", items:[
                "1.A. Zancada Inversa Elevada con MC — 3×12 c/pierna",
                "1.B. Subidas al Cajón Desaceleradas — 3×12 c/pierna",
                "2.A. RDL Agarre Snatch — 3×12",
                "2.B. Curl Femoral Nórdico — 3×12"
              ]},
              {title:"Tronco", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w7d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos desde Sentadilla — 2×10 seg",
                "Salto al Cajón Sentado | Salto con Impulso — 10×1 c/u",
                "Lanzamiento de Balón Medicinal Vertical — 10×1",
                "Serie de Golpeo de Balón Medicinal — 4×1 (Frente y Ambos Lados)",
                "Pase de Pecho con Balón Medicinal en Supino — 3×5"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press en Suelo — 5×4",
                "1.B. Rotaciones Externas Sentado — 5×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Inclinado — 3×12",
                "1.B. Remo Inclinado con MC — 3×12",
                "2.A. Press Landmine — 3×12 c/brazo",
                "2.B. Jalones Agarre Cerrado — 3×12",
                "3.A. Elevación de Deltoides Posterior — 3×12",
                "3.B. Skull Crushers EZ Bar — 3×12",
                "3.C. Curl Martillo Inclinado — 3×12"
              ]},
              {title:"Tronco", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w7d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Shuttle Lateral Corto — 2×1 c/dirección",
                "Shuttle Corto — 2×1 c/dirección",
                "Serie de Desaceleración — 2×1 c/u (6 reps total)",
                "Ejercicio de Corte con Salto — 4×1 c/dirección",
                "Carrera en Círculo — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×4",
                "1.B. Caminata Monstruo — 5×5 yardas (adelante y atrás) [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1.A. Subidas al Cajón con MC — 3×8 c/pierna",
                "1.B. Bajadas Isométricas — 3×12 c/pierna",
                "2.A. Buenos Días con Banda — 3×12 [BANDA VERDE]",
                "2.B. Empuje de Cadera con Barra — 3×12"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w8", name:"Semana 8", label:"Transmutación",
        days:[
          {
            id:"fps-w8d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Long. Unilateral a 90° (pierna externa) — 4×1 c/pierna",
                "Salto al Cajón Unilateral (caída bilateral) — 4×1 c/pierna",
                "Salto al Cajón Semiarrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico — 5×3 [1|4|X]",
                "1.B. Blackburns en Prono — 5×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Alternado con MC — 3×10 c/brazo",
                "1.B. Remo Bajo Unilateral con Banda — 3×10 c/brazo [BANDA VERDE]",
                "2.A. Press Vertical Semiarrodillado — 3×10 c/brazo",
                "2.B. Dominadas con Cuerda — 3×10",
                "3.A. Flexiones Agarre Cerrado con Banda — 3×10",
                "3.B. Curl Barra EZ (Agarre Amplio) — 3×10"
              ]},
              {title:"Tronco", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"fps-w8d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas en Caída — 8×10 yardas",
                "Ball Drops — 10×1 (progresar a máx. distancia)",
                "Progresiones de Velocidad — 4×20 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica — 5×3 [1|4|X]",
                "1.B. Almejas Lateral — 5×8 c/lado"
              ]},
              {title:"Construcción", items:[
                "1.A. Zancada Inversa Elevada con MC — 3×10 c/pierna",
                "1.B. Subidas al Cajón Desaceleradas — 3×10 c/pierna",
                "2.A. RDL Agarre Snatch — 3×10",
                "2.B. Curl Femoral Nórdico — 3×10"
              ]},
              {title:"Tronco", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w8d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos desde Sentadilla — 2×10 seg",
                "Salto al Cajón Sentado | Salto con Impulso — 10×1 c/u",
                "Lanzamiento de Balón Medicinal Vertical — 10×1",
                "Serie de Golpeo de Balón Medicinal — 4×1 (Frente y Ambos Lados)",
                "Pase de Pecho con Balón Medicinal en Supino — 3×5"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press en Suelo — 5×3",
                "1.B. Rotaciones Externas Sentado — 5×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Inclinado — 3×10",
                "1.B. Remo Inclinado con MC — 3×10",
                "2.A. Press Landmine — 3×10 c/brazo",
                "2.B. Jalones Agarre Cerrado — 3×10",
                "3.A. Elevación de Deltoides Posterior — 3×10",
                "3.B. Skull Crushers EZ Bar — 3×10",
                "3.C. Curl Martillo Inclinado — 3×10"
              ]},
              {title:"Tronco", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w8d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Shuttle Lateral Corto — 2×1 c/dirección",
                "Shuttle Corto — 2×1 c/dirección",
                "Serie de Desaceleración — 2×1 c/u (6 reps total)",
                "Ejercicio de Corte con Salto — 4×1 c/dirección",
                "Carrera en Círculo — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×3",
                "1.B. Caminata Monstruo — 5×5 yardas (adelante y atrás) [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1.A. Subidas al Cajón con MC — 3×8 c/pierna",
                "1.B. Bajadas Isométricas — 3×10 c/pierna",
                "2.A. Buenos Días con Banda — 3×10 [BANDA VERDE]",
                "2.B. Empuje de Cadera con Barra — 3×10"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w9", name:"Semana 9", label:"Transmutación",
        days:[
          {
            id:"fps-w9d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Long. Unilateral a 90° (pierna externa) — 4×1 c/pierna",
                "Salto al Cajón Unilateral (caída bilateral) — 4×1 c/pierna",
                "Salto al Cajón Semiarrodillado — 4×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Isométrico — 6×2 [1|3|X]",
                "1.B. Blackburns en Prono — 6×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Alternado con MC — 3×8 c/brazo",
                "1.B. Remo Bajo Unilateral con Banda — 3×8 c/brazo [BANDA VERDE]",
                "2.A. Press Vertical Semiarrodillado — 3×8 c/brazo",
                "2.B. Dominadas con Cuerda — 3×8",
                "3.A. Flexiones Agarre Cerrado con Banda — 3×8",
                "3.B. Curl Barra EZ (Agarre Amplio) — 3×8"
              ]},
              {title:"Tronco", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"fps-w9d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas en Caída — 8×10 yardas",
                "Ball Drops — 10×1 (progresar a máx. distancia)",
                "Progresiones de Velocidad — 4×20 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica — 6×2 [1|3|X]",
                "1.B. Almejas Lateral — 6×8 c/lado"
              ]},
              {title:"Construcción", items:[
                "1.A. Zancada Inversa Elevada con MC — 3×8 c/pierna",
                "1.B. Subidas al Cajón Desaceleradas — 3×8 c/pierna",
                "2.A. RDL Agarre Snatch — 3×8",
                "2.B. Curl Femoral Nórdico — 3×8"
              ]},
              {title:"Tronco", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w9d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos desde Sentadilla — 2×10 seg",
                "Salto al Cajón Sentado | Salto con Impulso — 10×1 c/u",
                "Lanzamiento de Balón Medicinal Vertical — 10×1",
                "Serie de Golpeo de Balón Medicinal — 4×1 (Frente y Ambos Lados)",
                "Pase de Pecho con Balón Medicinal en Supino — 3×5"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press en Suelo — 6×2",
                "1.B. Rotaciones Externas Sentado — 6×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Inclinado — 3×8",
                "1.B. Remo Inclinado con MC — 3×8",
                "2.A. Press Landmine — 3×8 c/brazo",
                "2.B. Jalones Agarre Cerrado — 3×8",
                "3.A. Elevación de Deltoides Posterior — 3×8",
                "3.B. Skull Crushers EZ Bar — 3×8",
                "3.C. Curl Martillo Inclinado — 3×8"
              ]},
              {title:"Tronco", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w9d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Shuttle Lateral Corto — 2×1 c/dirección",
                "Shuttle Corto — 2×1 c/dirección",
                "Serie de Desaceleración — 2×1 c/u (6 reps total)",
                "Ejercicio de Corte con Salto — 4×1 c/dirección",
                "Carrera en Círculo — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 6×2",
                "1.B. Caminata Monstruo — 6×5 yardas (adelante y atrás) [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1.A. Subidas al Cajón con MC — 3×8 c/pierna",
                "1.B. Bajadas Isométricas — 3×8 c/pierna",
                "2.A. Buenos Días con Banda — 3×8 [BANDA VERDE]",
                "2.B. Empuje de Cadera con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w10", name:"Semana 10", label:"Descarga",
        days:[
          {
            id:"fps-w10d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Ascendentes — 2×10 yardas c/dirección",
                "Salto Long. Unilateral a 90° (pierna externa) — 2×1 c/pierna",
                "Salto al Cajón Unilateral (caída bilateral) — 2×1 c/pierna",
                "Salto al Cajón Semiarrodillado — 2×1 c/pierna"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×5 @50%",
                "1.B. Blackburns en Prono — 5×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Neutro Alternado con MC — 3×8 c/brazo",
                "1.B. Remo Bajo Unilateral con Banda — 3×8 c/brazo [BANDA VERDE]",
                "2.A. Press Vertical Semiarrodillado — 3×8 c/brazo",
                "2.B. Dominadas con Cuerda — 3×8",
                "3.A. Flexiones Agarre Cerrado con Banda — 3×8",
                "3.B. Curl Barra EZ (Agarre Amplio) — 3×8"
              ]},
              {title:"Tronco", items:["1. Rueda Abdominal — 3×20"]}
            ]
          },
          {
            id:"fps-w10d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Salidas en Caída — 4×10 yardas",
                "Ball Drops — 6×1 (progresar a máx. distancia)",
                "Progresiones de Velocidad — 4×20 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Isométrica — 5×5 @50%",
                "1.B. Almejas Lateral — 5×8 c/lado"
              ]},
              {title:"Construcción", items:[
                "1.A. Zancada Inversa Elevada con MC — 3×8 c/pierna",
                "1.B. Subidas al Cajón Desaceleradas — 3×8 c/pierna",
                "2.A. RDL Agarre Snatch — 3×8",
                "2.B. Curl Femoral Nórdico — 3×8"
              ]},
              {title:"Tronco", items:["1. Giros Sentado — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w10d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos desde Sentadilla — 2×10 seg",
                "Salto al Cajón Sentado | Salto con Impulso — 6×1 c/u",
                "Lanzamiento de Balón Medicinal Vertical — 6×1",
                "Serie de Golpeo de Balón Medicinal — 4×1 (Frente y Ambos Lados)",
                "Pase de Pecho con Balón Medicinal en Supino — 3×5"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press en Suelo — 5×5 @50%",
                "1.B. Rotaciones Externas Sentado — 5×10"
              ]},
              {title:"Construcción", items:[
                "1.A. Press en Inclinado — 3×8",
                "1.B. Remo Inclinado con MC — 3×8",
                "2.A. Press Landmine — 3×8 c/brazo",
                "2.B. Jalones Agarre Cerrado — 3×8",
                "3.A. Elevación de Deltoides Posterior — 3×8",
                "3.B. Skull Crushers EZ Bar — 3×8",
                "3.C. Curl Martillo Inclinado — 3×8"
              ]},
              {title:"Tronco", items:["1. Elevaciones de Cadera en Plancha Lateral — 3×20 c/lado"]}
            ]
          },
          {
            id:"fps-w10d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Carioca Paso Rápido — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Shuttle Lateral Corto — 2×1 c/dirección",
                "Shuttle Corto — 2×1 c/dirección",
                "Serie de Desaceleración — 2×1 c/u (6 reps total)",
                "Ejercicio de Corte con Salto — 4×1 c/dirección",
                "Carrera en Círculo — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×5 @50%",
                "1.B. Caminata Monstruo — 5×5 yardas (adelante y atrás) [BANDA HIP CIRCLE]"
              ]},
              {title:"Construcción", items:[
                "1.A. Subidas al Cajón con MC — 3×8 c/pierna",
                "1.B. Bajadas Isométricas — 3×8 c/pierna",
                "2.A. Buenos Días con Banda — 3×8 [BANDA VERDE]",
                "2.B. Empuje de Cadera con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones — 3×20"]}
            ]
          }
        ]
      }
    ]
  },
  // ══════════════════════════════════════════
  // FPS FASE 4 — REALIZACIÓN
  // ══════════════════════════════════════════
  {
    id:"fps-p4", name:"FASE 4", label:"Realización", accent:"#7B61FF",
    weeks:[
      {
        id:"fps-w11", name:"Semana 11", label:"Realización",
        days:[
          {
            id:"fps-w11d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Reactivos — 4×4 c/lado",
                "Salto Lateral Unilateral a 90° (pierna externa) — 4×1 c/pierna",
                "Salto al Cajón con Impulso Unilateral (caída bilateral) — 4×1 c/pierna",
                "Triple Salto Unilateral — 4×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Concéntrico — 5×4 [1|1|X]",
                "1.B. Pase de Pecho con Rebote — 5×5 seg (Balón Med. 10 lb)"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Banca a Un Brazo — 3×8 c/brazo",
                "1.B. Remo con Trineo — 3×8",
                "2.A. Push Press — 3×8",
                "2.B. Jalones con Banda — 3×8 c/brazo [BANDA VERDE]",
                "3.A. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]",
                "3.B. Curl con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"fps-w11d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Cicleo Unilateral — 4×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Zancadas Unilaterales — 2×20 yardas",
                "Sprints con Trineo — 10×25 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Concéntrica — 5×4 [1|1|X]",
                "1.B. Doble Salto de Longitud — 5×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 3×8 c/pierna",
                "2. Swing KB con Banda — 3×8 [BANDA NEGRA]",
                "3. Curl Femoral Nórdico — 3×5 (rep completa sin manos)"
              ]},
              {title:"Tronco", items:["1. Leñador en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w11d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos Pogo Lineales — 2×10 yardas",
                "Zancadas de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "Salto al Cajón con Impulso — 10×1",
                "Salto al Cajón con Rebote — 10×1",
                "Lanzamiento por Debajo — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Tabla — 5×4 (2 Tablas)",
                "1.B. Lanzamiento de Long. con Balón Med. Arrodillado — 5×2"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Inclinado con MC — 3×8",
                "1.B. Jalones de Cara en Polea — 3×8",
                "2.A. Jerk con Landmine — 3×8 c/brazo",
                "2.B. Remo Alto con Banda — 3×8 c/brazo [BANDA VERDE]",
                "3.A. Extensión de Tríceps Rodante con MC — 3×8",
                "3.B. Curl Agarre Invertido EZ Bar — 3×8"
              ]},
              {title:"Tronco", items:["1. Giro Ruso de Pie — 3×8 c/lado"]}
            ]
          },
          {
            id:"fps-w11d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Pogos Laterales Unilaterales — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Ejercicio Espejo — 4×5 seg",
                "Paso Lateral a Ball Drop — 4×1",
                "Retroceso a Ball Drop — 4×1",
                "Ejercicio en Figura 8 — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×4",
                "1.B. Salto al Cajón — 5×2"
              ]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 3×8 c/lado",
                "2. Goblet Zancada Lateral — 3×8 c/lado",
                "3. Marcha con Trineo — 3×20 yardas"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones con Carga — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w12", name:"Semana 12", label:"Realización",
        days:[
          {
            id:"fps-w12d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Reactivos — 4×4 c/lado",
                "Salto Lateral Unilateral a 90° (ext. e int.) — 4×1 c/pierna",
                "Salto al Cajón con Impulso Unilateral (caída bilateral) — 4×1 c/pierna",
                "Triple Salto Unilateral — 4×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Concéntrico — 6×2 [X|1|X]",
                "1.B. Pase de Pecho con Rebote — 6×5 seg (Balón Med. 10 lb)"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Banca a Un Brazo — 3×6 c/brazo",
                "1.B. Remo con Trineo — 3×6",
                "2.A. Push Press — 3×6",
                "2.B. Jalones con Banda — 3×6 c/brazo [BANDA VERDE]",
                "3.A. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]",
                "3.B. Curl con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"fps-w12d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Cicleo Unilateral — 4×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Zancadas Unilaterales — 2×20 yardas",
                "Sprints con Trineo — 8×25 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Concéntrica — 6×2 [X|1|X]",
                "1.B. Doble Salto de Longitud — 6×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 3×6 c/pierna",
                "2. Swing KB con Banda — 3×6 [BANDA NEGRA]",
                "3. Curl Femoral Nórdico — 3×5 (rep completa sin manos)"
              ]},
              {title:"Tronco", items:["1. Leñador en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w12d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos Pogo Lineales — 2×10 yardas",
                "Zancadas de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "Salto al Cajón con Impulso — 10×1",
                "Salto al Cajón con Rebote — 10×1",
                "Lanzamiento por Debajo — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Tabla — 6×2 (2 Tablas)",
                "1.B. Lanzamiento de Long. con Balón Med. Arrodillado — 6×2"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Inclinado con MC — 3×6",
                "1.B. Jalones de Cara en Polea — 3×6",
                "2.A. Jerk con Landmine — 3×6 c/brazo",
                "2.B. Remo Alto con Banda — 3×6 c/brazo [BANDA VERDE]",
                "3.A. Extensión de Tríceps Rodante con MC — 3×8",
                "3.B. Curl Agarre Invertido EZ Bar — 3×8"
              ]},
              {title:"Tronco", items:["1. Giro Ruso de Pie — 3×8 c/lado"]}
            ]
          },
          {
            id:"fps-w12d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Pogos Laterales Unilaterales — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Ejercicio Espejo — 4×5 seg",
                "Paso Lateral a Ball Drop — 4×1",
                "Retroceso a Ball Drop — 4×1",
                "Ejercicio en Figura 8 — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 6×2",
                "1.B. Salto al Cajón — 6×2"
              ]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 3×6 c/lado",
                "2. Goblet Zancada Lateral — 3×6 c/lado",
                "3. Marcha con Trineo — 3×20 yardas"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones con Carga — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w13", name:"Semana 13", label:"Realización",
        days:[
          {
            id:"fps-w13d1", name:"Día 1", label:"Pliometría · Fuerza Trifásica · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Reactivos — 4×4 c/lado",
                "Salto Lateral Unilateral a 90° (ext. e int.) — 4×1 c/pierna",
                "Salto al Cajón con Impulso Unilateral (caída bilateral) — 4×1 c/pierna",
                "Triple Salto Unilateral — 4×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca Concéntrico — 8×1 [X|X|X]",
                "1.B. Pase de Pecho con Rebote — 8×5 seg (Balón Med. 10 lb)"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Banca a Un Brazo — 4×4 c/brazo",
                "1.B. Remo con Trineo — 4×4",
                "2.A. Push Press — 4×4",
                "2.B. Jalones con Banda — 4×6 c/brazo [BANDA VERDE]",
                "3.A. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]",
                "3.B. Curl con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"fps-w13d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Cicleo Unilateral — 4×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Zancadas Unilaterales — 2×20 yardas",
                "Sprints con Trineo — 8×25 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera Concéntrica — 8×1 [X|X|X]",
                "1.B. Doble Salto de Longitud — 8×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×4 c/pierna",
                "2. Swing KB con Banda — 4×4 [BANDA NEGRA]",
                "3. Curl Femoral Nórdico — 3×5 (rep completa sin manos)"
              ]},
              {title:"Tronco", items:["1. Leñador en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w13d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos Pogo Lineales — 2×10 yardas",
                "Zancadas de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "Salto al Cajón con Impulso — 10×1",
                "Salto al Cajón con Rebote — 10×1",
                "Lanzamiento por Debajo — 10×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Tabla — 8×1 (2 Tablas)",
                "1.B. Lanzamiento de Long. con Balón Med. Arrodillado — 8×2"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Inclinado con MC — 4×4",
                "1.B. Jalones de Cara en Polea — 4×6",
                "2.A. Jerk con Landmine — 4×4 c/brazo",
                "2.B. Remo Alto con Banda — 4×6 c/brazo [BANDA VERDE]",
                "3.A. Extensión de Tríceps Rodante con MC — 3×8",
                "3.B. Curl Agarre Invertido EZ Bar — 3×8"
              ]},
              {title:"Tronco", items:["1. Giro Ruso de Pie — 3×8 c/lado"]}
            ]
          },
          {
            id:"fps-w13d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Pogos Laterales Unilaterales — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Ejercicio Espejo — 4×5 seg",
                "Paso Lateral a Ball Drop — 4×1",
                "Retroceso a Ball Drop — 4×1",
                "Ejercicio en Figura 8 — 4×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 8×1",
                "1.B. Salto al Cajón — 8×2"
              ]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 4×4 c/lado",
                "2. Goblet Zancada Lateral — 4×4 c/lado",
                "3. Marcha con Trineo — 3×20 yardas"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones con Carga — 3×20"]}
            ]
          }
        ]
      },
      {
        id:"fps-w14", name:"Semana 14", label:"Descarga",
        days:[
          {
            id:"fps-w14d1", name:"Día 1", label:"Pliometría · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Unilateral + CDD", items:[
                "Pogos Lineales Unilaterales | Pogos Laterales — 2×10 yardas c/pierna",
                "Salto de Longitud Unilateral | Salto Lateral Unilateral (caída bilateral) — 2×4 c/pierna",
                "Saltos de Patinador Reactivos — 2×4 c/lado",
                "Salto Lateral Unilateral a 90° (ext. e int.) — 2×1 c/pierna",
                "Salto al Cajón con Impulso Unilateral (caída bilateral) — 2×1 c/pierna",
                "Triple Salto Unilateral — 2×1 c/lado"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca — 5×5 @50%",
                "1.B. Pase de Pecho con Rebote — 5×5 seg (Balón Med. 10 lb)"
              ]},
              {title:"Construcción", items:[
                "1.A. Press de Banca a Un Brazo — 4×4 c/brazo",
                "1.B. Remo con Trineo — 4×4",
                "2.A. Push Press — 4×4",
                "2.B. Jalones con Banda — 4×6 c/brazo [BANDA VERDE]",
                "3.A. Pistones con Banda — 3×8 c/brazo [BANDA MORADA]",
                "3.B. Curl con Barra — 3×8"
              ]},
              {title:"Tronco", items:["1. Abdominales de Velocista — 3×20"]}
            ]
          },
          {
            id:"fps-w14d2", name:"Día 2", label:"Velocidad · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad — Aceleración + Vel. Máxima", items:[
                "Skips de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "A Skips | B Skips — 2×10 yardas c/u",
                "Cicleo Unilateral — 4×10 yardas c/u",
                "Zancadas Pierna Recta | Zancadas Alternas — 2×20 yardas c/u",
                "Zancadas Unilaterales — 2×20 yardas",
                "Sprints con Trineo — 4×25 yardas"
              ]},
              {title:"Fuerza", items:[
                "1.A. Sentadilla Trasera — 5×5 @50%",
                "1.B. Doble Salto de Longitud — 5×1"
              ]},
              {title:"Construcción", items:[
                "1. Zancada Inversa con Barra — 4×4 c/pierna",
                "2. Swing KB con Banda — 4×4 [BANDA NEGRA]",
                "3. Curl Femoral Nórdico — 3×5 (rep completa sin manos)"
              ]},
              {title:"Tronco", items:["1. Leñador en Polea — 3×10 c/lado"]}
            ]
          },
          {
            id:"fps-w14d3", name:"Día 3", label:"Potencia · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Pliometría — Base", items:[
                "Saltos Pogo | Saltos Pogo Lineales — 2×10 yardas",
                "Zancadas de Potencia (2 altura | 2 distancia) — 4×20 yardas",
                "Salto al Cajón con Impulso — 6×1",
                "Salto al Cajón con Rebote — 6×1",
                "Lanzamiento por Debajo — 6×1"
              ]},
              {title:"Fuerza", items:[
                "1.A. Press de Banca con Tabla — 5×5 @50% (2 Tablas)",
                "1.B. Lanzamiento de Long. con Balón Med. Arrodillado — 5×2"
              ]},
              {title:"Construcción", items:[
                "1.A. Press Inclinado con MC — 4×4",
                "1.B. Jalones de Cara en Polea — 4×6",
                "2.A. Jerk con Landmine — 4×4 c/brazo",
                "2.B. Remo Alto con Banda — 4×6 c/brazo [BANDA VERDE]",
                "3.A. Extensión de Tríceps Rodante con MC — 3×8",
                "3.B. Curl Agarre Invertido EZ Bar — 3×8"
              ]},
              {title:"Tronco", items:["1. Giro Ruso de Pie — 3×8 c/lado"]}
            ]
          },
          {
            id:"fps-w14d4", name:"Día 4", label:"Cambio de Dirección · Fuerza · Hipertrofia",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Cambio de Dirección", items:[
                "Pogos Laterales | Pogos Laterales Unilaterales — 2×10 yardas c/dirección",
                "Paso Lateral | Paso Lateral Potencia — 2×20 yardas c/u",
                "Ejercicio Espejo — 2×5 seg",
                "Paso Lateral a Ball Drop — 2×1",
                "Retroceso a Ball Drop — 2×1",
                "Ejercicio en Figura 8 — 2×1 c/dirección"
              ]},
              {title:"Fuerza", items:[
                "1.A. Peso Muerto Trap Bar — 5×5 @50%",
                "1.B. Salto al Cajón — 5×2"
              ]},
              {title:"Construcción", items:[
                "1. Zancada con Giro — 4×4 c/lado",
                "2. Goblet Zancada Lateral — 4×4 c/lado",
                "3. Marcha con Trineo — 3×20 yardas"
              ]},
              {title:"Tronco", items:["1. Hiperextensiones con Carga — 3×20"]}
            ]
          }
        ]
      }
    ]
  }
];


const SAV_PHASES = [
  {
    id:"sav-p1", name:"FASE 1", label:"Preparación", accent:"#E8003D",
    weeks:[
      {
        id:"sav-p1w1", name:"Semana 1", label:"",
        days:[
          {
            id:"sav-p1w1d1", name:"Día 1", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Salidas al suelo - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Peso muerto barra trap - 3 x 3",
                "2. Eccentric Peso muerto barra trap - 2 x 3 [2|X|X]",
                "3. Peso muerto barra trap en cajón - 2 x 5"
              ]},
              {title:"Construcción", items:[
                "1. Zancada inversa elevada - 3 x 10 cada pierna",
                "2. RDL con barra - 3 x 10"
              ]},
              {title:"Core", items:["1. Plancha - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w1d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Salto al cajón - 8 x 1"]},
              {title:"Fuerza", items:[
                "1. Press de banca - 3 x 3",
                "2. Eccentric Press de banca - 2 x 3 [2|X|X]",
                "3. Press con tabla - 2 x 5"
              ]},
              {title:"Construcción", items:[
                "1. Press inclinado - 3 x 10",
                "2. Aperturas inclinadas con mancuernas - 3 x 10",
                "3. Rompe cráneos - 3 x 10",
                "4. Extensión de tríceps - 3 x 10"
              ]}
            ]
          },
          {
            id:"sav-p1w1d3", name:"Día 3", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Pro Shuttle - 3 x 1 cada uno way"]},
              {title:"Fuerza", items:[
                "1. Remo con barra - 3 x 3",
                "2. Eccentric Remo con barra - 2 x 3 [2|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Remo unilateral - 3 x 10 cada uno",
                "2. Face Pull - 3 x 10",
                "3. Curl inverso EZ - 3 x 10",
                "4. Curl martillo - 3 x 10"
              ]},
              {title:"Core", items:["1. Side Plancha - 3 x 30-45 segundos cada lado"]}
            ]
          },
          {
            id:"sav-p1w1d4", name:"Día 4", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Volantes de 20 - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Sentadilla - 3 x 3",
                "2. Eccentric Sentadilla - 2 x 3 [2|X|X]",
                "3. Box Sentadilla - 2 x 5"
              ]},
              {title:"Construcción", items:[
                "1. Zancada caminando - 3 x 10",
                "2. Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Cobra prono - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w1d5", name:"Día 5", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Saltos de longitud - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Press sobre cabeza - 3 x 3",
                "2. Eccentric Press sobre cabeza - 2 x 3 [2|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Elevación lateral - 3 x 10",
                "2. Elevación posterior de hombro - 3 x 10",
                "3. Fondos en paralelas - 3 x 10",
                "4. Overhead Extensión de tríceps - 3 x 10"
              ]},
              {title:"Core", items:["1. Stir the Pot - 3 x 10 cada uno direction"]}
            ]
          },
          {
            id:"sav-p1w1d6", name:"Día 6", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Sprints en círculo - 4 x 1 cada uno way"]},
              {title:"Fuerza", items:[
                "1. Dominadas con peso - 3 x 3",
                "2. Eccentric Remo con barra - 2 x 3 [2|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Jalón agarre ancho - 3 x 10",
                "2. Jalón con brazos rectos - 3 x 10",
                "3. Curl con barra - 3 x 10",
                "4. Curl inclinado - 3 x 10"
              ]},
              {title:"Core", items:["1. L-Sit colgado - 3 x 30-45 segundos"]}
            ]
          }
        ]
      },
      {
        id:"sav-p1w2", name:"Semana 2", label:"",
        days:[
          {
            id:"sav-p1w2d1", name:"Día 1", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Salidas al suelo - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Peso muerto barra trap - 4 x 2",
                "2. Eccentric Peso muerto barra trap - 3 x 2 [3|X|X]",
                "3. Peso muerto barra trap en cajón - 2 x 3"
              ]},
              {title:"Construcción", items:[
                "1. Zancada inversa elevada - 3 x 10 cada pierna",
                "2. RDL con barra - 3 x 10"
              ]},
              {title:"Core", items:["1. Plancha - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w2d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Salto al cajón - 8 x 1"]},
              {title:"Fuerza", items:[
                "1. Press de banca - 4 x 2",
                "2. Eccentric Press de banca - 3 x 2 [3|X|X]",
                "3. Press con tabla - 2 x 3"
              ]},
              {title:"Construcción", items:[
                "1. Press inclinado - 3 x 10",
                "2. Aperturas inclinadas con mancuernas - 3 x 10",
                "3. Rompe cráneos - 3 x 10",
                "4. Extensión de tríceps - 3 x 10"
              ]}
            ]
          },
          {
            id:"sav-p1w2d3", name:"Día 3", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Pro Shuttle - 3 x 1 cada uno way"]},
              {title:"Fuerza", items:[
                "1. Remo con barra - 4 x 2",
                "2. Eccentric Remo con barra - 3 x 2 [3|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Remo unilateral - 3 x 10 cada uno",
                "2. Face Pull - 3 x 10",
                "3. Curl inverso EZ - 3 x 10",
                "4. Curl martillo - 3 x 10"
              ]},
              {title:"Core", items:["1. Side Plancha - 3 x 30-45 segundos cada lado"]}
            ]
          },
          {
            id:"sav-p1w2d4", name:"Día 4", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Volantes de 20 - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Sentadilla - 4 x 2",
                "2. Eccentric Sentadilla - 3 x 2 [3|X|X]",
                "3. Box Sentadilla - 2 x 3"
              ]},
              {title:"Construcción", items:[
                "1. Zancada caminando - 3 x 10",
                "2. Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Cobra prono - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w2d5", name:"Día 5", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Saltos de longitud - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Press sobre cabeza - 4 x 2",
                "2. Eccentric Press sobre cabeza - 3 x 2 [3|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Elevación lateral - 3 x 10",
                "2. Elevación posterior de hombro - 3 x 10",
                "3. Fondos en paralelas - 3 x 10",
                "4. Overhead Extensión de tríceps - 3 x 10"
              ]},
              {title:"Core", items:["1. Stir the Pot - 3 x 10 cada uno direction"]}
            ]
          },
          {
            id:"sav-p1w2d6", name:"Día 6", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Sprints en círculo - 4 x 1 cada uno way"]},
              {title:"Fuerza", items:[
                "1. Dominadas con peso - 4 x 2",
                "2. Eccentric Remo con barra - 3 x 2 [3|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Jalón agarre ancho - 3 x 10",
                "2. Jalón con brazos rectos - 3 x 10",
                "3. Curl con barra - 3 x 10",
                "4. Curl inclinado - 3 x 10"
              ]},
              {title:"Core", items:["1. L-Sit colgado - 3 x 30-45 segundos"]}
            ]
          }
        ]
      },
      {
        id:"sav-p1w3", name:"Semana 3", label:"",
        days:[
          {
            id:"sav-p1w3d1", name:"Día 1", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Salidas al suelo - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Peso muerto barra trap - 5 x 1",
                "2. Eccentric Peso muerto barra trap - 4 x 1 [4|X|X]",
                "3. Peso muerto barra trap en cajón - 2 x 3-5 (mismo peso que la semana pasada)"
              ]},
              {title:"Construcción", items:[
                "1. Zancada inversa elevada - 3 x 10 cada pierna",
                "2. RDL con barra - 3 x 10"
              ]},
              {title:"Core", items:["1. Plancha - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w3d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Salto al cajón - 8 x 1"]},
              {title:"Fuerza", items:[
                "1. Press de banca - 5 x 1",
                "2. Eccentric Press de banca - 4 x 1 [4|X|X]",
                "3. Press con tabla - 2 x 3-5 (mismo peso que la semana pasada)"
              ]},
              {title:"Construcción", items:[
                "1. Press inclinado - 3 x 10",
                "2. Aperturas inclinadas con mancuernas - 3 x 10",
                "3. Rompe cráneos - 3 x 10",
                "4. Extensión de tríceps - 3 x 10"
              ]}
            ]
          },
          {
            id:"sav-p1w3d3", name:"Día 3", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Pro Shuttle - 3 x 1 cada uno way"]},
              {title:"Fuerza", items:[
                "1. Remo con barra - 5 x 1",
                "2. Eccentric Remo con barra - 4 x 1 [4|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Remo unilateral - 3 x 10 cada uno",
                "2. Face Pull - 3 x 10",
                "3. Curl inverso EZ - 3 x 10",
                "4. Curl martillo - 3 x 10"
              ]},
              {title:"Core", items:["1. Side Plancha - 3 x 30-45 segundos cada lado"]}
            ]
          },
          {
            id:"sav-p1w3d4", name:"Día 4", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Volantes de 20 - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Sentadilla - 5 x 1",
                "2. Eccentric Sentadilla - 4 x 1 [4|X|X]",
                "3. Box Sentadilla - 2 x 3-5 (mismo peso que la semana pasada)"
              ]},
              {title:"Construcción", items:[
                "1. Zancada caminando - 3 x 10",
                "2. Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Cobra prono - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w3d5", name:"Día 5", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Saltos de longitud - 6 x 1"]},
              {title:"Fuerza", items:[
                "1. Press sobre cabeza - 5 x 1",
                "2. Eccentric Press sobre cabeza - 4 x 1 [4|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Elevación lateral - 3 x 10",
                "2. Elevación posterior de hombro - 3 x 10",
                "3. Fondos en paralelas - 3 x 10",
                "4. Overhead Extensión de tríceps - 3 x 10"
              ]},
              {title:"Core", items:["1. Stir the Pot - 3 x 10 cada uno direction"]}
            ]
          },
          {
            id:"sav-p1w3d6", name:"Día 6", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Sprints en círculo - 4 x 1 cada uno way"]},
              {title:"Fuerza", items:[
                "1. Dominadas con peso - 5 x 1",
                "2. Eccentric Remo con barra - 4 x 1 [2|X|X]"
              ]},
              {title:"Construcción", items:[
                "1. Jalón agarre ancho - 3 x 10",
                "2. Jalón con brazos rectos - 3 x 10",
                "3. Curl con barra - 3 x 10",
                "4. Curl inclinado - 3 x 10"
              ]},
              {title:"Core", items:["1. L-Sit colgado - 3 x 30-45 segundos"]}
            ]
          }
        ]
      },
      {
        id:"sav-p1w4", name:"Semana 4", label:"Descarga",
        days:[
          {
            id:"sav-p1w4d1", name:"Día 1", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Salidas al suelo - 3 x 1"]},
              {title:"Fuerza", items:["1. Peso muerto barra trap - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Zancada inversa elevada - 3 x 6 cada pierna",
                "2. RDL con barra - 3 x 10"
              ]},
              {title:"Core", items:["1. Plancha - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w4d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Salto al cajón - 4 x 1"]},
              {title:"Fuerza", items:["1. Press de banca - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Press inclinado - 3 x 10",
                "2. Aperturas inclinadas con mancuernas - 3 x 10",
                "3. Rompe cráneos - 3 x 10",
                "4. Extensión de tríceps - 3 x 10"
              ]}
            ]
          },
          {
            id:"sav-p1w4d3", name:"Día 3", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Pro Shuttle - 3 x 1 cada uno way"]},
              {title:"Fuerza", items:["1. Remo con barra - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Remo unilateral - 3 x 10 cada uno",
                "2. Face Pull - 3 x 10",
                "3. Curl inverso EZ - 3 x 10",
                "4. Curl martillo - 3 x 10"
              ]},
              {title:"Core", items:["1. Side Plancha - 3 x 30-45 segundos cada lado"]}
            ]
          },
          {
            id:"sav-p1w4d4", name:"Día 4", label:"Velocidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Velocidad", items:["1. Volantes de 20 - 6 x 1"]},
              {title:"Fuerza", items:["1. Sentadilla - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Zancada caminando - 3 x 10",
                "2. Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Cobra prono - 3 x 45-60 segundos"]}
            ]
          },
          {
            id:"sav-p1w4d5", name:"Día 5", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Potencia", items:["1. Saltos de longitud - 3 x 1"]},
              {title:"Fuerza", items:["1. Press sobre cabeza - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Elevación lateral - 3 x 10",
                "2. Elevación posterior de hombro - 3 x 10",
                "3. Fondos en paralelas - 3 x 10",
                "4. Overhead Extensión de tríceps - 3 x 10"
              ]},
              {title:"Core", items:["1. Stir the Pot - 3 x 10 cada uno direction"]}
            ]
          },
          {
            id:"sav-p1w4d6", name:"Día 6", label:"Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Agilidad", items:["1. Sprints en círculo - 2 x 1 cada uno way"]},
              {title:"Fuerza", items:["1. Dominadas - 5 x 5"]},
              {title:"Construcción", items:[
                "1. Jalón agarre ancho - 3 x 10",
                "2. Jalón con brazos rectos - 3 x 10",
                "3. Curl con barra - 3 x 10",
                "4. Curl inclinado - 3 x 10"
              ]},
              {title:"Core", items:["1. L-Sit colgado - 3 x 30-45 segundos"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"sav-p2", name:"FASE 2", label:"Hipertrofia", accent:"#00C9FF",
    weeks:[
      {
        id:"sav-p2w5", name:"Semana 5", label:"",
        days:[
          {
            id:"sav-p2w5d1", name:"Día 1", label:"Velocidad/Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Rollover Reach - 2 x 10",
                "2. Groiners - 2 x 10",
                "3. Fire Hydrants - 2 x 10 cada uno"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Caída de pelota - 8 x 1",
                "2. Retroceso a sprint - 4 x 1 (10 yardas retroceso | 10 yardas sprint)"
              ]},
              {title:"Fuerza", items:[
                "1. Peso muerto barra trap - 3 x 3",
                "2. Isometric Peso muerto barra trap - 2 x 3 [mantener 5 segundos al paralelo o tirar activamente contra los pins]",
                "3. Peso muerto barra trap en cajón - 1 x Máximo [deja 2 reps en el tanque]"
              ]},
              {title:"Construcción", items:[
                "1. Remo agarre ancho neutro - 3 x 10 | 2 x 3 [SS]",
                "2. Dominadass - 40 Reps",
                "3. Remo inclinado mancuernas - 3 x 10 | 2 x 3 [SS]",
                "4. Curl martillo - 3 x 10 | 2 x 3 [SS]",
                "5. Curl con barras - 3 x 10 | 2 x 3 [SS]"
              ]},
              {title:"Core", items:["1. Hiperextensiones - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w5d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1.A. Passthroughs tumbado - 2 x 10",
                "1.B. Rotación torácica en cuadrupedia - 2 x 10 cada uno",
                "1.C. Y-Cuffs - 2 x 10"
              ]},
              {title:"Potencia", items:[
                "1. Salto con mancuernas - 3 x 10",
                "2. Salto de valla - 10 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Press de banca - 3 x 3",
                "2. Isometric Press de banca - 2 x 3 [mantener 5 segundos codos por debajo del paralelo o contra los pins]",
                "3. Press con tabla - 1 x Máximo [deja 2 en el tanque]"
              ]},
              {title:"Construcción", items:[
                "1. Press inclinado con mancuernas - 3 x 10 | 2 x 3 [SS]",
                "2. Fondos en paralelas - 40 Reps",
                "3. Press agarre cerrado - 3 x 10 | 2 x 3 [SS]",
                "4. OH DB Extensión de tríceps - 3 x 10 | 2 x 3 [SS]",
                "5. Band Extensión de tríceps - 3 x 10 | 2 x 3 [SS]"
              ]},
              {title:"Core", items:["1. Elevaciones de piernas colgado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w5d3", name:"Día 3", label:"Velocidad/Agilidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Estiramiento de rana - 1 x 30 segundos",
                "2. Estiramiento paloma - 1 x 30 segundos cada uno",
                "3. Monster Walks - 2 x 10 yardas"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Circuito velocidad máxima - 1 x 1",
                "2. Mini Pro Shuttle - 4 x 1 (toques alternos de mano)"
              ]},
              {title:"Fuerza", items:[
                "1. Sentadilla - 3 x 3",
                "2. Isometric Sentadilla - 2 x 3 [mantener 5 segundos sentadilla al paralelo o contra los pins]",
                "3. Box Sentadilla - 1 x Máximo [deja 2 en el tanque]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada lateral - 3 x 10 cada lado",
                "2. Arrastre de trineo o swing con kettlebell - 3 x 20 yardas | 3 x 10",
                "3. Swiss Ball Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Rotación rusa sentado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w5d4", name:"Día 4", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Series de movilidad de hombro con banda - 3 x 1 [dislocaciones x 10, separaciones x 10, rotación externa x 10]"
              ]},
              {title:"Potencia", items:[
                "1. Triple salto - 4 x 1",
                "2. Salto vertical reactivo - 4 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Press sobre cabeza - 3 x 3",
                "2. Isometric Press sobre cabeza - 2 x 3 [mantener 5 segundos codos por debajo del paralelo o contra los pins]",
                "3. Press sobre cabeza en suelo - 1 x Máximo [deja 2 en el tanque]"
              ]},
              {title:"Construcción", items:[
                "1. Elevación frontal con disco - 3 x 10 | 2 x 3 [SS]",
                "2. Dump the Buckets - 3 x 10 | 2 x 3 [SS]",
                "3.A. Curl alternos con mancuernas - 3 x 10",
                "3.B. DB Rompe cráneoss - 3 x 10"
              ]},
              {title:"Core", items:["1. Circuito abdominales - 3 x 1 [Abdominales x 20, Elevaciones de cadera x 20, Supermans x 20]"]}
            ]
          }
        ]
      },
      {
        id:"sav-p2w6", name:"Semana 6", label:"",
        days:[
          {
            id:"sav-p2w6d1", name:"Día 1", label:"Velocidad/Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Rollover Reach - 2 x 10",
                "2. Groiners - 2 x 10",
                "3. Fire Hydrants - 2 x 10 cada uno"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Caída de pelota - 8 x 1",
                "2. Circuito retroceso a sprint - 4 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Peso muerto barra trap - 4 x 2",
                "2. Isometric Peso muerto barra trap - 3 x 2 [mantener 5 segundos sobre el paralelo o tirando contra los pins]",
                "3. Peso muerto barra trap en cajón - 1 x Máximo [deja 2 reps en el tanque pero supera la semana anterior]"
              ]},
              {title:"Construcción", items:[
                "1. Remo agarre ancho neutro - 3 x 10 | 2 x 3 [SS]",
                "2. Dominadass - 45 Reps",
                "3. Remo inclinado mancuernas - 3 x 10 | 2 x 3 [SS]",
                "4. Curl martillo - 3 x 10 | 2 x 3 [SS]",
                "5. Curl con barras - 3 x 10 | 2 x 3 [SS]"
              ]},
              {title:"Core", items:["1. Abdominales con peso - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w6d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1.A. Passthroughs tumbado - 2 x 10",
                "1.B. Rotación torácica en cuadrupedia - 2 x 10 cada uno",
                "1.C. Y-Cuffs - 2 x 10"
              ]},
              {title:"Potencia", items:[
                "1. Salto con mancuernas - 3 x 10",
                "2. Salto de valla - 10 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Press de banca - 4 x 2",
                "2. Isometric Press de banca - 3 x 2 [mantener 5 segundos codos al paralelo o contra los pins]",
                "3. Press con tabla - 1 x Máximo [deja 2 en el tanque]"
              ]},
              {title:"Construcción", items:[
                "1. Press inclinado con mancuernas - 3 x 10 | 2 x 3 [SS]",
                "2. Fondos en paralelas - 45 Reps",
                "3. Press agarre cerrado - 3 x 10 | 2 x 3 [SS]",
                "4. OH DB Extensión de tríceps - 3 x 10 | 2 x 3 [SS]",
                "5. Band Extensión de tríceps - 3 x 10 | 2 x 3 [SS]"
              ]},
              {title:"Core", items:["1. Elevaciones de piernas colgado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w6d3", name:"Día 3", label:"Velocidad/Agilidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Estiramiento de rana - 1 x 30 segundos",
                "2. Estiramiento paloma - 1 x 30 segundos cada uno",
                "3. Monster Walks - 2 x 10 yardas"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Circuito velocidad máxima - 1 x 1",
                "2. Mini Pro Shuttle - 4 x 1 (toques alternos de mano)"
              ]},
              {title:"Fuerza", items:[
                "1. Sentadilla - 4 x 2",
                "2. Isometric Sentadilla - 3 x 2 [mantener 5 segundos sentadilla sobre el paralelo o contra los pins]",
                "3. Box Sentadilla - 1 x Máximo [deja 2 en el tanque]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada lateral - 3 x 10 cada lado",
                "2. Arrastre de trineo o swing con kettlebell - 3 x 20 yardas | 3 x 10",
                "3. Swiss Ball Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Rotación rusa sentado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w6d4", name:"Día 4", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Series de movilidad de hombro con banda - 3 x 1 [dislocaciones x 10, separaciones x 10, rotación externa x 10]"
              ]},
              {title:"Potencia", items:[
                "1. Triple salto - 4 x 1",
                "2. Salto vertical reactivo - 4 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Press sobre cabeza - 4 x 2",
                "2. Isometric Press sobre cabeza - 3 x 2 [mantener 5 segundos codos al paralelo o contra los pins]",
                "3. Press sobre cabeza en suelo - 1 x Máximo [deja 2 en el tanque]"
              ]},
              {title:"Construcción", items:[
                "1. Elevación frontal con disco - 3 x 10 | 2 x 3 [SS]",
                "2. Dump the Buckets - 3 x 10 | 2 x 3 [SS]",
                "3.A. Curl alternos con mancuernas - 3 x 10",
                "3.B. DB Rompe cráneoss - 3 x 10"
              ]},
              {title:"Core", items:["1. Circuito abdominales - 3 x 1 [Abdominales x 20, Elevaciones de cadera x 20, Supermans x 20]"]}
            ]
          }
        ]
      },
      {
        id:"sav-p2w7", name:"Semana 7", label:"",
        days:[
          {
            id:"sav-p2w7d1", name:"Día 1", label:"Velocidad/Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Rollover Reach - 2 x 10",
                "2. Groiners - 2 x 10",
                "3. Fire Hydrants - 2 x 10 cada uno"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Caída de pelota - 8 x 1",
                "2. Circuito retroceso a sprint - 4 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Peso muerto barra trap - 5 x 1",
                "2. Isometric Peso muerto barra trap - 4 x 1 [mantener 5 segundos caderas en cuarto de sentadilla o contra los pins]",
                "3. Peso muerto barra trap en cajón - 1 x Máximo [Máximo posible]"
              ]},
              {title:"Construcción", items:[
                "1. Remo agarre ancho neutro - 3 x 10 | 2 x 3 [SS]",
                "2. Dominadass - 50 Reps",
                "3. Remo inclinado mancuernas - 3 x 10 | 2 x 3 [SS]",
                "4. Curl martillo - 3 x 10 | 2 x 3 [SS]",
                "5. Curl con barras - 3 x 10 | 2 x 3 [SS]"
              ]},
              {title:"Core", items:["1. Abdominales con peso - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w7d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1.A. Passthroughs tumbado - 2 x 10",
                "1.B. Rotación torácica en cuadrupedia - 2 x 10 cada uno",
                "1.C. Y-Cuffs - 2 x 10"
              ]},
              {title:"Potencia", items:[
                "1. Salto con mancuernas - 3 x 10",
                "2. Salto de valla - 10 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Press de banca - 5 x 1",
                "2. Isometric Press de banca - 4 x 1 [mantener 5 segundos codos por encima del paralelo o contra los pins]",
                "3. Press con tabla - 1 x Máximo [máximo de repeticiones posibles]"
              ]},
              {title:"Construcción", items:[
                "1. Press inclinado con mancuernas - 3 x 10 | 2 x 3 [SS]",
                "2. Fondos en paralelas - 50 Reps",
                "3. Press agarre cerrado - 3 x 10 | 2 x 3 [SS]",
                "4. OH DB Extensión de tríceps - 3 x 10 | 2 x 3 [SS]",
                "5. Band Extensión de tríceps - 3 x 10 | 2 x 3 [SS]"
              ]},
              {title:"Core", items:["1. Elevaciones de piernas colgado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w7d3", name:"Día 3", label:"Velocidad/Agilidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Estiramiento de rana - 1 x 30 segundos",
                "2. Estiramiento paloma - 1 x 30 segundos cada uno",
                "3. Monster Walks - 2 x 10 yardas"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Circuito velocidad máxima - 1 x 1",
                "2. Mini Pro Shuttle - 4 x 1 (toques alternos de mano)"
              ]},
              {title:"Fuerza", items:[
                "1. Sentadilla - 5 x 1",
                "2. Isometric Sentadilla - 4 x 1 [mantener 5 segundos cuarto de sentadilla o contra los pins]",
                "3. Box Sentadilla - 1 x Máximo [as many as possible]"
              ]},
              {title:"Construcción", items:[
                "1. Zancada lateral - 3 x 10 cada lado",
                "2. Arrastre de trineo o swing con kettlebell - 3 x 20 yardas | 3 x 10",
                "3. Swiss Ball Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Rotación rusa sentado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w7d4", name:"Día 4", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Series de movilidad de hombro con banda - 3 x 1 [dislocaciones x 10, separaciones x 10, rotación externa x 10]"
              ]},
              {title:"Potencia", items:[
                "1. Triple salto - 4 x 1",
                "2. Salto vertical reactivo - 4 x 1"
              ]},
              {title:"Fuerza", items:[
                "1. Press sobre cabeza - 5 x 1",
                "2. Isometric Press sobre cabeza - 4 x 1 [mantener 5 segundos codos por encima del paralelo o contra los pins]",
                "3. Press sobre cabeza en suelo - 1 x Máximo [as many as possible]"
              ]},
              {title:"Construcción", items:[
                "1. Elevación frontal con disco - 3 x 10 | 2 x 3 [SS]",
                "2. Dump the Buckets - 3 x 10 | 2 x 3 [SS]",
                "3.A. Curl alternos con mancuernas - 3 x 10",
                "3.B. DB Rompe cráneoss - 3 x 10"
              ]},
              {title:"Core", items:["1. Circuito abdominales - 3 x 1 [Abdominales x 20, Elevaciones de cadera x 20, Supermans x 20]"]}
            ]
          }
        ]
      },
      {
        id:"sav-p2w8", name:"Semana 8", label:"Descarga",
        days:[
          {
            id:"sav-p2w8d1", name:"Día 1", label:"Velocidad/Agilidad & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Rollover Reach - 2 x 10",
                "2. Groiners - 2 x 10",
                "3. Fire Hydrants - 2 x 10 cada uno"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Caída de pelota - 8 x 1",
                "2. Circuito retroceso a sprint - 4 x 1"
              ]},
              {title:"Fuerza", items:["1. Peso muerto barra trap - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Remo agarre ancho neutro - 3 x 10",
                "2. Dominadass - 30 Reps",
                "3. Remo inclinado mancuernas - 3 x 10",
                "4. Curl martillo - 3 x 10",
                "5. Curl con barras - 3 x 10"
              ]},
              {title:"Core", items:["1. Abdominales con peso - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w8d2", name:"Día 2", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1.A. Passthroughs tumbado - 2 x 10",
                "1.B. Rotación torácica en cuadrupedia - 2 x 10 cada uno",
                "1.C. Y-Cuffs - 2 x 10"
              ]},
              {title:"Potencia", items:[
                "1. Salto con mancuernas - 3 x 10",
                "2. Salto de valla - 10 x 1"
              ]},
              {title:"Fuerza", items:["1. Press de banca - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Press inclinado con mancuernas - 3 x 10",
                "2. Fondos en paralelas - 30 Reps",
                "3. Press agarre cerrado - 3 x 10",
                "4. OH DB Extensión de tríceps - 3 x 10",
                "5. Band Extensión de tríceps - 3 x 10"
              ]},
              {title:"Core", items:["1. Elevaciones de piernas colgado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w8d3", name:"Día 3", label:"Velocidad/Agilidad & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Estiramiento de rana - 1 x 30 segundos",
                "2. Estiramiento paloma - 1 x 30 segundos cada uno",
                "3. Monster Walks - 2 x 10 yardas"
              ]},
              {title:"Velocidad/Agilidad", items:[
                "1. Circuito velocidad máxima - 1 x 1",
                "2. Mini Pro Shuttle - 4 x 1 (toques alternos de mano)"
              ]},
              {title:"Fuerza", items:["1. Sentadilla - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Zancada lateral - 3 x 10 cada lado",
                "2. Arrastre de trineo o swing con kettlebell - 3 x 20 yardas | 3 x 10",
                "3. Swiss Ball Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Rotación rusa sentado - 3 x 20"]}
            ]
          },
          {
            id:"sav-p2w8d4", name:"Día 4", label:"Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Movilización & Activación", items:[
                "1. Series de movilidad de hombro con banda - 3 x 1 [dislocaciones x 10, separaciones x 10, rotación externa x 10]"
              ]},
              {title:"Potencia", items:[
                "1. Triple salto - 4 x 1",
                "2. Salto vertical reactivo - 4 x 1"
              ]},
              {title:"Fuerza", items:["1. Press sobre cabeza - 5 x 5 @50%"]},
              {title:"Construcción", items:[
                "1. Elevación frontal con disco - 3 x 10",
                "2. Dump the Buckets - 3 x 10",
                "3.A. Curl alternos con mancuernas - 3 x 10",
                "3.B. DB Rompe cráneoss - 3 x 10"
              ]},
              {title:"Core", items:["1. Circuito abdominales - 3 x 1 [Abdominales x 20, Elevaciones de cadera x 20, Supermans x 20]"]}
            ]
          }
        ]
      }
    ]
  },
  {
    id:"sav-p3", name:"FASE 3", label:"Potencia", accent:"#7B61FF",
    weeks:[
      {
        id:"sav-p3w9", name:"Semana 9", label:"",
        days:[
          {
            id:"sav-p3w9d1", name:"Día 1", label:"Velocidad, Potencia & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1. Fire Hydrant isométrico - 2 x 10 segundos cada lado",
                "2. Patada atrás isométrica - 2 x 10 segundos cada lado"
              ]},
              {title:"Velocidad", items:["1. Sprint - 6 x 20 yardas [30 segundos rest]"]},
              {title:"Potencia", items:[
                "1.A. Peso muerto barra trap - 6 x 3 [3|1|X | 70 - 80%]",
                "1.B. Bounding - 6 x 1 [10 yardas | 3 enfoque en altura, 3 enfoque en distancia]"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo con barra - 3 x 10 [2|1|2]",
                "1.B. Rope/Towel Dominadas - 3 x Máximo",
                "1.C. Hiperextensiones - 3 x 60 segundos",
                "2.A. Curl inverso EZ - 3 x 10 [2|1|2]",
                "2.B. DB Curl martillo - 3 x 10 [2|1|2]",
                "2.C. Curl inclinado con mancuernas - 3 x 10"
              ]},
              {title:"Core", items:["1. Pikes en balón suizo - 3 x 10"]}
            ]
          },
          {
            id:"sav-p3w9d2", name:"Día 2", label:"Velocidad, Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Y,T,W - 3 x 5 cada uno"]},
              {title:"Velocidad", items:["1. Ejercicio 3 conos - 6 x 1 [30 segundos rest]"]},
              {title:"Potencia", items:[
                "1.A. Press de banca - 6 x 3 [3|1|X | 70 - 80%]",
                "1.B. Lanzamiento de balón medicinal - 6 x 3"
              ]},
              {title:"Construcción", items:[
                "1.A. DB Press de banca - 3 x 10 [2|1|2]",
                "1.B. Hex Press inclinado - 3 x 10 [2|1|2]",
                "1.C. Flexiones abiertas - 3 x 60 segundos",
                "2.A. Rompe cráneoss - 3 x 10 [2|1|2]",
                "2.B. Fondos en paralelas - 3 x Máximo",
                "2.C. Cable Extensión de tríceps - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Press Pallof - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w9d3", name:"Día 3", label:"Velocidad, Potencia & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Monster Walk - 3 x 10 yardas [adelante y atrás]"]},
              {title:"Velocidad", items:["1. Bounding alterno - 6 x 1 [30 yardas]"]},
              {title:"Potencia", items:[
                "1.A. Sentadilla - 6 x 3 [3|1|X | 70 - 80%]",
                "1.B. Salto de valla - 6 x 1"
              ]},
              {title:"Construcción", items:[
                "1.A. Bulgarian Split Sentadilla - 3 x 10",
                "1.B. RDL con mancuernas - 3 x 10",
                "1.C. Curl femoral - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Corte de leña en polea - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w9d4", name:"Día 4", label:"Velocidad, Potencia & Empuje/Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1.A. Wall Slides - 2 x 10",
                "1.B. Rotación externa con disco inclinado - 2 x 10"
              ]},
              {title:"Velocidad", items:["1. Ejercicio en 8 - 6 x 1"]},
              {title:"Potencia", items:[
                "1.A. Press sobre cabeza - 6 x 3 [3|1|X| 70 - 80%]",
                "1.B. Lanzamiento atrás balón medicinal - 6 x 2"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo al mentón - 3 x 10 [2|1|2]",
                "1.B. Dominadas supinas - 3 x Máximo",
                "1.C. Espantapájaros - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Farmer carry unilateral - 3 x 30 yardas cada mano"]}
            ]
          }
        ]
      },
      {
        id:"sav-p3w10", name:"Semana 10", label:"",
        days:[
          {
            id:"sav-p3w10d1", name:"Día 1", label:"Velocidad, Potencia & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1. Fire Hydrant isométrico - 2 x 10 segundos cada lado",
                "2. Patada atrás isométrica - 2 x 10 segundos cada lado"
              ]},
              {title:"Velocidad", items:["1. Sprint - 6 x 20 yardas [30 segundos rest]"]},
              {title:"Potencia", items:[
                "1.A. Peso muerto barra trap - 8 x 2 [2|1|X | 80 - 90%]",
                "1.B. Bounding - 8 x 1 [10 yardas | 4 enfoque en altura, 4 enfoque en distancia]"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo con barra - 3 x 10 [2|1|2]",
                "1.B. Rope/Towel Dominadas - 3 x Máximo",
                "1.C. Hiperextensiones - 3 x 60 segundos",
                "2.A. Curl inverso EZ - 3 x 10 [2|1|2]",
                "2.B. DB Curl martillo - 3 x 10 [2|1|2]",
                "2.C. Curl inclinado con mancuernas - 3 x 10"
              ]},
              {title:"Core", items:["1. Pikes en balón suizo - 3 x 10"]}
            ]
          },
          {
            id:"sav-p3w10d2", name:"Día 2", label:"Velocidad, Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Y,T,W - 3 x 5 cada uno"]},
              {title:"Velocidad", items:["1. Ejercicio 3 conos - 6 x 1 [30 segundos rest]"]},
              {title:"Potencia", items:[
                "1.A. Press de banca - 8 x 2 [2|1|X | 80 - 90%]",
                "1.B. Lanzamiento de balón medicinal - 8 x 2"
              ]},
              {title:"Construcción", items:[
                "1.A. DB Press de banca - 3 x 10 [2|1|2]",
                "1.B. Hex Press inclinado - 3 x 10 [2|1|2]",
                "1.C. Flexiones abiertas - 3 x 60 segundos",
                "2.A. Rompe cráneoss - 3 x 10 [2|1|2]",
                "2.B. Fondos en paralelas - 3 x Máximo",
                "2.C. Cable Extensión de tríceps - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Press Pallof - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w10d3", name:"Día 3", label:"Velocidad, Potencia & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Monster Walk - 3 x 10 yardas [adelante y atrás]"]},
              {title:"Velocidad", items:["1. Bounding alterno - 6 x 1 [30 yardas]"]},
              {title:"Potencia", items:[
                "1.A. Sentadilla - 8 x 2 [2|1|X| 80 - 90%]",
                "1.B. Salto de valla - 8 x 1"
              ]},
              {title:"Construcción", items:[
                "1.A. Bulgarian Split Sentadilla - 3 x 10",
                "1.B. RDL con mancuernas - 3 x 10",
                "1.C. Curl femoral - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Corte de leña en polea - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w10d4", name:"Día 4", label:"Velocidad, Potencia & Empuje/Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1.A. Wall Slides - 2 x 10",
                "1.B. Rotación externa con disco inclinado - 2 x 10"
              ]},
              {title:"Velocidad", items:["1. Ejercicio en 8 - 6 x 1"]},
              {title:"Potencia", items:[
                "1.A. Press sobre cabeza - 8 x 2 [2|1|X| 80 - 90%]",
                "1.B. Lanzamiento atrás balón medicinal - 8 x 2"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo al mentón - 3 x 10 [2|1|2]",
                "1.B. Dominadas supinas - 3 x Máximo",
                "1.C. Espantapájaros - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Farmer carry unilateral - 3 x 30 yardas cada mano"]}
            ]
          }
        ]
      },
      {
        id:"sav-p3w11", name:"Semana 11", label:"",
        days:[
          {
            id:"sav-p3w11d1", name:"Día 1", label:"Velocidad, Potencia & Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1. Fire Hydrant isométrico - 2 x 10 segundos cada lado",
                "2. Patada atrás isométrica - 2 x 10 segundos cada lado"
              ]},
              {title:"Velocidad", items:["1. Sprint - 4 x 20 yardas [30 segundos rest]"]},
              {title:"Potencia", items:[
                "1.A. Peso muerto barra trap - 10 x 1 [1|1|X | 90+%]",
                "1.B. Bounding - 10 x 1 [10 yardas | 5 enfoque en altura, 5 enfoque en distancia]"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo con barra - 3 x 10 [2|1|2]",
                "1.B. Rope/Towel Dominadas - 3 x Máximo",
                "1.C. Hiperextensiones - 3 x 60 segundos",
                "2.A. Curl inverso EZ - 3 x 10 [2|1|2]",
                "2.B. DB Curl martillo - 3 x 10 [2|1|2]",
                "2.C. Curl inclinado con mancuernas - 3 x 10"
              ]},
              {title:"Core", items:["1. Pikes en balón suizo - 3 x 10"]}
            ]
          },
          {
            id:"sav-p3w11d2", name:"Día 2", label:"Velocidad, Potencia & Empuje",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Y,T,W - 3 x 5 cada uno"]},
              {title:"Velocidad", items:["1. Ejercicio 3 conos - 4 x 1 [30 segundos rest]"]},
              {title:"Potencia", items:[
                "1.A. Press de banca - 10 x 1 [1|1|X | 90+%]",
                "1.B. Lanzamiento de balón medicinal - 10 x 1"
              ]},
              {title:"Construcción", items:[
                "1.A. DB Press de banca - 3 x 10 [2|1|2]",
                "1.B. Hex Press inclinado - 3 x 10 [2|1|2]",
                "1.C. Flexiones abiertas - 3 x 60 segundos",
                "2.A. Rompe cráneoss - 3 x 10 [2|1|2]",
                "2.B. Fondos en paralelas - 3 x Máximo",
                "2.C. Cable Extensión de tríceps - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Press Pallof - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w11d3", name:"Día 3", label:"Velocidad, Potencia & Tren Inferior",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Monster Walk - 3 x 10 yardas [adelante y atrás]"]},
              {title:"Velocidad", items:["1. Bounding alterno - 6 x 1 [30 yardas]"]},
              {title:"Potencia", items:[
                "1.A. Sentadilla - 10 x 1 [1|1|X| 90+%]",
                "1.B. Salto de valla - 10 x 1"
              ]},
              {title:"Construcción", items:[
                "1.A. Bulgarian Split Sentadilla - 3 x 10",
                "1.B. RDL con mancuernas - 3 x 10",
                "1.C. Curl femoral - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Corte de leña en polea - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w11d4", name:"Día 4", label:"Velocidad, Potencia & Empuje/Tirón",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1.A. Wall Slides - 2 x 10",
                "1.B. Rotación externa con disco inclinado - 2 x 10"
              ]},
              {title:"Velocidad", items:["1. Ejercicio en 8 - 4 x 1"]},
              {title:"Potencia", items:[
                "1.A. Press sobre cabeza - 10 x 1 [1|1|X| 90+%]",
                "1.B. Lanzamiento atrás balón medicinal - 10 x 1"
              ]},
              {title:"Construcción", items:[
                "1.A. Remo al mentón - 3 x 10 [2|1|2]",
                "1.B. Dominadas supinas - 3 x Máximo",
                "1.C. Espantapájaros - 3 x 60 segundos"
              ]},
              {title:"Core", items:["1. Farmer carry unilateral - 3 x 30 yardas cada mano"]}
            ]
          }
        ]
      },
      {
        id:"sav-p3w12", name:"Semana 12", label:"Descarga",
        days:[
          {
            id:"sav-p3w12d1", name:"Día 1", label:"Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1. Fire Hydrant isométrico - 2 x 10 segundos cada lado",
                "2. Patada atrás isométrica - 2 x 10 segundos cada lado"
              ]},
              {title:"Velocidad", items:["1. Sprint - 2 x 20 yardas [60 segundos rest]"]},
              {title:"Potencia", items:["1. Bounding - 4 x 1 [10 yardas | 2 enfoque en altura, 2 enfoque en distancia]"]},
              {title:"Construcción", items:[
                "1. Peso muerto barra trap - 5 x 5 @50%",
                "1.A. Remo con barra - 3 x 10",
                "1.B. Rope/Towel Dominadas - 3 x 10",
                "1.C. Hiperextensiones - 3 x 10",
                "2.A. Curl inverso EZ - 3 x 10",
                "2.B. DB Curl martillo - 3 x 10",
                "2.C. Curl inclinado con mancuernas - 3 x 10"
              ]},
              {title:"Core", items:["1. Pikes en balón suizo - 3 x 10"]}
            ]
          },
          {
            id:"sav-p3w12d2", name:"Día 2", label:"Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Y,T,W - 3 x 5 cada uno"]},
              {title:"Velocidad", items:["1. Ejercicio 3 conos - 2 x 1 [60 segundos rest]"]},
              {title:"Potencia", items:["1. Lanzamiento de balón medicinal - 4 x 1"]},
              {title:"Construcción", items:[
                "1. Press de banca - 5 x 5 @50%",
                "1.A. DB Press de banca - 3 x 10",
                "1.B. Hex Press inclinado - 3 x 10",
                "1.C. Flexiones abiertas - 3 x 10",
                "2.A. Rompe cráneoss - 3 x 10",
                "2.B. Fondos en paralelas - 3 x 10",
                "2.C. Cable Extensión de tríceps - 3 x 10"
              ]},
              {title:"Core", items:["1. Press Pallof - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w12d3", name:"Día 3", label:"Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:["1. Monster Walk - 3 x 10 yardas [adelante y atrás]"]},
              {title:"Velocidad", items:["1. Bounding alterno - 3 x 1 [30 yardas]"]},
              {title:"Potencia", items:["1. Salto de valla - 4 x 1"]},
              {title:"Construcción", items:[
                "1. Sentadilla - 5 x 5 @50%",
                "1.A. Bulgarian Split Sentadilla - 3 x 10",
                "1.B. RDL con mancuernas - 3 x 10",
                "1.C. Curl femoral - 3 x 10"
              ]},
              {title:"Core", items:["1. Corte de leña en polea - 3 x 10 cada lado"]}
            ]
          },
          {
            id:"sav-p3w12d4", name:"Día 4", label:"Descarga",
            sections:[
              {title:"Calentamiento Dinámico", items:[]},
              {title:"Activación", items:[
                "1.A. Wall Slides - 2 x 10",
                "1.B. Rotación externa con disco inclinado - 2 x 10"
              ]},
              {title:"Velocidad", items:["1. Ejercicio en 8 - 2 x 1"]},
              {title:"Potencia", items:["1. Lanzamiento atrás balón medicinal - 4 x 1"]},
              {title:"Construcción", items:[
                "1. Press sobre cabeza - 5 x 5 @50%",
                "1.A. Remo al mentón - 3 x 10",
                "1.B. Dominadas supinas - 3 x 10",
                "1.C. Espantapájaros - 3 x 10"
              ]},
              {title:"Core", items:["1. Farmer carry unilateral - 3 x 30 yardas cada mano"]}
            ]
          }
        ]
      }
    ]
  }
];



// ── SECTION COLORS ──────────────────────────────────────────────
const SECTION_COLORS = {
  "Calentamiento Dinámico": "#444",
  "Dynamic Warm Up": "#444",
  "Potencia": "#FF8800",
  "Potencia — Unilateral": "#FF8800",
  "Potencia — Bilateral": "#FF8800",
  "Pliometría": "#FF8800",
  "Plyometrics": "#FF8800",
  "Pliometría — Fundamentos": "#FF8800",
  "Pliometría — Unilateral": "#FF8800",
  "Pliometría — Bilateral": "#FF8800",
  "Pliometría — Fundamentos Bilaterales": "#FF8800",
  "Pliometría — Base": "#FF8800",
  "Pliometría — Unilateral + CDD": "#FF8800",
  "Velocidad": "#FF5C00",
  "Speed": "#FF5C00",
  "Velocidad — Aceleración": "#FF5C00",
  "Velocidad — Aceleración + Vel. Máxima": "#FF5C00",
  "Velocidad — CDD Lateral": "#FF5C00",
  "Velocidad — Velocidad Máxima": "#FF5C00",
  "Aceleración": "#FF5C00",
  "Acceleration": "#FF5C00",
  "Velocidad Máxima": "#FF5C00",
  "Velocidad Máxima — Mecánica Frontal": "#FF5C00",
  "Velocidad Máxima — Mecánica Posterior": "#FF5C00",
  "Agilidad Lineal": "#FF5C00",
  "CAD Lateral": "#FF5C00",
  "Max Velocity": "#FF5C00",
  "Cambio de Dirección": "#FF5C00",
  "Change of Direction": "#FF5C00",
  "Agility": "#FF5C00",
  "Speed/Agility": "#FF5C00",
  "Mobilization & Activation": "#9B59B6",
  "Activation": "#9B59B6",
  "Fuerza": "#00C9FF",
  "Strength": "#00C9FF",
  "Fuerza — Contraste Concéntrico": "#00C9FF",
  "Fuerza — Contraste": "#00C9FF",
  "Construcción": "#B8FF00",
  "Build": "#B8FF00",
  "Core": "#FF2D55",
  "Trunk": "#FF2D55",
  "Tronco": "#FF2D55",
  "Acondicionamiento": "#AA00FF",
  "Conditioning": "#AA00FF",
};

function getSectionColor(title) {
  for (const [key, color] of Object.entries(SECTION_COLORS)) {
    if (title.toLowerCase().includes(key.toLowerCase())) return color;
  }
  return "#888";
}

// ── COMPONENT ───────────────────────────────────────────────────
export default function GameSpeed() {
  const [view, setView] = useState("elite-home");
  const [currentProgram, setCurrentProgram] = useState("gs"); // "gs" | "ss"
  const [selPhase, setSelPhase] = useState(null);
  const [selWeek, setSelWeek] = useState(null);
  const [selDay, setSelDay] = useState(null);

  // Navigate with history tracking for hardware back button
  const navigate = (newView, opts = {}) => {
    window.history.pushState({ view: newView, ...opts }, "");
    setView(newView);
    if (opts.phase !== undefined) setSelPhase(opts.phase);
    if (opts.week !== undefined) setSelWeek(opts.week);
    if (opts.day !== undefined) setSelDay(opts.day);
    if (opts.program !== undefined) setCurrentProgram(opts.program);
  };

  // Handle hardware back button
  useEffect(() => {
    const handlePop = (e) => {
      const state = e.state;
      if (!state) {
        setView("elite-home");
        setSelPhase(null); setSelWeek(null); setSelDay(null);
        return;
      }
      setView(state.view);
      if (state.phase !== undefined) setSelPhase(state.phase);
      if (state.week !== undefined) setSelWeek(state.week);
      if (state.day !== undefined) setSelDay(state.day);
      if (state.program !== undefined) setCurrentProgram(state.program);
    };
    window.addEventListener("popstate", handlePop);
    // Push initial state
    window.history.replaceState({ view: "elite-home" }, "");
    return () => window.removeEventListener("popstate", handlePop);
  }, []);
  const [completed, setCompleted] = useState({});
  const [completedSS, setCompletedSS] = useState({});
  const [completedEVA, setCompletedEVA] = useState({});
  const [completedFPS, setCompletedFPS] = useState({});
  const [completedSAV, setCompletedSAV] = useState({});

  // Load all programs' completion from storage
  useEffect(() => {
    (async () => {
      try {
        const raw_gamespeed_completed_v4 = localStorage.getItem("gamespeed-completed-v4");
        if (raw_gamespeed_completed_v4) setCompleted(JSON.parse(raw_gamespeed_completed_v4));
      } catch (_) {}
      try {
        const raw_speedsystem_completed_v2 = localStorage.getItem("speedsystem-completed-v2");
        if (raw_speedsystem_completed_v2) setCompletedSS(JSON.parse(raw_speedsystem_completed_v2));
      } catch (_) {}
      try {
        const raw_eva_completed_v2 = localStorage.getItem("eva-completed-v2");
        if (raw_eva_completed_v2) setCompletedEVA(JSON.parse(raw_eva_completed_v2));
      } catch (_) {}
      try {
        const raw_fps_completed_v2 = localStorage.getItem("fps-completed-v2");
        if (raw_fps_completed_v2) setCompletedFPS(JSON.parse(raw_fps_completed_v2));
      } catch (_) {}
      try {
        const raw_savage_completed_v1 = localStorage.getItem("savage-completed-v1");
        if (raw_savage_completed_v1) setCompletedSAV(JSON.parse(raw_savage_completed_v1));
      } catch (_) {}
    })();
  }, []);

  useEffect(() => {
    if (Object.keys(completed).length === 0) return;
    (async () => {
      try { localStorage.setItem("gamespeed-completed-v4", JSON.stringify(completed)); } catch (_) {}
    })();
  }, [completed]);

  useEffect(() => {
    if (Object.keys(completedSS).length === 0) return;
    (async () => {
      try { localStorage.setItem("speedsystem-completed-v2", JSON.stringify(completedSS)); } catch (_) {}
    })();
  }, [completedSS]);

  useEffect(() => {
    if (Object.keys(completedEVA).length === 0) return;
    (async () => {
      try { localStorage.setItem("eva-completed-v2", JSON.stringify(completedEVA)); } catch (_) {}
    })();
  }, [completedEVA]);

  useEffect(() => {
    if (Object.keys(completedFPS).length === 0) return;
    (async () => {
      try { localStorage.setItem("fps-completed-v2", JSON.stringify(completedFPS)); } catch (_) {}
    })();
  }, [completedFPS]);

  useEffect(() => {
    if (Object.keys(completedSAV).length === 0) return;
    (async () => {
      try { localStorage.setItem("savage-completed-v1", JSON.stringify(completedSAV)); } catch (_) {}
    })();
  }, [completedSAV]);

  const toggleExercise = (key) => {
    setCompleted(prev => {
      const next = { ...prev, [key]: !prev[key] };
      if (!next[key]) delete next[key];
      return next;
    });
  };

  const toggleExerciseSS = (key) => {
    setCompletedSS(prev => {
      const next = { ...prev, [key]: !prev[key] };
      if (!next[key]) delete next[key];
      return next;
    });
  };

  const toggleExerciseEVA = (key) => {
    setCompletedEVA(prev => {
      const next = { ...prev, [key]: !prev[key] };
      if (!next[key]) delete next[key];
      return next;
    });
  };

  const toggleExerciseFPS = (key) => {
    setCompletedFPS(prev => {
      const next = { ...prev, [key]: !prev[key] };
      if (!next[key]) delete next[key];
      return next;
    });
  };

  const toggleExerciseSAV = (key) => {
    setCompletedSAV(prev => {
      const next = { ...prev, [key]: !prev[key] };
      if (!next[key]) delete next[key];
      return next;
    });
  };

  const resetProgram = () => {
    if (currentProgram === "ss") { setCompletedSS({}); try { localStorage.removeItem("speedsystem-completed-v2"); } catch(_){} }
    else if (currentProgram === "eva") { setCompletedEVA({}); try { localStorage.removeItem("eva-completed-v2"); } catch(_){} }
    else if (currentProgram === "fps") { setCompletedFPS({}); try { localStorage.removeItem("fps-completed-v2"); } catch(_){} }
    else if (currentProgram === "sav") { setCompletedSAV({}); try { localStorage.removeItem("savage-completed-v1"); } catch(_){} }
    else { setCompleted({}); try { localStorage.removeItem("gamespeed-completed-v4"); } catch(_){} }
  };

  const activePhases = currentProgram === "ss" ? ASS_PHASES : currentProgram === "eva" ? EVA_PHASES : currentProgram === "fps" ? FPS_PHASES : currentProgram === "sav" ? SAV_PHASES : PHASES;
  const activeCompleted = currentProgram === "ss" ? completedSS : currentProgram === "eva" ? completedEVA : currentProgram === "fps" ? completedFPS : currentProgram === "sav" ? completedSAV : completed;
  const activeToggle = currentProgram === "ss" ? toggleExerciseSS : currentProgram === "eva" ? toggleExerciseEVA : currentProgram === "fps" ? toggleExerciseFPS : currentProgram === "sav" ? toggleExerciseSAV : toggleExercise;

  const phase = activePhases.find(p => p.id === selPhase);
  const week = phase?.weeks.find(w => w.id === selWeek);
  const day = week?.days.find(d => d.id === selDay);
  const accent = phase?.accent || "#FF5C00";

  const styles = {
    app: {
      minHeight: "100vh", background: "#080808", color: "#f0f0f0",
      fontFamily: "'Barlow', sans-serif", overflowX: "hidden"
    },
    gfont: `@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700;800;900&family=Barlow:wght@300;400;500;600&display=swap');`,
  };

  // Set favicon and app title
  useEffect(() => {
    document.title = "Elite App";
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/svg+xml';
    link.rel = 'shortcut icon';
    link.href = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' rx='20' fill='%23080808'/%3E%3Cpolygon points='58,6 29,50 47,50 39,94 73,50 55,50' fill='%23ffffff'/%3E%3C/svg%3E";
    document.head.appendChild(link);
    // Apple touch icon
    const apple = document.querySelector("link[rel='apple-touch-icon']") || document.createElement('link');
    apple.rel = 'apple-touch-icon';
    apple.sizes = '180x180';
    apple.href = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 180 180'%3E%3Crect width='180' height='180' rx='36' fill='%23080808'/%3E%3Cpolygon points='104,11 52,90 85,90 70,169 131,90 98,90' fill='%23ffffff'/%3E%3C/svg%3E";
    document.head.appendChild(apple);
    // PWA theme color
    const meta = document.querySelector("meta[name='theme-color']") || document.createElement('meta');
    meta.name = 'theme-color';
    meta.content = '#080808';
    document.head.appendChild(meta);
    // Viewport with user-scalable for mobile
    const vp = document.querySelector("meta[name='viewport']");
    if (vp) vp.content = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,600;0,700;0,800;0,900;1,800&family=Barlow:wght@300;400;500;600&family=Inter:wght@400;500;600&display=swap');
        * { box-sizing: border-box; margin:0; padding:0; }
        html { -webkit-text-size-adjust: 100%; touch-action: manipulation; overscroll-behavior-y: contain; }
        body { overscroll-behavior-y: contain; }
        body { background:#080808; overflow-x:hidden; }
        ::-webkit-scrollbar { width:0px; background:transparent; }
        * { scrollbar-width:none; }
        .card-hover { transition: transform 0.18s ease, box-shadow 0.18s ease; cursor:pointer; }
        @media (hover: hover) { .card-hover:hover { transform: translateY(-3px); } }
        .btn-back { background:none; border:1px solid #333; color:#aaa; padding:12px 20px;
          border-radius:4px; cursor:pointer; font-family:'Barlow',sans-serif; font-size:14px;
          letter-spacing:0.5px; transition:all 0.15s; min-height:44px; touch-action:manipulation;
          display:block; width:100%; text-align:left; }
        .btn-back:hover { border-color:#666; color:#fff; }
        .fade-in { animation: fadeIn 0.3s ease; }
        @keyframes fadeIn { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
        .exercise-item { border-left:2px solid; padding:10px 0 10px 14px; margin:4px 0;
          font-size:15px; line-height:1.7; color:#e8e8e8; font-weight:400; letter-spacing:0.15px;
          font-family:'Inter', sans-serif; }
        .deload-badge { background:#222; color:#FF9F0A; font-size:10px; font-weight:600;
          padding:2px 8px; border-radius:2px; letter-spacing:1px; text-transform:uppercase; }
        @media (max-width: 600px) {
          .exercise-item { font-size:14px; }
        }
      `}</style>
      <div style={styles.app}>
        {view === "elite-home" && (
          <EliteHomeView
            completed={completed} phases={PHASES}
            completedSS={completedSS} phasesss={ASS_PHASES}
            completedEVA={completedEVA} phasesEVA={EVA_PHASES}
            completedFPS={completedFPS} phasesFPS={FPS_PHASES}
            completedSAV={completedSAV} phasesSAV={SAV_PHASES}
            onSelectGS={() => navigate("home", { program: "gs" })}
            onSelectSS={() => navigate("home", { program: "ss" })}
            onSelectEVA={() => navigate("home", { program: "eva" })}
            onSelectFPS={() => navigate("home", { program: "fps" })}
            onSelectSAV={() => navigate("home", { program: "sav" })}
          />
        )}
        {view === "home" && (
          <HomeView
            program={currentProgram}
            started={Object.keys(activeCompleted).length > 0}
            isProgramDone={activePhases.every(p => isPhaseDone(p, activeCompleted))}
            onEnter={() => navigate("phases")}
            onBack={() => navigate("elite-home")}
            onReset={resetProgram}
          />
        )}
        {view === "phases" && (
          <PhasesView phases={activePhases} completed={activeCompleted}
            onSelect={id => navigate("weeks", { phase: id })}
            onBack={() => setView("home")} />
        )}
        {view === "weeks" && phase && (
          <WeeksView phase={phase} completed={activeCompleted}
            onSelect={id => navigate("days", { week: id })}
            onBack={() => navigate("phases", { phase: null })} />
        )}
        {view === "days" && week && (
          <DaysView phase={phase} week={week} completed={activeCompleted}
            onSelect={id => navigate("workout", { day: id })}
            onBack={() => navigate("weeks", { week: null })} />
        )}
        {view === "workout" && day && (
          <WorkoutView phase={phase} week={week} day={day} completed={activeCompleted} toggleExercise={activeToggle}
            onBack={() => navigate("days", { day: null })} />
        )}
      </div>
    </>
  );
}

// ── ELITE HOME ───────────────────────────────────────────────────
function EliteHomeView({ completed, phases, completedSS, phasesss, completedEVA, phasesEVA, completedFPS, phasesFPS, completedSAV, phasesSAV, onSelectGS, onSelectSS, onSelectEVA, onSelectFPS, onSelectSAV }) {
  // Game Speed stats
  const gsAllKeys = phases.flatMap(p => p.weeks.flatMap(w => w.days.flatMap(d => getDayItems(d))));
  const gsDone = gsAllKeys.filter(k => completed[k]).length;
  const gsPct = gsAllKeys.length > 0 ? Math.round((gsDone / gsAllKeys.length) * 100) : 0;
  const gsStarted = gsDone > 0;
  const gsWeeks = phases.reduce((a, p) => a + p.weeks.length, 0);

  // Speed System stats
  const ssAllKeys = phasesss.flatMap(p => p.weeks.flatMap(w => w.days.flatMap(d => getDayItems(d))));
  const ssDone = ssAllKeys.filter(k => completedSS[k]).length;
  const ssPct = ssAllKeys.length > 0 ? Math.round((ssDone / ssAllKeys.length) * 100) : 0;
  const ssStarted = ssDone > 0;
  const ssWeeks = phasesss.reduce((a, p) => a + p.weeks.length, 0);

  // EVA stats
  const evaAllKeys = phasesEVA.flatMap(p => p.weeks.flatMap(w => w.days.flatMap(d => getDayItems(d))));
  const evaDone = evaAllKeys.filter(k => completedEVA[k]).length;
  const evaPct = evaAllKeys.length > 0 ? Math.round((evaDone / evaAllKeys.length) * 100) : 0;
  const evaStarted = evaDone > 0;
  const evaWeeks = phasesEVA.reduce((a, p) => a + p.weeks.length, 0);

  // FPS stats
  const fpsAllKeys = phasesFPS.flatMap(p => p.weeks.flatMap(w => w.days.flatMap(d => getDayItems(d))));
  const fpsDone = fpsAllKeys.filter(k => completedFPS[k]).length;
  const fpsPct = fpsAllKeys.length > 0 ? Math.round((fpsDone / fpsAllKeys.length) * 100) : 0;
  const fpsStarted = fpsDone > 0;
  const fpsWeeks = phasesFPS.reduce((a, p) => a + p.weeks.length, 0);

  // SAV stats
  const savAllKeys = phasesSAV.flatMap(p => p.weeks.flatMap(w => w.days.flatMap(d => getDayItems(d))));
  const savDone = savAllKeys.filter(k => completedSAV[k]).length;
  const savPct = savAllKeys.length > 0 ? Math.round((savDone / savAllKeys.length) * 100) : 0;
  const savStarted = savDone > 0;
  const savWeeks = phasesSAV.reduce((a, p) => a + p.weeks.length, 0);

  const ProgramCard = ({ started, pct, accent, titleLine1, titleLine2, subtitle, tagline, numPhases, numWeeks, numWorkouts, onClick }) => {
    const done = pct === 100;
    const statusColor = done ? "#4caf50" : accent;
    return (
      <div style={{
        borderRadius:"8px", overflow:"hidden",
        border:`1px solid ${started ? statusColor + "55" : "#1e1e1e"}`,
        background:"#0d0d0d", marginBottom:"14px"
      }}>
        {started ? (
          <div style={{ display:"flex", alignItems:"stretch" }}>
            {/* LEFT: tagline + title + stats */}
            <div style={{ flex:1, minWidth:0, padding:"14px 12px 14px 14px" }}>
              <div style={{ fontSize:"9px", color:accent, letterSpacing:"1.5px", fontWeight:700,
                fontFamily:"'Barlow Condensed',sans-serif", textTransform:"uppercase",
                whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", marginBottom:"5px"
              }}>{tagline}</div>
              <div style={{ marginBottom:"10px" }}>
                <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
                  fontSize:"clamp(28px,7vw,38px)", color:accent, lineHeight:0.95, letterSpacing:"-1px", whiteSpace:"nowrap"
                }}>{titleLine2.split(" ")[0]}</span>
              </div>
              <div style={{ display:"flex", gap:"12px" }}>
                {[{val:`${numPhases}`,label:"FASES"},{val:`${numWeeks}`,label:"SEMANAS"},{val:`${numWorkouts}`,label:"ENTRENOS"}].map(s => (
                  <div key={s.label}>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"18px", color:"#fff", lineHeight:1 }}>{s.val}</div>
                    <div style={{ fontSize:"10px", color:"#555", letterSpacing:"1px", marginTop:"2px", fontFamily:"'Barlow Condensed',sans-serif" }}>{s.label}</div>
                  </div>
                ))}
              </div>
            </div>
            {/* DIVIDER */}
            <div style={{ width:"1px", background:"#1e1e1e", flexShrink:0 }} />
            {/* RIGHT: % + bar + button — fixed narrow width */}
            <div style={{ width:"95px", flexShrink:0, padding:"12px 10px", display:"flex", flexDirection:"column", justifyContent:"space-between", gap:"8px" }}>
              <div>
                <div style={{ fontSize:"9px", color:"#555", letterSpacing:"1px", fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, marginBottom:"2px" }}>PROGRESO</div>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"22px", color:statusColor, lineHeight:1 }}>{pct}%</div>
              </div>
              <div style={{ height:"2px", background:"#1a1a1a", borderRadius:"2px" }}>
                <div style={{ width:`${pct}%`, height:"100%", borderRadius:"2px", transition:"width 0.4s ease",
                  background: done ? "#4caf50" : accent }} />
              </div>
              <div onClick={onClick} style={{
                whiteSpace:"nowrap", textAlign:"center",
                background: done ? "#1a3d1a" : accent + "20",
                border:`1px solid ${done ? "#2d6b2d" : accent + "66"}`,
                color:statusColor, fontSize:"10px", fontWeight:800,
                padding:"6px 4px", borderRadius:"4px", letterSpacing:"0px",
                fontFamily:"'Barlow Condensed',sans-serif", cursor:"pointer"
              }}>{done ? "✓ LISTO" : "CONTINUAR →"}</div>
            </div>
          </div>
        ) : (
          <div style={{ padding:"14px" }}>
            {/* Tagline */}
            <div style={{ fontSize:"9px", color:accent, letterSpacing:"1.5px", fontWeight:700,
              fontFamily:"'Barlow Condensed',sans-serif", textTransform:"uppercase",
              whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis", marginBottom:"4px"
            }}>{tagline}</div>
            {/* Title */}
            <div style={{ display:"flex", alignItems:"baseline", gap:"4px", marginBottom:"8px", flexWrap:"nowrap", overflow:"hidden" }}>
              <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontStyle:"italic", fontWeight:900,
                fontSize:"clamp(24px,6vw,34px)", color:"#fff", lineHeight:0.95, letterSpacing:"-1px", whiteSpace:"nowrap"
              }}>{titleLine1}</span>
              <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
                fontSize:"clamp(24px,6vw,34px)", color:accent, lineHeight:0.95, letterSpacing:"-1px", whiteSpace:"nowrap"
              }}>{titleLine2}</span>
            </div>
            {/* Subtitle */}
            <div style={{ fontSize:"12px", color:"#555", fontWeight:300, lineHeight:1.5, marginBottom:"12px" }}>{subtitle}</div>
            {/* Stats + button on same row */}
            <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:"8px" }}>
              <div style={{ display:"flex", gap:"14px" }}>
                {[{val:`${numPhases}`,label:"FASES"},{val:`${numWeeks}`,label:"SEMANAS"},{val:`${numWorkouts}`,label:"ENTRENOS"}].map(s => (
                  <div key={s.label}>
                    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"18px", color:"#fff", lineHeight:1 }}>{s.val}</div>
                    <div style={{ fontSize:"10px", color:"#555", letterSpacing:"1px", marginTop:"2px", fontFamily:"'Barlow Condensed',sans-serif" }}>{s.label}</div>
                  </div>
                ))}
              </div>
              <div onClick={onClick} style={{
                flexShrink:0, whiteSpace:"nowrap", cursor:"pointer",
                fontSize:"12px", fontWeight:700, color:accent,
                letterSpacing:"1px", fontFamily:"'Barlow Condensed',sans-serif",
                padding:"8px 12px", border:`1px solid ${accent}44`, borderRadius:"4px"
              }}>VER PROGRAMA →</div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const allPrograms = [
    { key:"gs", started:gsStarted, pct:gsPct, accent:"#E8003D", titleLine1:"ATHLETIC", titleLine2:"GAME SYSTEM", tagline:"RAPIDEZ · AGILIDAD · EXPLOSIVIDAD", subtitle:"Domina el arte del frenado y la redirección explosiva para dejar a tus defensores atrás en cada cambio de dirección.", numPhases:phases.length, numWeeks:gsWeeks, numWorkouts:56, onClick:onSelectGS },
    { key:"ss", started:ssStarted, pct:ssPct, accent:"#00C9FF", titleLine1:"ATHLETIC", titleLine2:"SPEED SYSTEM", tagline:"VELOCIDAD PUNTA · ACELERACIÓN · POTENCIA", subtitle:"Desarrolla la potencia explosiva necesaria para acelerar más fuerte y alcanzar tu máxima velocidad en campo abierto.", numPhases:phasesss.length, numWeeks:ssWeeks, numWorkouts:56, onClick:onSelectSS },
    { key:"eva", started:evaStarted, pct:evaPct, accent:"#7B61FF", titleLine1:"ATHLETIC", titleLine2:"VERTICAL SYSTEM", tagline:"REACTIVIDAD · SALTO · PROPULSIÓN", subtitle:"Maximiza tu capacidad de salto mediante la transferencia de fuerza y la optimización del despegue.", numPhases:phasesEVA.length, numWeeks:evaWeeks, numWorkouts:56, onClick:onSelectEVA },
    { key:"fps", started:fpsStarted, pct:fpsPct, accent:"#FF9500", titleLine1:"ATHLETIC", titleLine2:"FOOTBALL SYSTEM", tagline:"COORDINACIÓN · FUERZA EXPLOSIVA · INTEGRACIÓN", subtitle:"Alcanza la maestría atlética transformando tu capacidad física bajo cualquier situación.", numPhases:phasesFPS.length, numWeeks:fpsWeeks, numWorkouts:56, onClick:onSelectFPS },
    { key:"sav", started:savStarted, pct:savPct, accent:"#B8FF00", titleLine1:"ATHLETIC", titleLine2:"MUSCLE SYSTEM", tagline:"FUERZA ABSOLUTA · HIPERTROFIA · RESILIENCIA", subtitle:"Construye un físico dominante reconstruyendo tu composición corporal mediante una fuerza absoluta y funcional.", numPhases:phasesSAV.length, numWeeks:savWeeks, numWorkouts:56, onClick:onSelectSAV },
  ];
  const activePrograms = allPrograms.filter(p => p.started && p.pct < 100);
  const inactivePrograms = allPrograms.filter(p => !p.started);
  const completedPrograms = allPrograms.filter(p => p.pct === 100);

  const SectionLabel = ({ text }) => (
    <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"11px",
      letterSpacing:"4px", color:"#444", textTransform:"uppercase", marginBottom:"14px", marginTop:"8px"
    }}>{text}</div>
  );

  return (
    <div className="fade-in" style={{ minHeight:"100vh", background:"#080808", display:"flex", flexDirection:"column" }}>
      <div style={{ padding:"20px 20px 20px", borderBottom:"1px solid #111" }}>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
          fontSize:"clamp(42px,8vw,72px)", letterSpacing:"-2px", lineHeight:1, color:"#fff"
        }}>ELITE</div>
        <div style={{ fontFamily:"'Barlow',sans-serif", fontWeight:300, fontSize:"15px",
          letterSpacing:"4px", color:"#444", textTransform:"uppercase", marginTop:"4px"
        }}>PROGRAMAS DE ENTRENAMIENTO</div>
      </div>

      <div style={{ flex:1, padding:"20px 16px", maxWidth:"900px", width:"100%", boxSizing:"border-box" }}>

        {/* PROGRAMAS ACTIVOS */}
        {activePrograms.length > 0 && (
          <>
            <SectionLabel text={activePrograms.length > 1 ? "▶ PROGRAMAS ACTIVOS" : "▶ PROGRAMA ACTIVO"} />
            {activePrograms.map(p => (
              <ProgramCard key={p.key} {...p} />
            ))}
          </>
        )}

        {/* PROGRAMAS COMPLETADOS */}
        {completedPrograms.length > 0 && (
          <>
            <SectionLabel text="✓ COMPLETADOS" />
            {completedPrograms.map(p => (
              <ProgramCard key={p.key} {...p} />
            ))}
          </>
        )}

        {/* MIS PROGRAMAS (sin iniciar) */}
        {inactivePrograms.length > 0 && (
          <>
            <SectionLabel text="MIS PROGRAMAS" />
            {inactivePrograms.map(p => (
              <ProgramCard key={p.key} {...p} />
            ))}
          </>
        )}
      </div>
    </div>
  );
}

// ── HOME ─────────────────────────────────────────────────────────
function HomeView({ program, started, onEnter, onBack, onReset, isProgramDone }) {
  const isEVA = program === "eva";
  const isSS = program === "ss";
  const isFPS = program === "fps";
  const isSAV = program === "sav";
  const accent = isEVA ? "#7B61FF" : isSS ? "#00C9FF" : isFPS ? "#FF9500" : isSAV ? "#B8FF00" : "#E8003D";
  const accentB = isEVA ? "#9B81FF" : isSS ? "#0099FF" : isFPS ? "#FF9F0A" : isSAV ? "#D4FF40" : "#FF9F0A";

  if (isProgramDone) {
    const programName = isEVA ? "VERTICAL SYSTEM" : isSS ? "SPEED SYSTEM" : isFPS ? "FOOTBALL SYSTEM" : isSAV ? "MUSCLE SYSTEM" : "GAME SYSTEM";
    return (
      <div className="fade-in" style={{
        minHeight:"100vh", background:"#080808", display:"flex", flexDirection:"column",
        padding:"20px 16px", maxWidth:"960px", margin:"0 auto"
      }}>
        <button className="btn-back" onClick={onBack} style={{ marginBottom:"24px", flexShrink:0 }}>← ELITE</button>
        <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
          <div style={{
            width:"80px", height:"80px", borderRadius:"50%",
            background:accent+"22", border:`2px solid ${accent}`,
            display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"32px"
          }}>
            <span style={{ fontSize:"36px", color:accent }}>✓</span>
          </div>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"13px",
            letterSpacing:"4px", color:accent, textTransform:"uppercase", marginBottom:"12px"
          }}>PROGRAMA</div>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
            fontSize:"clamp(42px,10vw,64px)", color:"#fff", letterSpacing:"-2px",
            lineHeight:0.9, marginBottom:"8px"
          }}>COMPLETADO</div>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700,
            fontSize:"18px", color:accent, letterSpacing:"2px", marginBottom:"40px"
          }}>{programName}</div>
          <div style={{ display:"flex", flexDirection:"column", gap:"12px", width:"100%", maxWidth:"300px" }}>
            <button onClick={onEnter} style={{
              background:accent, color:"#fff", border:"none",
              padding:"18px 24px", borderRadius:"4px", cursor:"pointer",
              fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800,
              fontSize:"18px", letterSpacing:"2px", textTransform:"uppercase"
            }}>VER PROGRAMA</button>
            <button onClick={onReset} style={{
              background:"transparent", color:"#e8003d", border:"1px solid #e8003d44",
              padding:"14px 24px", borderRadius:"4px", cursor:"pointer",
              fontFamily:"'Barlow Condensed',sans-serif", fontWeight:600,
              fontSize:"14px", letterSpacing:"1px", textTransform:"uppercase"
            }}>RESETEAR PROGRAMA</button>
            <button onClick={onBack} style={{
              background:"transparent", color:"#555", border:"1px solid #333",
              padding:"14px 24px", borderRadius:"4px", cursor:"pointer",
              fontFamily:"'Barlow Condensed',sans-serif", fontWeight:600,
              fontSize:"14px", letterSpacing:"1px", textTransform:"uppercase"
            }}>← VOLVER</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fade-in" style={{
      minHeight:"100vh", display:"flex", flexDirection:"column",
      padding:"20px 16px", maxWidth:"960px", margin:"0 auto", position:"relative", overflow:"hidden"
    }}>
      <div style={{
        position:"absolute", inset:0, opacity:0.04, zIndex:0,
        backgroundImage:"repeating-linear-gradient(0deg,transparent,transparent 39px,#fff 39px,#fff 40px),repeating-linear-gradient(90deg,transparent,transparent 39px,#fff 39px,#fff 40px)"
      }} />
      <button className="btn-back" onClick={onBack} style={{ position:"relative", zIndex:1, marginBottom:"24px", flexShrink:0 }}>← ELITE</button>
      <div style={{ textAlign:"center", position:"relative", zIndex:1, flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center" }}>
        <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
          fontSize:"clamp(16px,3vw,22px)", letterSpacing:"6px", color:accent,
          textTransform:"uppercase", marginBottom:"16px"
        }}>PROGRAMA DE ENTRENAMIENTO</div>
        <div style={{ height:"8px" }} />
        {isEVA ? (
          <>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontStyle:"italic", fontWeight:800, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:"#fff", letterSpacing:"-2px", marginBottom:"4px" }}>ATHLETIC</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:accent, letterSpacing:"-2px", marginBottom:"20px" }}>VERTICAL SYSTEM</div>
          </>
        ) : isSS ? (
          <>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontStyle:"italic", fontWeight:800, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:"#fff", letterSpacing:"-2px", marginBottom:"4px" }}>ATHLETIC</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:accent, letterSpacing:"-2px", marginBottom:"20px" }}>SPEED SYSTEM</div>
          </>
        ) : isFPS ? (
          <>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontStyle:"italic", fontWeight:800, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:"#fff", letterSpacing:"-2px", marginBottom:"4px" }}>ATHLETIC</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:accent, letterSpacing:"-2px", marginBottom:"20px" }}>FOOTBALL SYSTEM</div>
          </>
        ) : isSAV ? (
          <>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontStyle:"italic", fontWeight:800, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:"#fff", letterSpacing:"-2px", marginBottom:"4px" }}>ATHLETIC</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:accent, letterSpacing:"-2px", marginBottom:"20px" }}>MUSCLE SYSTEM</div>
          </>
        ) : (
          <>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontStyle:"italic", fontWeight:800, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:"#fff", letterSpacing:"-2px", marginBottom:"4px" }}>ATHLETIC</div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(48px,12vw,90px)", lineHeight:0.9, color:accent, letterSpacing:"-2px", marginBottom:"20px" }}>GAME SYSTEM</div>
          </>
        )}
        <div style={{ fontFamily:"'Barlow',sans-serif", fontWeight:400, fontSize:"clamp(12px,3vw,16px)",
          letterSpacing:"3px", color:"#666", textTransform:"uppercase", marginBottom:"36px"
        }}>{isEVA ? "Reactividad · Salto · Propulsión" : isSS ? "Velocidad Punta · Aceleración · Potencia" : isFPS ? "Coordinación · Fuerza Explosiva · Integración" : isSAV ? "Fuerza Absoluta · Hipertrofia · Resiliencia" : "Rapidez · Agilidad · Explosividad"}</div>
        <div style={{ display:"flex", gap:"10px", justifyContent:"center", marginBottom:"40px", width:"100%", maxWidth:"460px" }}>
          {[{n: isSAV ? "12 SEMANAS" : "14 SEMANAS",c:accent},{n: isFPS ? "4 FASES" : isSAV ? "3 FASES" : "4 FASES",c:accent},{n: isSAV ? "56 ENTRENOS" : "56 ENTRENOS",c:accent}].map(b => (
            <div key={b.n} style={{
              flex:1, border:`1px solid ${b.c}44`, padding:"12px 8px", borderRadius:"4px",
              fontSize:"clamp(11px,2.5vw,13px)", fontWeight:700, letterSpacing:"1px", color:b.c,
              fontFamily:"'Barlow Condensed',sans-serif", textAlign:"center",
              background:`${b.c}10`
            }}>{b.n}</div>
          ))}
        </div>
        <button onClick={onEnter} style={{
          background:accent, color:"#fff", border:"none", padding:"20px 24px",
          fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800, fontSize:"20px",
          letterSpacing:"2px", textTransform:"uppercase", cursor:"pointer", borderRadius:"4px",
          transition:"all 0.2s", marginBottom:"40px", width:"100%", maxWidth:"340px",
          whiteSpace:"nowrap"
        }}
        onMouseEnter={e => e.target.style.background=accentB}
        onMouseLeave={e => e.target.style.background=accent}>
          {started ? "CONTINUAR PROGRAMA" : "INICIAR PROGRAMA"}
        </button>
      </div>
    </div>
  );
}

// ── PHASES ───────────────────────────────────────────────────────
function PhasesView({ phases, completed, onSelect, onBack }) {
  return (
    <div className="fade-in" style={{ minHeight:"100vh", display:"flex", flexDirection:"column", padding:"20px 16px", maxWidth:"960px", margin:"0 auto" }}>
      <button className="btn-back" onClick={onBack} style={{ marginBottom:"24px", flexShrink:0 }}>← VOLVER</button>
      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"11px", letterSpacing:"4px", color:"#555", textTransform:"uppercase", marginBottom:"4px", flexShrink:0 }}>PROGRAMA</div>
      <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(32px,7vw,48px)", color:"#fff", letterSpacing:"-1px", marginBottom:"24px", flexShrink:0 }}>SELECCIONA UNA FASE</h1>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(140px, 1fr))", gap:"12px", flex:1, minHeight:0 }}>
        {phases.map((p, i) => {
          const done = isPhaseDone(p, completed);
          const prevDone = i === 0 || isPhaseDone(phases[i-1], completed);
          const hasProgress = p.weeks.some(w => w.days.some(d => getDayItems(d).some(k => completed[k])));
          const inProgress = !done && prevDone && hasProgress;
          return (
            <div key={p.id} className="card-hover" onClick={() => onSelect(p.id)} style={{
              background:"#111", border:`1px solid ${done ? "#2a5a2a" : inProgress ? p.accent+"44" : "#1a1a1a"}`,
              borderTop:`3px solid ${p.accent}`, borderRadius:"4px", padding:"32px 24px",
              position:"relative", overflow:"hidden", display:"flex", flexDirection:"column", justifyContent:"space-between"
            }}>
              <div style={{
                position:"absolute", right:"-10px", top:"-10px", fontFamily:"'Barlow Condensed',sans-serif",
                fontWeight:900, fontSize:"100px", color:`${p.accent}06`, lineHeight:1, userSelect:"none"
              }}>{i+1}</div>
              <div>
                <div style={{
                  fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
                  fontSize:"clamp(22px,2.5vw,36px)", color:"#fff", marginBottom:"6px"
                }}>{p.name}</div>
                <div style={{
                  fontFamily:"'Barlow Condensed',sans-serif", fontWeight:600,
                  fontSize:"clamp(13px,1.4vw,16px)", letterSpacing:"3px", color:p.accent, textTransform:"uppercase", marginBottom:"12px"
                }}>{p.label}</div>
                <div style={{ fontSize:"13px", color:"#555" }}>
                  {p.weeks.length} {p.weeks.length === 1 ? "semana" : "semanas"}
                </div>
              </div>
              <div style={{ display:"flex", flexDirection:"column", gap:"8px", marginTop:"12px" }}>
                {done ? (
                  <div style={{
                    background:"#1a3d1a", border:"1px solid #2d6b2d", color:"#4caf50",
                    fontSize:"12px", fontWeight:800, padding:"10px 12px", borderRadius:"3px",
                    letterSpacing:"1.5px", textAlign:"center"
                  }}>✓ COMPLETADA</div>
                ) : inProgress ? (
                  <>
                    <div style={{ height:"2px", background:"#222", borderRadius:"1px" }}>
                      <div style={{ width:`${Math.round((p.weeks.reduce((a,w)=>a+w.days.filter(d=>isDayDone(d,completed)).length,0)/p.weeks.reduce((a,w)=>a+w.days.length,0))*100)}%`, height:"100%", background:p.accent, borderRadius:"1px", transition:"width 0.3s" }} />
                    </div>
                    <div style={{
                      background:p.accent+"15", border:`1px solid ${p.accent}44`, color:p.accent,
                      fontSize:"12px", fontWeight:800, padding:"8px 12px", borderRadius:"3px",
                      letterSpacing:"1.5px", textAlign:"center"
                    }}>● EN PROGRESO</div>
                  </>
                ) : (
                  <div style={{ color:p.accent, fontSize:"20px", fontWeight:800, textAlign:"center" }}>→</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── WEEKS ────────────────────────────────────────────────────────
function WeeksView({ phase, completed, onSelect, onBack }) {
  return (
    <div className="fade-in" style={{ minHeight:"100vh", display:"flex", flexDirection:"column", padding:"20px 16px", maxWidth:"960px", margin:"0 auto" }}>
      <button className="btn-back" onClick={onBack} style={{ marginBottom:"24px", flexShrink:0 }}>← FASES</button>
      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"11px", letterSpacing:"4px", color:phase.accent, textTransform:"uppercase", marginBottom:"4px", flexShrink:0 }}>{phase.name} · {phase.label}</div>
      <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(32px,7vw,48px)", color:"#fff", letterSpacing:"-1px", marginBottom:"24px", flexShrink:0 }}>SELECCIONA UNA SEMANA</h1>
      <div style={{ display:"flex", flexDirection:"column", gap:"10px" }}>
        {phase.weeks.map((w, j) => {
          const isDeload = w.label === "Descarga";
          const done = isWeekDone(w, completed);
          const prevDone = j === 0 || isWeekDone(phase.weeks[j-1], completed);
          const hasProgress = w.days.some(d => getDayItems(d).some(k => completed[k]));
          const inProgress = !done && prevDone && hasProgress;
          return (
            <div key={w.id} className="card-hover" onClick={() => onSelect(w.id)} style={{
              background:"#0e0e0e", border:`1px solid ${done ? "#2a5a2a" : inProgress ? phase.accent+"44" : isDeload ? phase.accent+"22" : "#1e1e1e"}`,
              borderLeft:`3px solid ${done ? "#4caf50" : phase.accent}`,
              borderRadius:"4px", padding:"16px 20px", position:"relative",
              display:"flex", alignItems:"center", justifyContent:"space-between"
            }}>
              <div style={{ flex:1 }}>
                <div style={{
                  fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
                  fontSize:"20px", color: done ? "#4caf50" : "#fff", marginBottom:"6px"
                }}>{w.name}</div>
                <div style={{ display:"flex", alignItems:"center", gap:"8px", lineHeight:"1.4" }}>
                  {isDeload
                    ? <span className="deload-badge">Descarga</span>
                    : <span style={{ fontSize:"12px", color:"#555", letterSpacing:"1px" }}>{w.label || phase.label}</span>
                  }
                  <span style={{ fontSize:"11px", color:"#444", lineHeight:"1" }}>· {w.days.length} días</span>
                </div>
              </div>
              <div style={{ marginLeft:"12px", flexShrink:0 }}>
                {done ? (
                  <div style={{
                    background:"#1a3d1a", border:"1px solid #2d6b2d", color:"#4caf50",
                    fontSize:"11px", fontWeight:800, padding:"6px 10px", borderRadius:"3px",
                    letterSpacing:"1.5px", whiteSpace:"nowrap"
                  }}>✓ COMPLETADA</div>
                ) : inProgress ? (
                  <div style={{
                    background:phase.accent+"15", border:`1px solid ${phase.accent}44`, color:phase.accent,
                    fontSize:"11px", fontWeight:800, padding:"6px 10px", borderRadius:"3px",
                    letterSpacing:"1.5px", whiteSpace:"nowrap"
                  }}>● EN PROGRESO</div>
                ) : (
                  <div style={{ color:phase.accent, fontSize:"20px", fontWeight:800, paddingRight:"4px" }}>→</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── DAYS ─────────────────────────────────────────────────────────
function DaysView({ phase, week, completed, onSelect, onBack }) {
  return (
    <div className="fade-in" style={{ minHeight:"100vh", padding:"20px 16px", maxWidth:"900px", margin:"0 auto" }}>
      <button className="btn-back" onClick={onBack} style={{ marginBottom:"24px", flexShrink:0 }}>← SEMANAS</button>
      <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"11px", letterSpacing:"4px", color:phase.accent, textTransform:"uppercase", marginBottom:"4px" }}>{phase.name} · {week.name}</div>
      <h1 style={{ fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900, fontSize:"clamp(32px,7vw,48px)", color:"#fff", letterSpacing:"-1px", marginBottom:"24px" }}>SELECCIONA UN DÍA</h1>
      <div style={{ display:"grid", gridTemplateColumns:"1fr", gap:"12px", maxWidth:"680px" }}>
        {week.days.map((d, i) => {
          const done = isDayDone(d, completed);
          const prog = dayProgress(d, completed);
          return (
            <div key={d.id} className="card-hover" onClick={() => onSelect(d.id)} style={{
              background:"#0e0e0e", border:`1px solid ${done ? "#2a5a2a" : prog.done > 0 ? phase.accent+"33" : "#1e1e1e"}`,
              borderLeft:`4px solid ${done ? "#4caf50" : prog.done > 0 ? phase.accent : phase.accent+"44"}`, borderRadius:"4px",
              padding:"16px 20px", display:"flex", alignItems:"center", justifyContent:"space-between"
            }}>
              <div style={{ flex:1 }}>
                <div style={{
                  fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800,
                  fontSize:"20px", color: done ? "#4caf50" : "#fff", marginBottom:"3px"
                }}>{d.name}</div>
                <div style={{ fontSize:"13px", color:"#666", fontWeight:300, marginBottom: prog.done > 0 && !done ? "8px" : 0 }}>{d.label}</div>
                {prog.total > 0 && !done && prog.done > 0 && (
                  <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
                    <div style={{ flex:1, height:"2px", background:"#222", borderRadius:"1px", maxWidth:"140px" }}>
                      <div style={{ width:`${(prog.done/prog.total)*100}%`, height:"100%", background:phase.accent, borderRadius:"1px", transition:"width 0.3s" }} />
                    </div>
                    <span style={{ fontSize:"11px", color:phase.accent, fontWeight:600 }}>{prog.done}/{prog.total}</span>
                  </div>
                )}
              </div>
              <div style={{ marginLeft:"16px", flexShrink:0 }}>
                {done ? (
                  <div style={{
                    background:"#1a3d1a", border:"1px solid #2d6b2d", color:"#4caf50",
                    fontSize:"11px", fontWeight:800, padding:"6px 10px", borderRadius:"3px",
                    letterSpacing:"1.5px", whiteSpace:"nowrap"
                  }}>✓ COMPLETADO</div>
                ) : prog.done > 0 ? (
                  <div style={{
                    background:phase.accent+"15", border:`1px solid ${phase.accent}44`, color:phase.accent,
                    fontSize:"11px", fontWeight:800, padding:"6px 10px", borderRadius:"3px",
                    letterSpacing:"1.5px", whiteSpace:"nowrap"
                  }}>● ACTIVO</div>
                ) : (
                  <div style={{ color:phase.accent, fontSize:"20px", fontWeight:800 }}>→</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ── WORKOUT ──────────────────────────────────────────────────────
function WorkoutView({ phase, week, day, completed, toggleExercise, onBack }) {
  const [openSections, setOpenSections] = useState(() => {
    const o = {};
    const firstNonEmpty = day.sections.find(s => s.items.length > 0);
    day.sections.forEach(s => { o[s.title] = s === firstNonEmpty; });
    return o;
  });
  const [showCompletedBanner, setShowCompletedBanner] = useState(true);
  const [justCompleted, setJustCompleted] = useState(false);

  const toggle = (title) => setOpenSections(prev => ({ ...prev, [title]: !prev[title] }));

  // Auto-close completed section and open next one
  const prevCompleted = React.useRef({});
  useEffect(() => {
    const nonEmpty = day.sections.filter(s => s.items.length > 0);
    const wasDayDone = isDayDone(day, prevCompleted.current);
    const isDayDoneNow = isDayDone(day, completed);
    // Detect just completed
    if (isDayDoneNow && !wasDayDone) {
      setJustCompleted(true);
      setShowCompletedBanner(true);
    }
    for (let i = 0; i < nonEmpty.length; i++) {
      const sec = nonEmpty[i];
      const secDone = sec.items.every((_, idx) => completed[exKey(day.id, sec.title, idx)]);
      const wasDone = sec.items.every((_, idx) => prevCompleted.current[exKey(day.id, sec.title, idx)]);
      if (secDone && !wasDone) {
        const next = nonEmpty[i + 1];
        setOpenSections(prev => ({
          ...prev,
          [sec.title]: false,
          ...(next ? { [next.title]: true } : {})
        }));
        break;
      }
    }
    prevCompleted.current = { ...completed };
  }, [completed]);

  const prog = dayProgress(day, completed);
  const done = isDayDone(day, completed);

  // Completed banner overlay
  if (done && showCompletedBanner) {
    return (
      <div className="fade-in" style={{
        minHeight:"100vh", background:"#080808", display:"flex", flexDirection:"column",
        alignItems:"center", justifyContent:"center", padding:"32px 24px", textAlign:"center"
      }}>
        {/* Animated checkmark */}
        <div style={{
          width:"80px", height:"80px", borderRadius:"50%",
          background:phase.accent+"22", border:`2px solid ${phase.accent}`,
          display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"32px"
        }}>
          <span style={{ fontSize:"36px", color:phase.accent }}>✓</span>
        </div>
        <div style={{
          fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"13px",
          letterSpacing:"4px", color:phase.accent, textTransform:"uppercase", marginBottom:"12px"
        }}>ENTRENAMIENTO</div>
        <div style={{
          fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
          fontSize:"clamp(48px,12vw,72px)", color:"#fff", letterSpacing:"-2px",
          lineHeight:0.9, marginBottom:"24px"
        }}>COMPLETADO</div>
        <div style={{
          fontSize:"15px", color:"#555", fontWeight:300, marginBottom:"48px"
        }}>{day.name} · {week.name}</div>
        <div style={{ display:"flex", flexDirection:"column", gap:"12px", width:"100%", maxWidth:"300px" }}>
          <button onClick={onBack} style={{
            background:phase.accent, color:"#fff", border:"none",
            padding:"18px 24px", borderRadius:"4px", cursor:"pointer",
            fontFamily:"'Barlow Condensed',sans-serif", fontWeight:800,
            fontSize:"18px", letterSpacing:"2px", textTransform:"uppercase"
          }}>← VOLVER A DÍAS</button>
          <button onClick={() => {
            setShowCompletedBanner(false);
            setOpenSections(prev => Object.keys(prev).reduce((a, k) => ({ ...a, [k]: false }), {}));
          }} style={{
            background:"transparent", color:"#555", border:"1px solid #333",
            padding:"14px 24px", borderRadius:"4px", cursor:"pointer",
            fontFamily:"'Barlow Condensed',sans-serif", fontWeight:600,
            fontSize:"14px", letterSpacing:"1px", textTransform:"uppercase"
          }}>VER EJERCICIOS</button>
        </div>
      </div>
    );
  }

  return (
    <div className="fade-in" style={{ minHeight:"100vh", padding:"20px 16px", maxWidth:"720px", margin:"0 auto" }}>
      <button className="btn-back" onClick={onBack} style={{ marginBottom:"24px", flexShrink:0 }}>← DÍAS</button>

      {/* Header */}
      <div style={{
        background:`linear-gradient(135deg, #111 0%, #0a0a0a 100%)`,
        border:`1px solid ${done ? phase.accent+"55" : "#1a1a1a"}`, borderTop:`3px solid ${phase.accent}`,
        borderRadius:"4px", padding:"28px 28px 24px", marginBottom:"24px"
      }}>
        <div style={{
          display:"flex", alignItems:"center", gap:"10px", marginBottom:"12px", flexWrap:"wrap"
        }}>
          <span style={{
            fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"11px",
            letterSpacing:"3px", color:phase.accent, textTransform:"uppercase"
          }}>{phase.name}</span>
          <span style={{ color:"#333" }}>·</span>
          <span style={{ fontSize:"12px", color:"#555", fontWeight:300 }}>{week.name}</span>
          {week.label === "Descarga" && <span className="deload-badge">Descarga</span>}
          {done && (
            <span style={{
              background:phase.accent, color:"#000", fontSize:"11px", fontWeight:800,
              padding:"3px 10px", borderRadius:"2px", letterSpacing:"1px"
            }}>✓ COMPLETADO</span>
          )}
        </div>
        <h2 style={{
          fontFamily:"'Barlow Condensed',sans-serif", fontWeight:900,
          fontSize:"clamp(28px,5vw,42px)", color:"#fff", letterSpacing:"-0.5px", marginBottom:"6px"
        }}>{day.name}</h2>
        <div style={{ fontSize:"14px", color:"#777", fontWeight:300, marginBottom: prog.total > 0 ? "16px" : 0 }}>{day.label}</div>
        {prog.total > 0 && (
          <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
            <div style={{ flex:1, height:"3px", background:"#1e1e1e", borderRadius:"2px" }}>
              <div style={{
                width:`${(prog.done/prog.total)*100}%`, height:"100%",
                background: done ? phase.accent : phase.accent+"bb",
                borderRadius:"2px", transition:"width 0.3s ease"
              }} />
            </div>
            <span style={{ fontSize:"12px", color: done ? phase.accent : "#666", fontWeight:600, whiteSpace:"nowrap" }}>
              {prog.done}/{prog.total} ejercicios
            </span>
          </div>
        )}
      </div>

      {/* Sections */}
      {day.sections.map((sec) => {
        const color = getSectionColor(sec.title);
        const isOpen = openSections[sec.title];
        const isEmpty = sec.items.length === 0;
        const secDone = !isEmpty && sec.items.every((_, i) => completed[exKey(day.id, sec.title, i)]);
        return (
          <div key={sec.title} style={{
            background:"#0e0e0e", border:`1px solid ${secDone ? color+"44" : "#1a1a1a"}`,
            borderLeft:`3px solid ${color}`, borderRadius:"4px", marginBottom:"10px",
            overflow:"hidden"
          }}>
            <div onClick={() => !isEmpty && toggle(sec.title)} style={{
              padding:"16px 20px", display:"flex", alignItems:"center",
              justifyContent:"space-between", cursor: isEmpty ? "default" : "pointer",
            }}>
              <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                <div style={{
                  fontFamily:"'Barlow Condensed',sans-serif", fontWeight:700, fontSize:"14px",
                  letterSpacing:"2px", color:isEmpty ? "#444" : (secDone ? color : color), textTransform:"uppercase"
                }}>{sec.title}</div>
                {secDone && <span style={{ color:color, fontSize:"13px", fontWeight:800 }}>✓</span>}
              </div>
              {!isEmpty && (
                <div style={{
                  color:"#444", fontSize:"12px", transition:"transform 0.2s",
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)"
                }}>▼</div>
              )}
              {isEmpty && (
                <div style={{ fontSize:"11px", color:"#333", letterSpacing:"1px" }}>INCLUIDO</div>
              )}
            </div>
            {isOpen && !isEmpty && (
              <div style={{ padding:"4px 20px 16px" }}>
                {sec.items.map((item, i) => {
                  const key = exKey(day.id, sec.title, i);
                  const checked = !!completed[key];
                  return (
                    <div key={i}
                      onClick={(e) => { e.stopPropagation(); toggleExercise(key); }}
                      className="exercise-item"
                      style={{
                        borderLeftColor: checked ? color : color + "55",
                        display:"flex", alignItems:"flex-start", gap:"12px",
                        cursor:"pointer", opacity: checked ? 0.6 : 1,
                        transition:"opacity 0.2s"
                      }}>
                      <div style={{
                        flexShrink:0, marginTop:"2px",
                        width:"18px", height:"18px", borderRadius:"3px",
                        border:`2px solid ${checked ? color : "#333"}`,
                        background: checked ? color : "transparent",
                        display:"flex", alignItems:"center", justifyContent:"center",
                        transition:"all 0.15s"
                      }}>
                        {checked && <span style={{ color:"#000", fontSize:"11px", fontWeight:900, lineHeight:1 }}>✓</span>}
                      </div>
                      <span style={{ textDecoration: checked ? "line-through" : "none", fontFamily:"'Inter', sans-serif", fontSize:"14px", fontWeight:400, color: checked ? "#888" : "#e8e8e8", lineHeight:1.65, letterSpacing:"0.15px" }}>{item}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}

      <div style={{ height:"60px" }} />
    </div>
  );
}